
/* TACOVICI theme.js — shared, every block guarded */
document.documentElement.classList.add('js');
function frameFail(img){var f=img.closest('.frame')||img.closest('.amb-stage');if(f)f.classList.add('no-img');else img.style.visibility='hidden';}
function discFail(img){var d=img.closest('.mirror-disc');if(d)d.classList.add('no-img');}
function cardFail(img){var c=img.closest('.card');if(c)c.classList.add('no-img');}
function pdpFail(img){var d=img.closest('.pdp-main');if(d)d.classList.add('no-img');}
function brandFallback(img){var b=img.closest('.brand')||img.closest('.foot-brand');if(b)b.classList.add('no-logo');}
function pressFail(img){var p=img.closest('.press-logo');if(p)p.classList.add('no-logo');}
function subscribe(form){form.classList.add('done');form.innerHTML='<span class="sub-thanks">Thanks — check your inbox to confirm. ✦</span>';return false;}
/* parse an inch measurement ("48″"/"48\""/"48 in") from a label; falls back to a lone 10–120 number. Shared by the PDP buy-box fit line + the Ask-an-expert fit verdict. */
function tacParseInches(src){src=src||'';var m=src.match(/(\d+(?:\.\d+)?)\s*(?:″|"|in\b|inch|inches)/i);if(!m){var a=src.match(/\b(\d{2,3}(?:\.\d+)?)\b/);if(a&&+a[1]>=10&&+a[1]<=120)m=a;}return m?parseFloat(m[1]):0;}
/* Save the optional delivery phone as a cart attribute. Shared by the drawer's #cdPhone (debounced on
   input) and the page cart's #cartPhone (on blur) — the page-cart field is a real `attributes[…]` input
   inside {% form 'cart' %}, so Update/Checkout submits it with no JS, BUT the express wallet buttons
   (Shop Pay, PayPal) build their checkout from the SAVED cart, not from unsubmitted form inputs. Without
   this, a shopper who types a number and taps Shop Pay loses it silently. Blank clears the attribute. */
function tacSaveDeliveryPhone(v){
  return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify({attributes:{'Delivery phone':String(v==null?'':v).trim()}})}).catch(function(){});
}
window.tacSaveDeliveryPhone=tacSaveDeliveryPhone;
document.addEventListener('DOMContentLoaded',function(){
  var pp=document.getElementById('cartPhone');if(!pp)return;
  var last=pp.value;
  pp.addEventListener('change',function(){if(pp.value!==last){last=pp.value;tacSaveDeliveryPhone(pp.value);}});
});

/* Shared vanity-width store. sessionStorage = fast same-tab value; localStorage (30-day TTL) = cross-session
   memory so a shopper who measured last week sees fit answers on return. Every fit tool writes via
   tacWriteVanityW and reads via tacReadVanityW (which promotes a fresh local value back into the session).
   Defined in theme.js (loaded on every page) so collection/search card badges resolve it without theme-pdp.js. */
var TAC_VW_TTL=2592000000; /* 30 days */
/* The width also carries WHERE it came from, because not every source is a measurement:
     'pdp' | 'finder' | 'studio' | 'calc'  — the shopper set a number themselves (exact)
     'quiz'                                — INFERRED from a room choice (powder/single/double → 22/28/48)
     'assumed'                             — the pre-set slider default, accepted without being moved
   Surfaces that phrase the width back at the shopper ("your 48″ vanity") check tacReadVanityWSrc and
   soften to "a typical 48″ vanity" for the estimated sources. A legacy value with no tag reads as
   exact — old widths shouldn't be retroactively demoted. */
function tacWriteVanityW(v,src){v=parseInt(v,10);if(!(v>0))return;src=src||'';
  try{sessionStorage.setItem('tacVanityW',String(v));
    if(src)sessionStorage.setItem('tacVanityWSrc',src);else sessionStorage.removeItem('tacVanityWSrc');}catch(_){}
  try{localStorage.setItem('tacVanityWL',JSON.stringify({v:v,t:Date.now(),s:src}));}catch(_){}}
function tacReadVanityW(){
  var v=0;try{v=parseInt(sessionStorage.getItem('tacVanityW'),10);}catch(_){}
  if(v>0)return v;
  try{var raw=localStorage.getItem('tacVanityWL');if(raw){var o=JSON.parse(raw);
    if(o&&o.v>0&&o.t&&(Date.now()-o.t)<TAC_VW_TTL){try{sessionStorage.setItem('tacVanityW',String(o.v));
      if(o.s)sessionStorage.setItem('tacVanityWSrc',o.s);}catch(_){}return parseInt(o.v,10);}
    try{localStorage.removeItem('tacVanityWL');}catch(_){}}}catch(_){}
  return 0;}
/* Call AFTER tacReadVanityW (which promotes the local value + its tag into the session). */
function tacReadVanityWSrc(){var s='';try{s=sessionStorage.getItem('tacVanityWSrc')||'';}catch(_){}return s;}
/* Age of the remembered width in ms, or -1 when unknown (session-only / legacy entry with no stamp). */
function tacVanityWAge(){
  try{var raw=localStorage.getItem('tacVanityWL');if(raw){var o=JSON.parse(raw);
    if(o&&o.t)return Math.max(0,Date.now()-o.t);}}catch(_){}
  return -1;}
/* Is the remembered width a guess rather than something the shopper stated? Two ways to be one:
   it was inferred/assumed to begin with, or it's simply old. We remember for 30 days, which is right
   for continuity, but a width can outlive the bathroom it described — someone who measured, renovated
   and came back deserves a prompt to re-check, not a month-old number quoted as fact. Unknown age
   never demotes a width. */
var TAC_VW_STALE=1209600000; /* 14 days */
var TAC_VW_DAY=86400000;     /* older than this = a previous visit, worth saying so (still trusted) */
function tacVanityWIsStale(){var age=tacVanityWAge();return age>TAC_VW_STALE;}
/* THE one place that decides whether a remembered width may be called "yours". Returns the possessive
   fragment for "…N″ vanity" — every surface that phrases the width back at a shopper uses it:
   buy-box fit card, sticky mobile chip, browse-time card badges, PDP passive fit line.
   It exists because this rule was written four separate times and quietly missed on two of them, so a
   quiz guess read as a measurement on collection pages for two rounds. Add a fifth surface? Call this. */
function tacVanityPhrase(){return tacVanityWIsEstimate()?'a typical ':'your ';}
function tacVanityWIsEstimate(){
  var s=tacReadVanityWSrc();return s==='quiz'||s==='assumed'||tacVanityWIsStale();}
/* Forget the remembered width (shopper resets a stale/mistyped vanity). Clears both stores + the order
   property + the width fields, then broadcasts tac:vanity so the buy-box check, sticky chip, card badges
   and carousel marker all fall back to their no-width state. */
function tacClearVanityW(){
  try{sessionStorage.removeItem('tacVanityW');sessionStorage.removeItem('tacVanityWSrc');}catch(_){}
  try{localStorage.removeItem('tacVanityWL');}catch(_){}
  var p=document.getElementById('pdpVanityProp');if(p){p.value='';p.disabled=true;}
  var fp=document.getElementById('pdpFitProp');if(fp){fp.value='';fp.disabled=true;}
  if(window.tacVWSetAll)window.tacVWSetAll(window.TAC_VW_DEF||48);   /* sliders can't be "empty" — park them back on the default */
  var ew=document.querySelector('#pdpExpert .pdp-expert-win');if(ew)ew.value='';
  if(window.tacFitlineRefresh)window.tacFitlineRefresh();
  try{document.dispatchEvent(new CustomEvent('tac:vanity',{detail:{w:0}}));}catch(_){}
}
window.tacReadVanityW=tacReadVanityW;window.tacWriteVanityW=tacWriteVanityW;window.tacClearVanityW=tacClearVanityW;
window.tacReadVanityWSrc=tacReadVanityWSrc;window.tacVanityWIsEstimate=tacVanityWIsEstimate;
window.tacVanityWAge=tacVanityWAge;window.TAC_VW_DAY=TAC_VW_DAY;window.tacVanityWIsStale=tacVanityWIsStale;window.tacVanityPhrase=tacVanityPhrase;

/* ---- Vanity-width slider — ONE control, two mounts: the PDP buy-box fit check (#pdpFit, built by
   theme-pdp.js from tacVWMarkup) and the vanity size calculator (server-rendered twin in
   sections/vanity-size-calculator.liquid — change both together). Shoppers estimate this number, so
   it's a drag, never a typed field.
   tacVWSet is the single writer: value ⇄ big readout ⇄ track fill ⇄ quick-pick state. It writes
   --vwpct and CSS paints the filled portion of the track from it (CLAUDE.md §5 contract) — no inline
   style beyond that one variable. Wiring is delegated at document level so a JS-injected instance
   (the buy box re-renders itself) needs no mount step. ---- */
var VW_MIN=18,VW_MAX=120,VW_DEF=48,VW_PRESETS=[30,36,48,60,72];
function tacVWMarkup(id,label){
  var v=arguments.length>2&&arguments[2]?arguments[2]:VW_DEF;
  return '<div class="vw"><div class="vw-read"><span class="vw-read-l">'+label+'</span><output class="vw-val" for="'+id+'">'+v+'″</output></div>'
    +'<input type="range" class="vw-range" id="'+id+'" min="'+VW_MIN+'" max="'+VW_MAX+'" step="1" value="'+v+'" aria-label="'+label+' in inches" aria-valuetext="'+v+' inches">'
    +'<div class="vw-scale"><span>'+VW_MIN+'″</span><span>'+VW_MAX+'″</span></div>'
    +'<div class="vw-presets">'+VW_PRESETS.map(function(p){return '<button type="button" class="vw-preset" data-vw-preset="'+p+'" aria-pressed="'+(p===v?'true':'false')+'">'+p+'″</button>';}).join('')+'</div></div>';
}
function tacVWSet(rg,n){
  if(!rg)return 0;
  n=parseInt(n,10);if(isNaN(n))n=VW_DEF;
  n=Math.min(VW_MAX,Math.max(VW_MIN,n));
  rg.value=n;rg.setAttribute('aria-valuetext',n+' inches');
  var root=rg.closest('.vw')||rg.parentNode;if(!root)return n;
  var out=root.querySelector('.vw-val');if(out)out.textContent=n+'″';
  root.style.setProperty('--vwpct',((n-VW_MIN)/(VW_MAX-VW_MIN)*100).toFixed(1)+'%');
  Array.prototype.forEach.call(root.querySelectorAll('[data-vw-preset]'),function(b){
    var on=parseInt(b.getAttribute('data-vw-preset'),10)===n;
    b.classList.toggle('is-on',on);b.setAttribute('aria-pressed',on?'true':'false');});
  return n;
}
/* Point every mounted slider at the same width — keeps the buy-box check and the below-fold
   calculator quoting one number after either one is used (via setVanityProp in theme-pdp.js). */
function tacVWSetAll(n){Array.prototype.forEach.call(document.querySelectorAll('.vw-range'),function(rg){tacVWSet(rg,n);});}
document.addEventListener('input',function(e){var rg=e.target.closest&&e.target.closest('.vw-range');if(rg)tacVWSet(rg,rg.value);});
document.addEventListener('click',function(e){
  var p=e.target.closest&&e.target.closest('[data-vw-preset]');if(!p)return;
  var root=p.closest('.vw'),rg=root&&root.querySelector('.vw-range');if(!rg)return;
  tacVWSet(rg,p.getAttribute('data-vw-preset'));
  try{rg.dispatchEvent(new Event('change',{bubbles:true}));}catch(_){}   /* consumers treat a pick like a settled drag */
});
window.tacVWMarkup=tacVWMarkup;window.tacVWSet=tacVWSet;window.tacVWSetAll=tacVWSetAll;window.TAC_VW_DEF=VW_DEF;
/* Publish a width the shopper just gave us ANYWHERE outside the PDP buy box (size finder, quiz):
   remember it, move every other mounted slider onto it, and broadcast so card fit badges + the
   sticky chip re-stamp without a page load. The PDP has its own richer twin (tacFit.setVanityProp
   in theme-pdp.js) that additionally writes the order line-item properties. */
function tacPublishVanityW(v,src){
  v=parseInt(v,10);if(!(v>0))return;
  tacWriteVanityW(v,src);tacVWSetAll(v);
  try{document.dispatchEvent(new CustomEvent('tac:vanity',{detail:{w:v,src:src||''}}));}catch(_){}
}
window.tacPublishVanityW=tacPublishVanityW;
/* JS twin of snippets/line-prop.liquid — the cart drawer builds its lines client-side from /cart.js,
   so it needs the same shopper-facing wording the cart page renders server-side. Returns '' for a
   property that shouldn't be printed. CHANGE BOTH FILES TOGETHER. */
function tacLineProp(key,value){
  key=String(key==null?'':key);value=String(value==null?'':value);
  if(!value.trim()||key.charAt(0)==='_'||key==='Item code')return '';
  /* two replacements, FIRST-occurrence only — the Liquid twin is `replace: ' inches' | replace_first: ' in'`,
     and a global replace would maul a value that happened to contain " in " twice */
  if(key==='Vanity width')return 'Your vanity: '+value.replace(' inches','″').replace(' in','″');
  if(key==='Fit')return value;                 /* already a sentence — "Fit:" would just stutter */
  return key+': '+value;
}
/* JS twin of snippets/sku-code.liquid — strips the internal "JT" prefix (plus any separator left
   behind) off a raw SKU so JS-built surfaces (cart drawer, shared lists) print the same item code the
   Liquid ones do. A non-JT SKU passes through; blank in → '' out. Change both files together. */
function tacItemCode(s){s=String(s||'').trim();if(!s)return '';
  if(s.slice(0,2).toUpperCase()==='JT'){s=s.slice(2);if(/^[-_ ]/.test(s))s=s.slice(1);}
  return s.trim();}
/* build a product card from a stored payload {h,u,t,img,p,c?,vid?,one?,ty?}; mirrors the Liquid product-card snippet so the recently-viewed rail + saved panel match the real grid. Single-variant items get a quick-add (data-qadd, handled by the global delegate); others link out. */
function tacBuildCard(it){
  it=it||{};var url=it.u||('/products/'+(it.h||''));
  var art=document.createElement('article');art.className='card';
  if(it.sz)art.setAttribute('data-sizes',it.sz);   /* carry size widths so the browse-time fit badge reaches JS-built rail cards */
  var a=document.createElement('a');a.className='card-link';a.href=url;a.setAttribute('aria-label',it.t||'');art.appendChild(a);
  var ph=document.createElement('div');ph.className='ph';
  if(it.c){var tg=document.createElement('span');tg.className='tagk';tg.textContent='Sale';ph.appendChild(tg);}
  var img=document.createElement('img');img.src=it.img||'';img.alt=it.t||'';img.loading='lazy';img.width=600;img.height=750;img.onerror=function(){if(window.cardFail)window.cardFail(this);};ph.appendChild(img);
  /* hover second frame — same .card-img-alt layer (and CSS gates) as the Liquid card: hover-capable pointers cross-fade, touch never fetches it (display:none + lazy), a failed load removes itself */
  if(it.i2){var i2=document.createElement('img');i2.className='card-img-alt';i2.src=it.i2;i2.alt='';i2.setAttribute('aria-hidden','true');i2.loading='lazy';i2.width=600;i2.height=750;i2.onerror=function(){this.remove();};ph.appendChild(i2);}
  var fb=document.createElement('div');fb.className='fb';fb.innerHTML='<div class="ring"></div>';ph.appendChild(fb);art.appendChild(ph);
  var body=document.createElement('div');body.className='body';
  if(it.ty){var sh=document.createElement('span');sh.className='shape';sh.textContent=it.ty;body.appendChild(sh);}
  var h3=document.createElement('h3');h3.textContent=it.t||'';body.appendChild(h3);
  /* NB: the payload's `sku` is deliberately NOT printed here — a shortlist is a comparison surface, not a
     support one. It still travels in the payload because the card's quick-add sends it as the cart line's
     Item code property (see the [data-qadd] delegate). */
  var foot=document.createElement('div');foot.className='foot';
  var pr=document.createElement('span');pr.className='price';
  if(it.c){var s=document.createElement('s');s.textContent=it.c;pr.appendChild(s);pr.appendChild(document.createTextNode(' '));}
  pr.appendChild(document.createTextNode(it.p||''));foot.appendChild(pr);
  if(it.one&&it.vid){var add=document.createElement('button');add.type='button';add.className='add qadd';add.setAttribute('data-qadd',it.vid);if(it.sku)add.setAttribute('data-sku',it.sku);add.setAttribute('aria-label','Add '+(it.t||'')+' to cart');add.textContent='Add';foot.appendChild(add);}
  else{var view=document.createElement('a');view.className='add';view.href=url;view.textContent='View';foot.appendChild(view);}
  body.appendChild(foot);
  /* Compare toggle — mirrors the Liquid card so saved/recently-viewed mirrors reach the tray.
     Carries whatever the stored payload has (specs may be absent → '—' in the table).
     Honors window.TAC_CARDCFG.compare (Theme settings → Product cards), default-on when unset. */
  if(!window.TAC_CARDCFG||window.TAC_CARDCFG.compare!==false){
    var cmp=document.createElement('button');cmp.type='button';cmp.className='card-compare';cmp.setAttribute('data-compare-add','');cmp.setAttribute('aria-pressed','false');
    cmp.setAttribute('data-h',it.h||'');cmp.setAttribute('data-u',url);cmp.setAttribute('data-t',it.t||'');cmp.setAttribute('data-img',it.img||'');cmp.setAttribute('data-p',it.p||'');if(it.pc!=null)cmp.setAttribute('data-pc',it.pc);cmp.setAttribute('data-ty',it.ty||'');if(it.vid)cmp.setAttribute('data-vid',it.vid);if(it.one!=null)cmp.setAttribute('data-one',it.one);if(it.dim)cmp.setAttribute('data-dim',it.dim);if(it.cct)cmp.setAttribute('data-cct',it.cct);if(it.lum)cmp.setAttribute('data-lum',it.lum);if(it.mount)cmp.setAttribute('data-mount',it.mount);if(it.feat)cmp.setAttribute('data-feat',it.feat);
    cmp.textContent='Compare';body.appendChild(cmp);
  }
  art.appendChild(body);
  if(window.tacCompareSync)window.tacCompareSync();
  return art;
}
/* shared save-for-later store (localStorage 'tacSaved', full card payloads) — used by the PDP heart, every product card, and the saved panel; changes fire a 'tac:saved' event so all save UIs stay in sync */
function tacSavedGet(){try{return JSON.parse(localStorage.getItem('tacSaved'))||[];}catch(_){return [];}}
function tacSavedKeyOf(x){return (typeof x==='string')?x:(x&&x.h);}
function tacSavedHas(h){if(!h)return false;var a=tacSavedGet();for(var i=0;i<a.length;i++){if(tacSavedKeyOf(a[i])===h)return true;}return false;}
function tacSavedToggle(o){if(!o||!o.h)return;var a=tacSavedGet(),f=-1;for(var i=0;i<a.length;i++){if(tacSavedKeyOf(a[i])===o.h){f=i;break;}}if(f>-1)a.splice(f,1);else a.unshift(o);try{localStorage.setItem('tacSaved',JSON.stringify(a));}catch(_){}try{document.dispatchEvent(new CustomEvent('tac:saved'));}catch(_){}}
window.tacSavedGet=tacSavedGet;window.tacSavedHas=tacSavedHas;window.tacSavedToggle=tacSavedToggle;

/* since-you-saved live flags — shared by the Saved page, shared lists, and the PDP saved panel.
   tacSavedRefresh(items,onFlag,onAll) fetches /products/{handle}.js once per handle per page load
   (cache below): the saved VARIANT wins while it's still listed, else the product; a price drop is
   computed ONLY against the exact saved variant (product min-price would false-flag). onFlag fires
   as flagged states land, onAll once every fetch this call started has settled. tacSavedFlag(el)
   then badges any .pdp-saved-cell[data-h] inside el from the cache: sold-out → .saved-oos badge +
   ?variant=#restock deep link (PDP back-in-stock capture); in-stock drop → green .saved-drop badge
   + live price painted over the stale stored one (display only). 404s/failures stay unflagged. */
var tacSavedLiveCache={},tacSavedLivePending={};
function tacSavedFlag(el){
  if(!el)return;
  function fmt(c){return window.tacMoney?tacMoney(c):'$'+((c||0)/100).toFixed(2);}
  Array.prototype.forEach.call(el.querySelectorAll('.pdp-saved-cell[data-h]'),function(cell){
    var info=tacSavedLiveCache[cell.getAttribute('data-h')];if(!info)return;
    var ph=cell.querySelector('.ph'),lk=cell.querySelector('.card-link');
    /* the badges are sighted-only from the focused card link's perspective — suffix its aria-label
       so assistive tech hears the state too (idempotent across repaints) */
    function mark(suffix){if(!lk)return;var al=lk.getAttribute('aria-label')||'';
      if(al.indexOf(suffix)<0)lk.setAttribute('aria-label',al+' '+suffix);}
    if(info.out){
      if(ph&&!ph.querySelector('.saved-oos')){var b=document.createElement('span');b.className='saved-oos';b.textContent='Sold out — tap for restock alerts';ph.appendChild(b);}
      if(lk&&lk.href.indexOf('#restock')<0){var href=lk.href;
        if(info.vid&&href.indexOf('variant=')<0)href+=(href.indexOf('?')<0?'?':'&')+'variant='+info.vid;
        lk.href=href+'#restock';}   /* hash intent: theme-pdp.js scrolls the PDP to the back-in-stock form */
      mark('— sold out, opens restock alerts');
      cell.classList.add('is-oos');
    }else if(info.drop>0){
      if(ph&&!ph.querySelector('.saved-drop')){var d=document.createElement('span');d.className='saved-drop';d.textContent='Price dropped '+fmt(info.drop);ph.appendChild(d);}
      var pr=cell.querySelector('.price');if(pr&&info.now)pr.textContent=fmt(info.now);
      mark('— price dropped to '+fmt(info.now));
      cell.classList.add('is-drop');
    }
  });
}
function tacSavedRefresh(items,onFlag,onAll){
  /* onAll waits on fetches ANOTHER caller started too (tacSavedLivePending) — otherwise a second
     caller in the same tick would read the {out:false} placeholders as settled state */
  var waits=[];
  (items||[]).forEach(function(x){
    var o=(typeof x==='string')?{h:x}:(x||{});
    if(!o.h)return;
    if(tacSavedLivePending[o.h]){waits.push(tacSavedLivePending[o.h]);return;}
    if(tacSavedLiveCache[o.h])return;
    tacSavedLiveCache[o.h]={out:false,drop:0};
    var pr=fetch('/products/'+o.h+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.ok?r.json():null;}).then(function(p){
      if(p){var out,vid=null,drop=0,now=0;
        var v=(p.variants||[]).filter(function(y){return String(y.id)===String(o.vid);})[0];
        if(v){out=!v.available;vid=v.id;
          var was=Number(o.pc)||0;
          if(!out&&was>0&&v.price<was){drop=was-v.price;now=v.price;}
        }else{out=!p.available;}
        tacSavedLiveCache[o.h]={out:out,vid:vid,drop:drop,now:now};
        if((out||drop)&&onFlag)onFlag();}
    }).catch(function(){}).then(function(){delete tacSavedLivePending[o.h];});
    tacSavedLivePending[o.h]=pr;waits.push(pr);
  });
  if(onAll){if(waits.length)Promise.all(waits).then(function(){onAll();});else onAll();}
}
window.tacSavedFlag=tacSavedFlag;window.tacSavedRefresh=tacSavedRefresh;
/* Crawler-protected contact links — the email/phone ships REVERSED in the markup
   (see snippets/contact-cloak.liquid) so harvest bots never see a real address.
   Reassemble the true value at runtime: set the mailto:/tel: href and restore
   normal-order, copy-able text. No-op (and the CSS bidi fallback stands) if absent. */
document.addEventListener('DOMContentLoaded',function(){
  var cloaks=document.querySelectorAll('a.cloak[data-cloak]');
  for(var ci=0;ci<cloaks.length;ci++){
    var a=cloaks[ci],real=(a.getAttribute('data-cloak')||'').split('').reverse().join('');
    if(!real)continue;
    if(a.getAttribute('data-cloak-type')==='tel')a.href='tel:'+real.replace(/[^+\d]/g,'');
    else a.href='mailto:'+real;
    var txt=a.querySelector('.cloak-txt');
    if(txt){txt.textContent=real;txt.classList.add('cloak-on');}
  }
});
document.addEventListener('DOMContentLoaded',function(){
  var root=document.documentElement;
  /* honour OS "reduce motion" everywhere, not just the hero — live query so a mid-session toggle is respected */
  var RMQ=matchMedia('(prefers-reduced-motion:reduce)');function RM(){return RMQ.matches;}
  /* random everyday bathroom scene each load — each scene carries its own mirror coords */
  var scbg=document.querySelector('.hero-scene .scene-bg');
  if(scbg && !window.__tacScenePicked && window.TAC_SCENES && window.TAC_SCENES.length){var SC=window.TAC_SCENES;
    var s=SC[Math.floor(Math.random()*SC.length)];if(s.s){scbg.srcset=s.s;scbg.sizes='100vw';}scbg.src=s.i;root.style.setProperty('--mx',s.x+'%');root.style.setProperty('--my',s.y+'%');root.style.setProperty('--md',s.d+'%');}
  var header=document.getElementById('siteHeader'),mcta=document.getElementById('mcta'),toTop=document.getElementById('toTop'),lastY=0;
  function onScroll(){var y=scrollY;if(header){header.classList.toggle('scrolled',y>10);header.classList.toggle('site--hidden',y>140&&y>lastY);}if(mcta)mcta.classList.toggle('show',y>520);if(toTop)toTop.classList.toggle('show',y>600);lastY=y;}
  addEventListener('scroll',onScroll,{passive:true});onScroll();
  /* --mcta-h: the sticky bar's live height while shown (0px while hidden or display:none). The welcome slide-in
     and the expert nudge sit `bottom: gap + --mcta-h`, so neither ever lands on Add to cart. Measured, not
     hardcoded: the bar is one row on phones but two (fit verdict strip) on tablet/desktop, and the old fixed
     86/96px offsets overlapped the two-row bar by ~20-90px. Re-measured on show/hide + any resize of the bar. */
  if(mcta){var mctaH=-1,mctaOn=null;
    var syncMctaH=function(){var h=mcta.classList.contains('show')?mcta.offsetHeight:0;if(h!==mctaH){mctaH=h;root.style.setProperty('--mcta-h',h+'px');}};
    addEventListener('scroll',function(){var on=mcta.classList.contains('show');if(on!==mctaOn){mctaOn=on;syncMctaH();}},{passive:true});
    if('ResizeObserver' in window)new ResizeObserver(syncMctaH).observe(mcta);
    syncMctaH();}
  /* Page-hero shrink-on-scroll: the inner-page banner (about/FAQ/size-guide/collection)
     reads tall above the body, so collapse its band as the shopper scrolls past — JS writes
     --hero-collapse (0 at top → 1 once scrolled in), CSS slims the band's padding. The home
     hero is intentionally excluded (it has no .page-hero). Held at 0 under reduced motion. */
  (function(){var ph=document.querySelector('.page-hero');if(!ph)return;
    var range=Math.min(innerHeight*0.42,300),tick=false;
    function setHeroCollapse(){tick=false;var raw=Math.min(1,Math.max(0,scrollY/range));
      root.style.setProperty('--hero-collapse',(RM()?0:raw).toFixed(3));
      /* Slim orientation bar shows once the band is mostly gone. Tied to RAW scroll (not the
         motion-gated value) so reduced-motion visitors still get the cue — CSS gives them a
         plain fade instead of the slide. */
      root.classList.toggle('ph-collapsed',scrollY>range*0.55);}
    addEventListener('scroll',function(){if(!tick){tick=true;requestAnimationFrame(setHeroCollapse);}},{passive:true});setHeroCollapse();})();
  if(toTop)toTop.addEventListener('click',function(){window.scrollTo({top:0,behavior:RM()?'auto':'smooth'});});
  (function(){var foot=document.querySelector('footer.site');if(!toTop||!foot||!('IntersectionObserver' in window))return;
    new IntersectionObserver(function(es){toTop.classList.toggle('near-foot',es[0].isIntersecting);}).observe(foot);})();
  function badgeBump(el){if(el&&!RM())el.animate([{transform:'scale(1.6)'},{transform:'scale(1)'}],{duration:300,easing:'ease'});}
  window.bumpCart=function(){var el=document.getElementById('cartCount');if(!el)return;el.textContent=(+el.textContent||0)+1;badgeBump(el);};
  /* set the cart badge to the REAL line-item count after an AJAX add (qty-aware); falls back to bumpCart on failure */
  window.refreshCartCount=function(){return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){var el=document.getElementById('cartCount');if(el&&typeof c.item_count==='number'){el.textContent=c.item_count;badgeBump(el);}return c;}).catch(function(){if(window.bumpCart)window.bumpCart();});};
  /* cart URL from the header cart pill (respects routes.cart_url / market prefixes); falls back to /cart */
  window.tacCartUrl=function(){var c=document.getElementById('cartCount'),a=c&&c.closest?c.closest('a'):null;return (a&&a.getAttribute('href'))||'/cart';};
  /* brief auto-dismissing confirmation toast; optional href adds a tappable "View cart" link (CSS gates the slide under reduced-motion) */
  window.toast=function(msg,href){var t=document.getElementById('tacToast');
    if(!t){t=document.createElement('div');t.id='tacToast';t.className='toast';t.setAttribute('role','status');t.setAttribute('aria-live','polite');
      var arm=function(){clearTimeout(window._toastT);window._toastT=setTimeout(function(){t.classList.remove('show');},2600);};
      var hold=function(){clearTimeout(window._toastT);};                    /* pause dismiss while the shopper is reaching for the link */
      t.addEventListener('mouseenter',hold);t.addEventListener('focusin',hold);
      t.addEventListener('mouseleave',arm);t.addEventListener('focusout',arm);
      t._arm=arm;document.body.appendChild(t);}
    t.innerHTML='';var m=document.createElement('span');m.className='toast-msg';m.textContent=msg;t.appendChild(m);
    if(href){var a=document.createElement('a');a.className='toast-link';a.href=href;a.textContent='View cart';t.appendChild(a);}
    requestAnimationFrame(function(){t.classList.add('show');});t._arm();};
  var drawerLast=null;
  function drawerFocusables(d){return Array.prototype.filter.call(d.querySelectorAll('a,button,input,[tabindex]'),function(n){
    if(n.disabled||n.offsetParent===null)return false;
    var sub=n.closest('.drawer-sub');if(sub){var g=n.closest('.drawer-group');if(g&&!g.classList.contains('open'))return false;}
    return true;});}
  window.toggleDrawer=function(open){var d=document.getElementById('drawer');if(!d)return;d.classList.toggle('open',open);document.body.style.overflow=open?'hidden':'';
    var burger=document.querySelector('.burger');if(burger)burger.setAttribute('aria-expanded',String(!!open));
    if(open){d.removeAttribute('inert');d.removeAttribute('aria-hidden');
      /* expand any group server-rendered open (the active branch) now that the drawer is visible — scrollHeight is 0 while display:none, so this must run on open */
      d.querySelectorAll('.drawer-group.open').forEach(function(g){var p=g.querySelector('.drawer-sub');if(p)p.style.maxHeight=p.scrollHeight+'px';});
      drawerLast=document.activeElement;var f=drawerFocusables(d);if(f.length)f[0].focus();}
    else{d.querySelectorAll('.drawer-group.open').forEach(function(g){g.classList.remove('open');var p=g.querySelector('.drawer-sub');if(p)p.style.maxHeight='0';var b=g.querySelector('.drawer-sub-toggle');if(b)b.setAttribute('aria-expanded','false');});
      var back=(drawerLast&&drawerLast.focus)?drawerLast:burger;if(back)back.focus();d.setAttribute('inert','');d.setAttribute('aria-hidden','true');}};
  (function(){var d=document.getElementById('drawer');if(!d)return;
    d.addEventListener('keydown',function(e){
      if(e.key==='Escape'){window.toggleDrawer(false);return;}
      if(e.key!=='Tab')return;var f=drawerFocusables(d);if(!f.length)return;var first=f[0],last=f[f.length-1];
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}});})();
  /* Normalises the slider's REAL range (3000-6000K, the factory-manual spec) to 0..1. Narrowed from
     2700-6500 on 2026-08-10 — the mirrors never offered that span. Slider min/max in
     sections/hero-spotlight.liquid must match this divisor or every colour mis-maps (§5). */
  function krgb(k){var t=(k-3000)/3000,w=[255,196,128],c=[206,228,255];return [Math.round(w[0]+(c[0]-w[0])*t),Math.round(w[1]+(c[1]-w[1])*t),Math.round(w[2]+(c[2]-w[2])*t)];}
  function lerp(a,b,t){return Math.round(a+(b-a)*t);}
  var kel=document.getElementById('kelvin'),kelVal=document.getElementById('kelvinVal'),kelMode=document.getElementById('kelvinMode'),
      bright=document.getElementById('bright'),brightVal=document.getElementById('brightVal');
  function doApplyLight(){
    var k=kel?+kel.value:4000, n=4000, A=krgb(k), rgb=A.join(',');   /* n = the real neutral preset */
    root.style.setProperty('--led','rgb('+rgb+')'); if(kelVal)kelVal.textContent=k+'K';
    var warm=Math.max(0,(n-k)/1000),cool=Math.max(0,(k-n)/2000),it=Math.max(warm,cool*0.85);
    var b=bright?(+bright.value/100):1, gb=0.30+0.70*b;   /* glow floored so the LED always reads "on", dims the halo */
    root.style.setProperty('--glowcol','rgba('+rgb+','+((0.86+0.12*it)*gb).toFixed(3)+')');
    root.style.setProperty('--glowcol2','rgba('+rgb+','+((0.60+0.30*it)*gb).toFixed(3)+')');
    root.style.setProperty('--glowcol3','rgba('+rgb+','+((0.34+0.30*it)*gb).toFixed(3)+')');
    /* the lit LED edge stays a LIGHT tint of the colour (a dimmed LED is still light, never a dark frame) */
    var wmix=0.30+0.18*b, bc=[lerp(A[0],255,wmix),lerp(A[1],255,wmix),lerp(A[2],255,wmix)];
    root.style.setProperty('--ledstrip','rgb('+bc.join(',')+')');
    root.style.setProperty('--scene-sat',(1+0.16*warm-0.05*cool).toFixed(3));
    root.style.setProperty('--scene-bri',(1+0.05*warm+0.025*cool).toFixed(3));
    /* name the band AND why it matters, so even free-dragging teaches the benefit */
    var km=k<3300?['Warm white','relaxing']:(k<5000?['Soft white','everyday']:['Daylight','makeup-accurate']);
    if(kelMode)kelMode.innerHTML=km[0]+' <i class="lp-cue">· '+km[1]+'</i>';
    if(brightVal)brightVal.textContent=Math.round(b*100)+'%';
  }
  /* Throttle slider-driven relights to one per frame: the kelvin/brightness inputs fire many events
     per drag and each relight writes 8 custom properties on :root (repainting the hero). Coalescing to
     rAF keeps the main thread free during a drag (INP). Initial + preset relights stay synchronous. */
  var _liRAF=false;
  function applyLight(){if(_liRAF)return;_liRAF=true;requestAnimationFrame(function(){_liRAF=false;doApplyLight();});}
  if(kel)kel.addEventListener('input',applyLight);
  if(bright)bright.addEventListener('input',applyLight);
  if(kel||bright)doApplyLight();
  /* one-tap light presets — set the temperature slider + re-light, and keep the active chip in sync as the slider moves */
  var lpPresets=document.querySelectorAll('.lp-preset');
  if(kel&&lpPresets.length){
    function syncPresets(){var k=+kel.value;Array.prototype.forEach.call(lpPresets,function(p){var on=parseInt(p.getAttribute('data-k'),10)===k;p.classList.toggle('active',on);p.setAttribute('aria-pressed',on?'true':'false');});}
    Array.prototype.forEach.call(lpPresets,function(p){p.addEventListener('click',function(){kel.value=p.getAttribute('data-k');doApplyLight();syncPresets();});});
    kel.addEventListener('input',syncPresets);
    syncPresets();
  }
  var baR=document.getElementById('baRange'),baA=document.getElementById('baAfter'),baH=document.getElementById('baHandle');
  if(baR){
    function ab(){var v=baR.value;baA.style.clipPath='inset(0 0 0 '+v+'%)';baH.style.left=v+'%';}
    baR.addEventListener('input',ab);ab();
    /* once the shopper drags or taps the slider, retire the "drag to compare" hint — :hover covers desktop, this covers touch where there's no hover */
    var baHint=document.querySelector('.ba-tile .ba-hint');
    if(baHint)baR.addEventListener('input',function(){baHint.classList.add('used');},{once:true});
    /* one-time nudge when the slider scrolls into view so it reads as draggable — skipped under reduced motion; programmatic value changes don't fire 'input', so the hint stays put until a real drag */
    var baTile=baR.closest('.ba-tile');
    if(baTile&&!RM()&&'IntersectionObserver'in window){
      var baNudged=false;
      function baNudge(){if(baNudged)return;baNudged=true;var t0=0;
        function step(ts){if(!t0)t0=ts;var p=(ts-t0)/1150;if(p>=1){baR.value=50;ab();return;}
          baR.value=50+13*Math.sin(p*Math.PI*2)*(1-p);ab();requestAnimationFrame(step);}
        requestAnimationFrame(step);}
      var baIO=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){baNudge();baIO.disconnect();}});},{threshold:.55});
      baIO.observe(baTile);
    }
  }
  (function(){var demo=document.getElementById('fogDemo'),cv=document.getElementById('fogCanvas'),hint=document.getElementById('fogHint');if(!demo||!cv)return;
    var ctx=cv.getContext('2d'),dpr=Math.min(2,window.devicePixelRatio||1),wiped=false;
    function fill(a){ctx.globalCompositeOperation='source-over';ctx.fillStyle='rgba(228,235,238,'+(a||1)+')';ctx.fillRect(0,0,cv.width,cv.height);}
    function size(){var r=demo.getBoundingClientRect();if(!r.width)return;cv.width=Math.round(r.width*dpr);cv.height=Math.round(r.height*dpr);fill(1);}
    function er(cx,cy){if(!cv.width){size();if(!cv.width)return;}var r=cv.getBoundingClientRect();var x=(cx-r.left)*(cv.width/r.width),y=(cy-r.top)*(cv.height/r.height),rad=58*dpr;
      var g=ctx.createRadialGradient(x,y,0,x,y,rad);g.addColorStop(0,'rgba(0,0,0,1)');g.addColorStop(.62,'rgba(0,0,0,1)');g.addColorStop(1,'rgba(0,0,0,0)');
      ctx.globalCompositeOperation='destination-out';ctx.fillStyle=g;ctx.beginPath();ctx.arc(x,y,rad,0,Math.PI*2);ctx.fill();if(!wiped){wiped=true;if(hint)hint.style.opacity='0';}}
    demo.addEventListener('pointermove',function(e){er(e.clientX,e.clientY);});demo.addEventListener('pointerdown',function(e){er(e.clientX,e.clientY);});
    /* the creeping fog regrowth is autonomous motion — skip it under reduce-motion; wipe-on-touch (user-driven) still works */
    if(!RM())setInterval(function(){if(document.hidden)return;ctx.globalCompositeOperation='source-over';ctx.fillStyle='rgba(228,235,238,0.035)';ctx.fillRect(0,0,cv.width,cv.height);if(wiped&&hint)hint.style.opacity='';},140);
    size();addEventListener('resize',size);})();
  /* Size finder. #vanity is the shared .vw slider (tacVWSet owns the #vanityVal readout + the track
     fill + the quick picks) — this block only maps the width to a recommendation. It reads the
     remembered width on load and publishes on release, so the width travels between this tool, the
     quiz and the PDP fit check instead of being asked for four times. */
  var vanity=document.getElementById('vanity'),sgN=document.getElementById('sgName'),sgW=document.getElementById('sgWhy'),
      sgShop=document.getElementById('sgShop'),bars=document.querySelectorAll('.sg-bar');
  /* Bands come from sections/size-finder.liquid via window.TAC_SIZEBANDS, where availability is read
     from the catalogue's size:<N>-inch tags. NEVER recommend a band with avail:false — that is the
     2026-09-17 bug (a 72" vanity was sent to a 40x24 that was also the widest thing we sold, and a
     44" band would otherwise advertise a SKU that has not landed). The literal list below is only a
     fallback for a page that mounts #vanity without this section; keep it conservative. */
  if(vanity){var recs=(window.TAC_SIZEBANDS&&window.TAC_SIZEBANDS.length)?window.TAC_SIZEBANDS:[
    {max:27,w:20,name:'Compact',dim:'20″ × 28″',why:'For a powder room or compact vanity, a frameless rectangle keeps clean proportions without crowding the wall.',avail:true,url:''},
    {max:33,w:24,name:'Classic',dim:'24″ × 32″',why:'Centred over a standard single vanity, this keeps soft proportions and frames the face beautifully.',avail:true,url:''},
    {max:43,w:32,name:'Wide',dim:'32″ × 24″',why:'A wider single vanity wants a horizontal mirror — more reflection, more light, balanced to the counter.',avail:true,url:''},
    {max:999,w:40,name:'A matched pair',dim:'two mirrors',why:'On a double vanity, two mirrors — one centred over each basin — read as intentional where one wide mirror reads as undersized.',avail:true,pair:true,url:''}];
    function nearestAvail(ideal){var best=null,bd=Infinity;recs.forEach(function(x){if(!x.avail)return;var d=Math.abs((x.w||0)-(ideal.w||0));if(d<bd){bd=d;best=x;}});return best;}
    function av(){var w=+vanity.value,ideal=recs.find(function(x){return w<=x.max;})||recs[recs.length-1],r=ideal,sub='';
      if(!ideal.avail){r=nearestAvail(ideal);
        /* Honest downgrade: name the size we DO make rather than silently showing a different one. */
        if(r)sub=' We don’t make a '+ideal.w+'″ yet — the closest is '+r.dim+'.';else r=ideal;}
      sgN.textContent=r.name+' · '+r.dim;sgW.textContent=r.why+sub;
      if(sgShop){if(r.url){sgShop.setAttribute('href',r.url);sgShop.hidden=false;}else{sgShop.hidden=!r.avail;}}
      bars.forEach(function(b){var mn=+b.dataset.min,mx=+b.dataset.max;
        b.classList.toggle('match',w>=mn&&w<=mx&&b.dataset.avail!=='0');});}
    var sgRemembered=tacReadVanityW();
    tacVWSet(vanity,sgRemembered||vanity.value);
    vanity.addEventListener('input',av);
    vanity.addEventListener('change',function(){tacPublishVanityW(vanity.value,'finder');});   /* on release / quick pick */
    document.addEventListener('tac:vanity',function(e){    /* width set by another tool on this page */
      /* No "value already equal" guard: tacPublishVanityW moves every slider BEFORE it broadcasts, so
         the value always matches by now — bailing on that would leave the recommendation on the old
         width. av() doesn't publish, so re-running it can't loop. */
      var w=e.detail&&e.detail.w;if(!(w>0))return;tacVWSet(vanity,w);av();});
    av();}
  document.querySelectorAll('.faq button').forEach(function(btn){btn.addEventListener('click',function(){var f=btn.parentElement,ans=f.querySelector('.ans'),open=f.classList.contains('open');
    f.classList.toggle('open',!open);btn.setAttribute('aria-expanded',String(!open));ans.style.maxHeight=open?'0':ans.scrollHeight+'px';});});
  /* PDP description tabs — switch the active panel on tab click (guarded; no-op if absent) */
  document.querySelectorAll('.pdp-tabs').forEach(function(tabs){
    var btns=tabs.querySelectorAll('.pdp-tab');
    tabs.addEventListener('click',function(e){var b=e.target.closest('.pdp-tab');if(!b)return;var key=b.getAttribute('data-tab');
      btns.forEach(function(x){var on=x===b;x.classList.toggle('active',on);x.setAttribute('aria-selected',on?'true':'false');});
      tabs.querySelectorAll('.pdp-panel').forEach(function(p){p.classList.toggle('active',p.getAttribute('data-panel')===key);});});
  });
  /* Spec chips → open the Specifications tab + scroll to it (guarded; PDP-only, no-op elsewhere) */
  (function(){var j=document.querySelector('[data-spec-jump]');if(!j)return;var tabs=document.querySelector('.pdp-tabs');if(!tabs)return;
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    j.addEventListener('click',function(e){e.preventDefault();var b=tabs.querySelector('.pdp-tab[data-tab="specs"]');if(b)b.click();tabs.scrollIntoView({behavior:reduce?'auto':'smooth',block:'start'});});})();
  /* Header nav dropdowns — hover + keyboard focus via CSS; click/tap toggles for touch; arrow-key roving; Esc + outside-click close. */
  (function(){var subs=document.querySelectorAll('.nav-item.has-sub');if(!subs.length)return;
    function closeAll(except){subs.forEach(function(it){if(it!==except){it.classList.remove('open');var b=it.querySelector('.subnav-toggle');if(b)b.setAttribute('aria-expanded','false');}});}
    /* keep a wide (mega) panel on-screen: if its centered position would clip the viewport edge, shift it horizontally via --sn-shift (the caret compensates) */
    function clampPanel(it){var p=it.querySelector('.subnav');if(!p)return;p.style.setProperty('--sn-shift','0px');var iw=window.innerWidth,m=8,r=it.getBoundingClientRect(),c=r.left+r.width/2,half=p.offsetWidth/2,shift=0;if(c+half>iw-m){shift=(iw-m)-(c+half);}else if(c-half<m){shift=m-(c-half);}if(shift){p.style.setProperty('--sn-shift',Math.round(shift)+'px');}}
    subs.forEach(function(it){var btn=it.querySelector('.subnav-toggle');if(!btn)return;
      if(it.classList.contains('has-mega')){it.addEventListener('mouseenter',function(){clampPanel(it);});it.addEventListener('focusin',function(){clampPanel(it);});}
      btn.addEventListener('click',function(e){e.preventDefault();var open=it.classList.contains('open');closeAll(it);it.classList.toggle('open',!open);btn.setAttribute('aria-expanded',String(!open));});
      var links=Array.prototype.slice.call(it.querySelectorAll('.subnav a'));
      it.addEventListener('keydown',function(e){var idx=links.indexOf(document.activeElement);
        if(e.key==='ArrowDown'){e.preventDefault();if(!it.classList.contains('open')){closeAll(it);it.classList.add('open');btn.setAttribute('aria-expanded','true');}links[idx+1<links.length?idx+1:0].focus();}
        else if(e.key==='ArrowUp'){e.preventDefault();if(links.length)links[idx>0?idx-1:links.length-1].focus();}
        else if(e.key==='Home'&&idx>=0){e.preventDefault();links[0].focus();}
        else if(e.key==='End'&&idx>=0){e.preventDefault();links[links.length-1].focus();}});});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')closeAll(null);});
    document.addEventListener('click',function(e){if(!e.target.closest('.nav-item.has-sub'))closeAll(null);});})();
  /* Mobile drawer submenus — tap a parent row to expand its children (mirrors the .faq accordion). */
  (function(){var toggles=document.querySelectorAll('.drawer-sub-toggle');if(!toggles.length)return;
    toggles.forEach(function(btn){btn.addEventListener('click',function(){var g=btn.parentElement,panel=g.querySelector('.drawer-sub'),open=g.classList.contains('open');
      g.classList.toggle('open',!open);btn.setAttribute('aria-expanded',String(!open));if(panel)panel.style.maxHeight=open?'0':panel.scrollHeight+'px';});});})();
  /* Inline header search — expand, predictive suggestions (keyboard-navigable), recent searches, "/" shortcut. */
  (function(){var ns=document.querySelector('.nav-search');if(!ns)return;
    var input=ns.querySelector('.nav-search-input'),btn=ns.querySelector('.nav-search-btn'),panel=ns.querySelector('.nav-search-suggest');if(!input||!btn)return;
    var act=ns.getAttribute('action')||'/search',items=[],active=-1,live=null;
    function openS(){ns.classList.add('open');btn.setAttribute('aria-expanded','true');}
    function closeS(){ns.classList.remove('open');btn.setAttribute('aria-expanded','false');hidePanel();}
    function hidePanel(){if(!panel)return;panel.hidden=true;panel.innerHTML='';items=[];active=-1;input.setAttribute('aria-expanded','false');input.removeAttribute('aria-activedescendant');if(live)live.textContent='';}
    function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
    btn.addEventListener('click',function(e){
      if(!ns.classList.contains('open')){e.preventDefault();openS();input.focus();if(panel&&!input.value.trim())renderRecent();}
      else if(!input.value.trim()){e.preventDefault();closeS();}});
    document.addEventListener('click',function(e){if(e.target.closest('.nav-search'))return;
      if(ns.classList.contains('open')&&!input.value.trim())closeS();else hidePanel();});
    /* Submitting a pasted item code natively would search the TRIMMED code, find nothing, and only then
       bounce off the zero-results retry in sections/main-search.liquid — a wasted round trip plus a flash
       of the no-results template. Rewrite it here instead: same shape rule + JT prefix, and code=1 so the
       results page still echoes the shopper's own code. Native submit stays the fallback with JS off. */
    ns.addEventListener('submit',function(e){
      var q=(input.value||'').trim();
      if(/^jt/i.test(q)||!/^[A-Za-z]{2}-[A-Za-z]{1,2}\d{1,3}-[A-Za-z0-9]{2,6}$/.test(q))return;
      e.preventDefault();
      location.href=act+'?q='+encodeURIComponent('JT'+q)+'&code=1';});
    if(panel){var t,ctrl=null,RK='tacRecentSearches';
      input.setAttribute('role','combobox');input.setAttribute('aria-autocomplete','list');input.setAttribute('aria-expanded','false');
      if(!panel.id)panel.id='navSearchSuggest';input.setAttribute('aria-controls',panel.id);
      live=document.createElement('span');live.className='visually-hidden';live.setAttribute('aria-live','polite');ns.appendChild(live);
      function show(html){panel.innerHTML=html;panel.hidden=false;input.setAttribute('aria-expanded','true');
        items=Array.prototype.slice.call(panel.querySelectorAll('a'));active=-1;input.removeAttribute('aria-activedescendant');
        items.forEach(function(a,k){if(!a.id)a.id='nssOpt'+k;a.setAttribute('role','option');a.addEventListener('mouseenter',function(){setActive(k);});});
        if(live){var rn=panel.querySelectorAll('.nss-list:not(.nss-recent) li').length;live.textContent=panel.querySelector('.nss-empty')?'No matches':(rn?(rn+' result'+(rn===1?'':'s')):'');}}
      function setActive(k){if(active>=0&&items[active])items[active].classList.remove('nss-active');active=k;
        if(k>=0&&items[k]){items[k].classList.add('nss-active');input.setAttribute('aria-activedescendant',items[k].id);items[k].scrollIntoView({block:'nearest'});}else input.removeAttribute('aria-activedescendant');}
      input.addEventListener('input',function(){clearTimeout(t);var q=input.value.trim();
        if(q.length>=2){t=setTimeout(function(){fetchSuggest(q);},220);return;}
        if(q.length===0)renderRecent();else hidePanel();});
      input.addEventListener('focus',function(){if(!input.value.trim())renderRecent();});
      input.addEventListener('keydown',function(e){
        if(e.key==='Escape'){if(!panel.hidden){hidePanel();}else{closeS();btn.focus();}return;}
        if(panel.hidden||!items.length)return;
        if(e.key==='ArrowDown'){e.preventDefault();setActive(active+1>=items.length?0:active+1);}
        else if(e.key==='ArrowUp'){e.preventDefault();setActive(active<=0?items.length-1:active-1);}
        else if(e.key==='Enter'&&active>=0){e.preventDefault();window.location.href=items[active].href;}});
      function fetchSuggest(q){
        if(ctrl)ctrl.abort();ctrl=('AbortController' in window)?new AbortController():null;
        var url=act+'/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product,collection,article,page&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url,{headers:{'Accept':'application/json'},signal:ctrl?ctrl.signal:undefined}).then(function(r){return r.json();}).then(function(d){
          if(input.value.trim()!==q)return;
          var res=(d&&d.resources&&d.resources.results)||{};
          renderResults(res.products||[],res.collections||[],((res.articles||[]).concat(res.pages||[])).slice(0,3),q);
        }).catch(function(e){if(e&&e.name==='AbortError')return;hidePanel();});}
      function hl(title,q){var et=esc(title),eq=esc(q);if(!eq)return et;return et.replace(new RegExp('('+eq.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')+')','ig'),'<mark>$1</mark>');}
      /* suggest.json gives price/price_min/max + tags, but NOT variant options — so the hint is price +
         size-count (from size:* tags), the two highest-signal mirror attributes, not finish (unavailable). */
      function fmtMoney(v){var n=parseFloat(v);if(isNaN(n)||n<=0)return '';var s=n%1===0?String(Math.round(n)):n.toFixed(2);return '$'+s.replace(/\B(?=(\d{3})+(?!\d))/g,',');}
      function suggestMeta(p){
        var pr=(p.price_min!=null?p.price_min:p.price),mult=(p.price_min!=null&&p.price_max!=null&&p.price_min!==p.price_max),pl=fmtMoney(pr);
        var nsz=(p.tags||[]).filter(function(t){return /^size:\d+/i.test(t);}).length;
        return [(pl?(mult?'From ':'')+pl:''),(nsz>1?nsz+' sizes':'')].filter(Boolean).join(' · ');
      }
      /* Item code typed into the box. /search/suggest.json does NOT match variant SKUs — verified against
         the live store, both "FM-R01-2032" and the raw "JTFM-R01-2032" return zero products — so there is
         nothing to prefix here; the FULL search does match the raw SKU. Offer a direct row into that query
         instead, which is the one path that actually resolves a code (same shape rule + JT prefix as the
         zero-results retry in sections/main-search.liquid; ?code=1 keeps the prefix off screen there). */
      function codeRow(q){
        q=(q||'').trim();
        if(/^jt/i.test(q)||!/^[A-Za-z]{2}-[A-Za-z]{1,2}\d{1,3}-[A-Za-z0-9]{2,6}$/.test(q))return '';
        return '<ul class="nss-list nss-code"><li><a href="'+esc(act)+'?q='+encodeURIComponent('JT'+q)+'&code=1">'+
          '<span class="nss-t"><span class="nss-t-title">Find item code “'+esc(q)+'”</span>'+
          '<span class="nss-meta">Goes straight to the matching mirror</span></span></a></li></ul>';}
      function renderResults(prods,colls,guides,q){
        var cr=codeRow(q);
        if(!prods.length&&!colls.length&&!guides.length){show(cr+(cr?'':'<div class="nss-empty">No matches.</div>')+'<a class="nss-all" href="'+esc(act)+'?q='+encodeURIComponent(q)+'">See all results for “'+esc(q)+'”</a>');return;}
        var h=cr;
        if(prods.length){h+='<ul class="nss-list">';prods.forEach(function(p){var img=p.image||(p.featured_image&&p.featured_image.url)||'';
          var meta=suggestMeta(p);
          h+='<li><a href="'+esc(p.url)+'">'+(img?'<img src="'+esc(img)+'" alt="" width="40" height="40" loading="lazy">':'<span class="nss-noimg"></span>')+'<span class="nss-t"><span class="nss-t-title">'+hl(p.title,q)+'</span>'+(meta?'<span class="nss-meta">'+esc(meta)+'</span>':'')+'</span></a></li>';});h+='</ul>';}
        if(colls.length){h+='<ul class="nss-list nss-colls">';colls.forEach(function(c){h+='<li><a href="'+esc(c.url)+'">'+esc(c.title)+'</a></li>';});h+='</ul>';}
        /* Guide/page hits — the results page is blended now, so the dropdown mirrors it: a compact
           Guides group (max 3, merged articles+pages) reusing the recent-searches row markup, so the
           existing keyboard nav / live-count in show() picks the links up with zero extra wiring. */
        if(guides.length){h+='<div class="nss-head">Guides</div><ul class="nss-list nss-guides">';guides.forEach(function(g){h+='<li><a href="'+esc(g.url)+'"><span class="nss-t">'+hl(g.title,q)+'</span></a></li>';});h+='</ul>';}
        h+='<a class="nss-all" href="'+esc(act)+'?q='+encodeURIComponent(q)+'">See all results for “'+esc(q)+'”</a>';
        show(h);}
      function getRecent(){try{return JSON.parse(localStorage.getItem(RK)||'[]');}catch(e){return [];}}
      function pushRecent(q){try{var a=getRecent().filter(function(x){return x.toLowerCase()!==q.toLowerCase();});a.unshift(q);localStorage.setItem(RK,JSON.stringify(a.slice(0,5)));}catch(e){}}
      function renderRecent(){var a=getRecent();if(!a.length){hidePanel();return;}
        var h='<div class="nss-head">Recent searches</div><ul class="nss-list nss-recent">';
        a.forEach(function(q){h+='<li><a href="'+esc(act)+'?q='+encodeURIComponent(q)+'"><span class="nss-t">'+esc(q)+'</span></a></li>';});
        h+='</ul>';show(h);}
      ns.addEventListener('submit',function(){var q=input.value.trim();if(q)pushRecent(q);});
    } else {
      input.addEventListener('keydown',function(e){if(e.key==='Escape'){closeS();btn.focus();}});
    }
    document.addEventListener('keydown',function(e){if(e.key!=='/'||e.metaKey||e.ctrlKey||e.altKey)return;
      var a=document.activeElement,tag=a&&a.tagName;
      if(tag==='INPUT'||tag==='TEXTAREA'||tag==='SELECT'||(a&&a.isContentEditable))return;
      e.preventDefault();openS();input.focus();});})();
  /* Rotating announcement bar — crossfade pipe-separated messages; pause on hover/focus + hidden tab; reduced-motion shows only the first. */
  (function(){var bar=document.querySelector('.promo[data-promo-rotate]');if(!bar)return;
    if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches)return;
    var msgs=bar.querySelectorAll('.promo-msg');if(msgs.length<2)return;var i=0,iv=null;
    function step(){msgs[i].classList.remove('on');i=(i+1)%msgs.length;msgs[i].classList.add('on');}
    function start(){if(!iv)iv=setInterval(step,4500);}
    function stop(){if(iv){clearInterval(iv);iv=null;}}
    bar.addEventListener('pointerenter',stop);bar.addEventListener('focusin',stop);
    bar.addEventListener('pointerleave',start);bar.addEventListener('focusout',start);
    document.addEventListener('visibilitychange',function(){if(document.hidden)stop();else start();});
    start();})();
  /* Address book (customers/addresses) — country_option_tags renders no selected attribute, so an
     edit form would show/submit the wrong country. Preselect each select from its data-addr-country.
     Guarded: no-op on every page but the address book. */
  (function(){var sels=document.querySelectorAll('select[data-addr-country]');if(!sels.length)return;
    Array.prototype.forEach.call(sels,function(s){var v=s.getAttribute('data-addr-country');if(v)s.value=v;});})();
  /* Dismissible announcement bar — remembers dismissal per message via localStorage. */
  (function(){var bar=document.querySelector('.promo[data-promo-key]');if(!bar)return;
    var key=bar.getAttribute('data-promo-key'),K='tacPromoDismissed';
    try{if(localStorage.getItem(K)===key){bar.style.display='none';return;}}catch(e){}
    var x=bar.querySelector('.promo-close');if(!x)return;
    x.addEventListener('click',function(){bar.style.display='none';try{localStorage.setItem(K,key);}catch(e){}});})();
  /* Newsletter success (server-rendered after POST) — move focus to it so screen readers announce the confirmation. */
  (function(){var s=document.querySelector('[data-nl-success]');if(s)s.focus();})();
  document.querySelectorAll('.swatches').forEach(function(g){g.addEventListener('click',function(e){var b=e.target.closest('.swatch');if(!b)return;g.querySelectorAll('.swatch').forEach(function(x){x.classList.remove('active');});b.classList.add('active');});});
  document.querySelectorAll('.qty').forEach(function(q){var n=q.querySelector('span');q.addEventListener('click',function(e){var v=+n.textContent;if(e.target.dataset.q==='inc')n.textContent=v+1;if(e.target.dataset.q==='dec'&&v>1)n.textContent=v-1;});});
  document.querySelectorAll('.chip-btn').forEach(function(c){c.addEventListener('click',function(){var p=c.parentElement;p.querySelectorAll('.chip-btn').forEach(function(x){x.classList.remove('active');});c.classList.add('active');});});
  document.querySelectorAll('.shapes-select').forEach(function(g){g.addEventListener('click',function(e){var c=e.target.closest('.cat');if(!c)return;g.querySelectorAll('.cat').forEach(function(x){x.classList.remove('active');});c.classList.add('active');});});
  /* threshold:0 + bottom rootMargin so elements TALLER than the viewport (e.g. long legal pages) still reveal — a % threshold can never be met when the target dwarfs the viewport, leaving it stuck at opacity:0 */
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:0,rootMargin:'0px 0px -12% 0px'});
  document.querySelectorAll('.reveal').forEach(function(el){io.observe(el);});
  function stag(sel,drop){document.querySelectorAll(sel).forEach(function(g){if(drop)g.classList.remove('reveal');
    Array.prototype.forEach.call(g.children,function(c,i){c.classList.add('reveal');if(!/\bd[1-4]\b/.test(c.className))c.style.setProperty('--d',(i*0.08)+'s');io.observe(c);});});}
  stag('.lineup',false);stag('.shop-grid',false);stag('.gallery',true);stag('.trustbar',true);stag('.feature-list',false);stag('.foot-grid',false);stag('.shapes',false);
  /* safety net: after 1.5s, rescue any .reveal that's in/above the viewport but never got .in (observer hiccup / edge case) — below-fold elements are left to reveal normally on scroll */
  setTimeout(function(){document.querySelectorAll('.reveal:not(.in)').forEach(function(el){if(el.getBoundingClientRect().top < innerHeight){el.classList.add('in');io.unobserve(el);}});},1500);
  function cu(el){var tg=parseFloat(el.dataset.count)||0,dec=+(el.dataset.dec||0),suf=el.dataset.suffix||'',pre=el.dataset.prefix||'';
    if(RM()){el.textContent=pre+tg.toFixed(dec)+suf;return;}
    var s=performance.now(),d=1500;
    (function st(t){var p=Math.min(1,(t-s)/d),e=1-Math.pow(1-p,3);el.textContent=pre+(tg*e).toFixed(dec)+suf;if(p<1)requestAnimationFrame(st);})(s);}
  var cio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){cu(e.target);cio.unobserve(e.target);}});},{threshold:.6});
  document.querySelectorAll('[data-count]').forEach(function(el){cio.observe(el);});
  var sbar=document.getElementById('scrollProgress');
  if(sbar){function pg(){var h=document.documentElement,mx=h.scrollHeight-h.clientHeight;sbar.style.width=(mx>0?(scrollY/mx*100):0)+'%';}addEventListener('scroll',pg,{passive:true});pg();}
});

/* ---- PDP 2026 (every block guarded) ---- */
/* ---- Ships-by date engine — one honest estimator shared by the PDP (#pdpShipBy), the cart drawer
   (#cartShipBy) and the collection cards. Each .tac-shipby carries its own data-* config (Theme
   settings → Fulfilment); window.TAC_SHIP (layout/theme.liquid) carries the same config globally for
   the cards. data-zip="1" DISPLAYS the ZIP personalisation; data-zip-detect="1" (PDP only) is allowed
   to trigger the one-time IP lookup. ZIP is IP-detected once via ipinfo.io, then editable; cached in
   localStorage and broadcast (tac:zip) so every surface stays in sync. ---- */
window.tacZipGet=function(){try{var z=localStorage.getItem('tac_zip');if(z&&/^\d{5}$/.test(z))return z;}catch(_){}return '';};
window.tacCityGet=function(){try{var c=localStorage.getItem('tac_city');if(c)return c;}catch(_){}return '';};
/* Deep-link ZIP prefill: a ?zip=NNNNN param (e.g. the order-confirmation email link carrying
   {{ shipping_address.zip }}) seeds the stored ZIP so every ships-by surface — PDP, cart, and the
   /pages/delivery-date-calculator page — shows that dated estimate without the shopper typing.
   Runs once on load (deferred script, before the DOMContentLoaded handlers read the ZIP); clears
   any stale detected city so the "Deliver to" label matches the seeded ZIP. */
try{var _tacQZip=(location.search.match(/[?&]zip=(\d{5})(?:\D|$)/)||[])[1];if(_tacQZip){localStorage.setItem('tac_zip',_tacQZip);localStorage.removeItem('tac_city');}}catch(_e){}
/* Per-zone transit window (business days) from the Vermont, USA warehouse (05403). Near zones key off
   the ZIP's leading digit; remote regions (AK/HI/PR-VI) are special-cased so they never inherit a
   too-fast mainland window. Honest estimate, not a carrier quote — only ever shown once a ZIP is known. */
window.tacZipZone=function(zip){
  var p3=parseInt(zip.slice(0,3),10);
  if(p3>=995&&p3<=999)return [6,9];   /* Alaska */
  if(p3===967||p3===968)return [6,9]; /* Hawaii */
  if(p3>=6&&p3<=9)return [5,8];       /* Puerto Rico / US Virgin Islands (006–009) */
  switch(zip.charAt(0)){
    case '0':return [1,3];case '1':return [2,3];case '2':return [2,4];case '3':return [3,5];case '4':return [3,4];
    case '5':return [3,5];case '6':return [4,5];case '7':return [4,6];case '8':return [4,6];case '9':return [5,7];
    default:return null;}};
/* US holidays with NO UPS Ground service (the days transit truly pauses) for a given year, as
   'YYYY-MM-DD'. Weekend-falling ones are harmless (transit already skips Sat/Sun). Keeps the
   estimate honest across long weekends instead of reading a day early. Merchant extras (a company
   shutdown, etc.) come from window.TAC_SHIP.holidays. */
window.tacUSHolidays=function(year){
  function pad(n){return (n<10?'0':'')+n;}
  function d(m,day){return year+'-'+pad(m)+'-'+pad(day);}
  function nthWeekday(month,weekday,n){var first=new Date(Date.UTC(year,month-1,1)).getUTCDay();var day=1+((weekday-first+7)%7)+(n-1)*7;return d(month,day);}
  function lastWeekday(month,weekday){var lastDt=new Date(Date.UTC(year,month,0));return d(month,lastDt.getUTCDate()-((lastDt.getUTCDay()-weekday+7)%7));}
  return [ d(1,1), lastWeekday(5,1), d(7,4), nthWeekday(9,1,1), nthWeekday(11,4,4), d(12,25) ];
  /* New Year · Memorial (last Mon May) · Independence · Labor (1st Mon Sep) · Thanksgiving (4th Thu Nov) · Christmas */
};
/* Pure estimator: cfg {tz,ch,cm,shipDays[],tmin,tmax} + optional zip → formatted ship/delivery dates
   in the warehouse timezone. zip (when in a known zone) tightens the transit window; otherwise the
   merchant's national tmin/tmax stand. Returns null only if Intl is unavailable. */
window.tacShipEstimate=function(cfg,zip){
  if(typeof Intl==='undefined'||!Intl.DateTimeFormat||!cfg)return null;
  var tz=cfg.tz||'America/New_York',ch=isNaN(cfg.ch)?14:cfg.ch,cm=cfg.cm||0,
      shipDays=(cfg.shipDays&&cfg.shipDays.length)?cfg.shipDays:[1,2,3,4,5],
      tmin=cfg.tmin||3,tmax=(cfg.tmax<cfg.tmin)?cfg.tmin:cfg.tmax,
      WD={Sun:0,Mon:1,Tue:2,Wed:3,Thu:4,Fri:5,Sat:6};
  function parts(d){var o={};new Intl.DateTimeFormat('en-US',{timeZone:tz,hourCycle:'h23',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',weekday:'short'}).formatToParts(d).forEach(function(p){o[p.type]=p.value;});return o;}
  function offsetMs(d){var o=parts(d);return Date.UTC(+o.year,+o.month-1,+o.day,+o.hour,+o.minute,+o.second)-(d.getTime()-d.getMilliseconds());}
  function noon(y,m,d){return new Date(Date.UTC(y,m-1,d,12,0,0));}
  function addDays(dt,n){return new Date(dt.getTime()+n*86400000);}
  function isShipDay(dt){return shipDays.indexOf(dt.getUTCDay())>=0;}
  function pad2(n){return (n<10?'0':'')+n;}
  function keyOf(dt){return dt.getUTCFullYear()+'-'+pad2(dt.getUTCMonth()+1)+'-'+pad2(dt.getUTCDate());}
  function isHoliday(dt){return HOL[keyOf(dt)]===1;}
  function addBiz(dt,n){var c=dt,k=0;while(k<n){c=addDays(c,1);var w=c.getUTCDay();if(w!==0&&w!==6&&!isHoliday(c))k++;}return c;}
  function fmt(dt){return new Intl.DateTimeFormat('en-US',{weekday:'short',month:'short',day:'numeric',timeZone:'UTC'}).format(dt);}
  var now=new Date(),o=parts(now),off=offsetMs(now);
  /* holiday lookup covers this year + next (a late-Dec window can cross into January) plus merchant extras */
  var HOL={},_hy=+o.year;
  if(typeof window.tacUSHolidays==='function'){[_hy,_hy+1].forEach(function(Y){window.tacUSHolidays(Y).forEach(function(s){HOL[s]=1;});});}
  var _extra=cfg.holidays||(window.TAC_SHIP&&window.TAC_SHIP.holidays);
  if(_extra&&_extra.length){_extra.forEach(function(s){s=String(s).trim();if(/^\d{4}-\d{2}-\d{2}$/.test(s))HOL[s]=1;});}
  var cutoff=Date.UTC(+o.year,+o.month-1,+o.day,ch,cm,0)-off;   /* epoch ms of today's cutoff in warehouse tz */
  var today=noon(+o.year,+o.month,+o.day);
  var shipsToday=shipDays.indexOf(WD[o.weekday])>=0&&now.getTime()<cutoff&&!isHoliday(today);
  var disp=today;
  if(!shipsToday){disp=addDays(disp,1);while(!isShipDay(disp)||isHoliday(disp))disp=addDays(disp,1);}
  var useMin=tmin,useMax=tmax,hasZip=false;
  if(zip){var zone=window.tacZipZone(zip);if(zone){useMin=zone[0];useMax=zone[1];hasZip=true;}}
  var dmin=addBiz(disp,useMin),dmax=addBiz(disp,useMax),within=null;
  if(shipsToday){var ms=Math.max(0,cutoff-now.getTime()),h=Math.floor(ms/3600000),mm=Math.floor((ms%3600000)/60000);within=h>0?(h+'h '+(mm<10?'0':'')+mm+'m'):(mm+' min');}
  return {shipsToday:shipsToday,within:within,shipFmt:fmt(disp),dminFmt:fmt(dmin),dmaxFmt:fmt(dmax),range:fmt(dmin)+' – '+fmt(dmax),hasZip:hasZip};
};

document.addEventListener('DOMContentLoaded',function(){
  if(typeof Intl==='undefined'||!Intl.DateTimeFormat)return;
  var els=document.querySelectorAll('.tac-shipby');if(!els.length)return;
  var curZip=window.tacZipGet(),curCity=window.tacCityGet(),ticks=[];
  function esc(s){return String(s).replace(/[&<>"']/g,function(c){return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];});}
  function renderAll(){ticks.forEach(function(t){t();});}
  function broadcast(){renderAll();try{document.dispatchEvent(new CustomEvent('tac:zip'));}catch(_){}}
  /* manual ZIP entry → keep the ZIP, drop any detected city (it no longer matches the typed ZIP) */
  function setZip(z){curZip=z;curCity='';try{localStorage.setItem('tac_zip',z);localStorage.removeItem('tac_city');}catch(_){}broadcast();}
  /* IP detection → store the matched ZIP + city together */
  function setLoc(z,city){curZip=z;curCity=city||'';try{localStorage.setItem('tac_zip',z);if(curCity)localStorage.setItem('tac_city',curCity);else localStorage.removeItem('tac_city');}catch(_){}broadcast();}

  function cfgOf(el){return {tz:el.getAttribute('data-tz'),ch:parseInt(el.getAttribute('data-cutoff-h'),10),cm:parseInt(el.getAttribute('data-cutoff-m'),10)||0,shipDays:(el.getAttribute('data-ship-days')||'1,2,3,4,5').split(',').map(function(n){return parseInt(n,10);}).filter(function(n){return n>=0&&n<=6;}),tmin:parseInt(el.getAttribute('data-transit-min'),10)||3,tmax:parseInt(el.getAttribute('data-transit-max'),10)||7};}

  function init(el){
    var txt=el.querySelector('.tac-shipby-txt');if(!txt)return;
    var zipOn=el.getAttribute('data-zip')==='1',compact=el.getAttribute('data-compact')==='1',cfg=cfgOf(el);
    var changeBtn=zipOn?el.querySelector('[data-zip-change]'):null,
        form=zipOn?el.querySelector('[data-zip-form]'):null,
        input=zipOn?el.querySelector('[data-zip-input]'):null,
        placeEl=zipOn?el.querySelector('[data-zip-place]'):null,
        sepEl=zipOn?el.querySelector('[data-zip-sep]'):null,
        subEl=el.querySelector('[data-shipby-sub]');
    function tick(){
      /* fallback ZIP (P2): when none is known/detected, estimate from a merchant-set default zone so
         ad-blocker visitors still get a dated range — but never claim "Deliver to" for an assumed ZIP. */
      var defZip=(window.TAC_SHIP&&/^\d{5}$/.test(String(window.TAC_SHIP.defaultZip||'')))?String(window.TAC_SHIP.defaultZip):'';
      var useZip=zipOn?(curZip||defZip):'';
      var e=window.tacShipEstimate(cfg,useZip);if(!e)return;
      /* PDP (full): bold "Free delivery <window>" lead line + a secondary ship/cutoff line + the
         location row below. Cart (compact): one concise line, folding the date in once a ZIP is known. */
      if(compact){
        var html=(zipOn&&e.hasZip)
          ?(e.shipsToday?('Order within <b>'+e.within+'</b> — get it by <b>'+e.dmaxFmt+'</b>.'):('Ships <b>'+e.shipFmt+'</b> — get it by <b>'+e.dmaxFmt+'</b>.'))
          :(e.shipsToday?('Order within <b>'+e.within+'</b> to ship today.'):('Ships <b>'+e.shipFmt+'</b>.'));
        txt.innerHTML=html;
      }else{
        txt.innerHTML='Free delivery <b>'+e.range+'</b>';
        if(subEl){subEl.innerHTML=e.shipsToday?('Order within <b>'+e.within+'</b> — ships today.'):('Ships <b>'+e.shipFmt+'</b>.');subEl.classList.toggle('is-soon',!!e.shipsToday);}
      }
      el.hidden=false;
      if(changeBtn&&form&&form.hidden){changeBtn.textContent=curZip?'Change':'Add ZIP';changeBtn.hidden=false;}
      if(placeEl){
        if(curZip&&e.hasZip){placeEl.innerHTML='Deliver to <b>'+((curCity?esc(curCity)+' ':'')+curZip)+'</b>';placeEl.hidden=false;}
        else placeEl.hidden=true;   /* assumed default ZIP → show the dated range but no "Deliver to" claim */
      }
      if(sepEl)sepEl.hidden=!(e.hasZip&&changeBtn&&!changeBtn.hidden);   /* "·" only between a visible place and Change */
    }
    ticks.push(tick);
    tick();setInterval(tick,30000);   /* refresh the countdown and roll past the cutoff automatically */

    /* Inline ZIP editor (PDP only) */
    if(changeBtn&&form&&input){
      function openForm(o){form.hidden=!o;changeBtn.hidden=o;if(sepEl)sepEl.hidden=o?true:!(placeEl&&!placeEl.hidden);if(o){input.value=curZip;input.removeAttribute('aria-invalid');input.focus();if(input.select)input.select();}}
      changeBtn.addEventListener('click',function(){openForm(true);});
      form.addEventListener('submit',function(e){e.preventDefault();var v=(input.value||'').replace(/[^0-9]/g,'').slice(0,5);if(v.length===5){setZip(v);openForm(false);}else{input.setAttribute('aria-invalid','true');input.focus();}});
      input.addEventListener('input',function(){input.removeAttribute('aria-invalid');});
      input.addEventListener('keydown',function(e){if(e.key==='Escape'){openForm(false);changeBtn.focus();}});
    }
  }
  Array.prototype.forEach.call(els,init);

  /* React to a ZIP set on another surface (the cart drawer mirrors a PDP/​card change without reload). */
  document.addEventListener('tac:zip',function(){var z=window.tacZipGet(),c=window.tacCityGet();if(z!==curZip||c!==curCity){curZip=z;curCity=c;renderAll();}});

  /* One-time IP geolocation to seed the ZIP when none is stored. Only an element opted in with
     data-zip-detect="1" (the PDP) may trigger it — keeps the third-party call off non-PDP pages.
     ipinfo.io, 3s timeout, silent fallback to the national estimate on any failure. */
  var wantsDetect=Array.prototype.some.call(els,function(el){return el.getAttribute('data-zip-detect')==='1';});
  if(wantsDetect&&!curZip&&typeof fetch==='function'){
    var done=false,ctrl=('AbortController' in window)?new AbortController():null;
    var killer=setTimeout(function(){if(done)return;done=true;if(ctrl)ctrl.abort();},3000);
    fetch('https://ipinfo.io/json',{headers:{Accept:'application/json'},signal:ctrl?ctrl.signal:undefined})
      .then(function(r){return (r&&r.ok)?r.json():null;})
      .then(function(d){if(done)return;done=true;clearTimeout(killer);var p=d&&(d.postal||d.postalCode);if(p&&/^\d{5}/.test(String(p))){var city=(d&&d.city)?String(d.city).trim().slice(0,40):'';setLoc(String(p).slice(0,5),city);}})
      .catch(function(){if(done)return;done=true;clearTimeout(killer);});
  }
});

/* ---- Collection-card "Get it by <date>" — a single global estimate (window.TAC_SHIP) written into
   every [data-pc-deliv] card. Driven purely by the stored ZIP: hidden when none, so no IP call here
   and no layout shift for first-time visitors. Re-renders on tac:zip (a ZIP set elsewhere on the page). ---- */
document.addEventListener('DOMContentLoaded',function(){
  var cards=document.querySelectorAll('[data-pc-deliv]');if(!cards.length)return;
  if(typeof window.tacShipEstimate!=='function'||!window.TAC_SHIP)return;
  function render(){
    var defZip=(window.TAC_SHIP&&/^\d{5}$/.test(String(window.TAC_SHIP.defaultZip||'')))?String(window.TAC_SHIP.defaultZip):'';
    var zip=window.tacZipGet()||defZip;
    var e=zip?window.tacShipEstimate(window.TAC_SHIP,zip):null;
    var show=e&&e.hasZip;
    Array.prototype.forEach.call(cards,function(el){
      if(show){el.innerHTML='Get it by <b>'+e.dmaxFmt+'</b>';el.hidden=false;}
      else{el.textContent='';el.hidden=true;}
    });
  }
  render();
  document.addEventListener('tac:zip',render);
});

/* ---- PDP "transaction is secure" popover (#pdpSecure) — click / Enter / Space toggle, hover on fine pointers, Escape & outside-click close. Reassurance only; degrades to hidden if JS is off. ---- */
document.addEventListener('DOMContentLoaded',function(){
  var wrap=document.getElementById('pdpSecure');if(!wrap)return;
  var btn=wrap.querySelector('.pdp-secure-btn'),pop=document.getElementById('pdpSecurePop');if(!btn||!pop)return;
  function open(o){pop.hidden=!o;btn.setAttribute('aria-expanded',o?'true':'false');wrap.classList.toggle('open',o);}
  btn.addEventListener('click',function(){open(pop.hidden);});
  document.addEventListener('click',function(e){if(!wrap.contains(e.target))open(false);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'||e.key==='Esc')open(false);});
  if(window.matchMedia&&window.matchMedia('(hover:hover)').matches){
    wrap.addEventListener('mouseenter',function(){open(true);});
    wrap.addEventListener('mouseleave',function(){open(false);});
  }
});

/* ---- Multi-mirror discount nudge — shared by the cart drawer and the page cart (#cdVolNudge) ---- */
/* renders a one-away nudge ("add 1 more → save X%") or "X% off applied" from a live cart; display-only, same automatic-discount caveat as the PDP volume table */
/* returns {pct,count} for the tier currently reached (pct 0 = none) so callers can badge the lines too */
window.tacVolNudge=function(el,cart,giftVid){
  if(!el)return {pct:0,count:0};
  var t2q=parseInt(el.getAttribute('data-t2q'),10)||0,t2p=parseInt(el.getAttribute('data-t2p'),10)||0,
      t3q=parseInt(el.getAttribute('data-t3q'),10)||0,t3p=parseInt(el.getAttribute('data-t3p'),10)||0,
      type=(el.getAttribute('data-type')||'').toLowerCase().trim(),
      tiers=[];
  if(t2q>=2&&t2p>0)tiers.push({q:t2q,p:t2p});
  if(t3q>=2&&t3p>0)tiers.push({q:t3q,p:t3p});
  if(!tiers.length){el.hidden=true;return {pct:0,count:0};}
  tiers.sort(function(a,b){return a.q-b.q;});
  /* count mirrors: every line except the auto-gift + gift-wrap lines (or only a configured product type); also tally their subtotal for the post-discount estimate */
  var wrapEl=document.querySelector('.gift-opts[data-wrap-id]'),wrapId=wrapEl?parseInt(wrapEl.getAttribute('data-wrap-id'),10)||0:0,n=0,mirrorSub=0,unit0=null,uniform=true;
  (cart.items||[]).forEach(function(it){
    if(giftVid&&it.variant_id===giftVid)return;
    if(wrapId&&it.variant_id===wrapId)return;
    if(type&&(it.product_type||'').toLowerCase()!==type)return;
    n+=it.quantity;mirrorSub+=it.final_line_price;
    /* track the undiscounted per-unit price; if every qualifying line shares it (single-product / uniform cart) we can project the next tier exactly instead of from the average */
    var u=(typeof it.original_price==='number')?it.original_price:(it.quantity>0?Math.round(it.final_line_price/it.quantity):0);
    if(unit0===null)unit0=u;else if(Math.abs(u-unit0)>1)uniform=false;
  });
  if(n<=0){el.hidden=true;return {pct:0,count:0,next:null};}
  var cur=null,next=null;
  tiers.forEach(function(t){if(n>=t.q)cur=t;else if(!next)next=t;});
  /* If the real automatic discount is already live, the Ajax cart total already reflects it — don't re-estimate (that would double-count). Only estimate when nothing's come off yet. */
  var applied=(cart.total_discount||0)>0;
  var est=(cur&&!applied)?((cart.total_price||0)-Math.round(mirrorSub*cur.p/100)):null;
  /* only rewrite when the text actually changes — el is aria-live, so a redundant write would re-announce on every quantity step */
  function setHTML(h){if(el.innerHTML!==h)el.innerHTML=h;el.hidden=false;}
  var nextInfo=null;
  if(next){var need=next.q-n;
    /* exact unit price for uniform carts, average otherwise, × next-tier qty × pct → the dollars off at the next tier (shown rounded to whole dollars — it's an estimate) */
    var unit=(uniform&&unit0!=null)?unit0:(n>0?mirrorSub/n:0),projOff=Math.round(unit*next.q*next.p/100),dm=(window.tacMoneyRound&&projOff>0)?window.tacMoneyRound(projOff):'';
    nextInfo={need:need,pct:next.p,off:projOff};
    setHTML('Add <b>'+need+'</b> more mirror'+(need===1?'':'s')+' → save <b>'+next.p+'%</b>'+(dm?' (~'+dm+')':'')+' on all of them.');
    el.classList.remove('cd-volnudge-done');}
  else if(cur){
    if(applied){setHTML('<b>'+cur.p+'% off</b> your '+n+' mirrors — applied ✓.');}
    else{var mm=window.tacMoney?window.tacMoney(est):'';
      setHTML('<b>'+cur.p+'% off</b> your '+n+' mirrors'+(mm?' — about <b>'+mm+'</b> at checkout':' — applied automatically at checkout')+'.');}
    el.classList.add('cd-volnudge-done');}
  else{el.hidden=true;}
  return {pct:cur?cur.p:0,count:n,est:est,next:nextInfo};
};
/* page cart (no drawer): fetch the cart once, render the nudge, and badge each qualifying mirror line so the discount reads per-line, not just in the summary */
document.addEventListener('DOMContentLoaded',function(){
  if(document.getElementById('cartDrawer'))return;
  var el=document.getElementById('cdVolNudge'),rows=document.querySelectorAll('.cart-line[data-volqualify="true"]'),sub=document.getElementById('cartPageSubtotal'),announce=document.getElementById('cartPageVolAnnounce'),chkHint=document.getElementById('cdCheckoutHint');
  if(!el&&!rows.length)return;
  fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
    var res=el?window.tacVolNudge(el,cart,0):{pct:0};
    Array.prototype.forEach.call(rows,function(row){var b=row.querySelector('.cart-line-volsave');if(!b)return;
      if(res&&res.pct>0){b.textContent='· save '+res.pct+'%';b.hidden=false;}else{b.hidden=true;}});
    /* same struck-full + estimate treatment the drawer subtotal gets (estimate steps aside once the real discount is live) */
    if(sub&&res&&res.est!=null&&res.est<cart.total_price&&window.tacMoney){
      sub.innerHTML='<s class="cd-sub-was">'+window.tacMoney(cart.total_price)+'</s> <span class="cd-sub-est">≈ '+window.tacMoney(res.est)+'</span>';}
    /* announce the saving once into the always-rendered sr-only live region (the page cart isn't JS-live, so this fires a single time on load) */
    if(announce&&el&&!el.hidden)announce.textContent=el.textContent;
    /* repeat the one-away upsell beside the page-cart checkout button (mirrors the drawer) */
    if(chkHint){if(res&&res.next&&res.next.off>0&&window.tacMoneyRound){
        chkHint.innerHTML='Add <b>'+res.next.need+'</b> more mirror'+(res.next.need===1?'':'s')+' → save <b>~'+window.tacMoneyRound(res.next.off)+'</b>';chkHint.hidden=false;}
      else{chkHint.hidden=true;}}
  }).catch(function(){});
});

/* ---- Page-cart discount field (cart_type:page) — the cart form can't apply a code natively, so
   Apply routes to Shopify's /discount/{code} (sets the code + returns to the cart, where it's
   confirmed server-side from cart_level_discount_applications). Guarded on #cartPageDiscount, so it's
   inert on the drawer and every other page. ---- */
document.addEventListener('DOMContentLoaded',function(){
  var inp=document.getElementById('cartPageDiscount');if(!inp)return;
  var back=inp.getAttribute('data-cart-url')||'/cart';
  function applyCode(){var c=(inp.value||'').trim();if(!c){inp.focus();return;}
    location.href='/discount/'+encodeURIComponent(c)+'?redirect='+encodeURIComponent(back);}
  var btn=document.querySelector('[data-cartpage-disc-apply]');if(btn)btn.addEventListener('click',applyCode);
  inp.addEventListener('keydown',function(e){if(e.key==='Enter'){e.preventDefault();applyCode();}});
});

/* ---- Cart drawer (AOV) — guarded; without #cartDrawer, adds fall back to /cart + toast ---- */
document.addEventListener('DOMContentLoaded',function(){
  var dr=document.getElementById('cartDrawer');
  /* Shopify money_format renderer (cents -> string), emitted as window.TAC_MONEY */
  function money(c){
    var fmt=window.TAC_MONEY||'${{amount}}',v=(c||0)/100;
    function grp(s,sep){return s.replace(/\B(?=(\d{3})+(?!\d))/g,sep);}
    function d2(k,d){var p=v.toFixed(2).split('.');return grp(p[0],k)+d+p[1];}
    function d0(k){return grp(v.toFixed(0),k);}
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g,function(_,n){
      switch(n){
        case 'amount_no_decimals':return d0(',');
        case 'amount_with_comma_separator':return d2('.',',');
        case 'amount_no_decimals_with_comma_separator':return d0('.');
        case 'amount_with_apostrophe_separator':return d2("'",'.');
        default:return d2(',','.');
      }});
  }
  window.tacMoney=money;
  /* whole-dollar money for estimates: round to the nearest dollar and drop a trailing .00/,00 so "~$134" never reads "~$133.50" or "~$134.00" */
  window.tacMoneyRound=function(c){return money(Math.round((c||0)/100)*100).replace(/[.,]00(?=\D*$)/,'');};

  /* single AJAX-add entry point: adds, syncs badge, opens drawer (or toasts when no drawer) */
  window.tacCartAdd=function(id,qty,btn,props){
    id=parseInt(id,10);qty=qty||1;if(!id)return Promise.resolve();
    var orig=btn?btn.textContent:null;if(btn){btn.disabled=true;btn.classList.add('loading');}
    var item={id:id,quantity:qty};if(props){for(var pk in props){if(props.hasOwnProperty(pk)){item.properties=props;break;}}}
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[item]})})
      .then(function(r){if(!r.ok)throw new Error('add');return r.json();})
      .then(function(){
        if(dr){return (window.tacOpenCartDrawer?window.tacOpenCartDrawer():null);}
        if(window.refreshCartCount)window.refreshCartCount();else if(window.bumpCart)window.bumpCart();
        if(window.tacOpenCartDrawer){window.tacOpenCartDrawer();}else if(window.toast){window.toast('Added to cart',window.tacCartUrl&&window.tacCartUrl());}
      })
      .then(function(){if(btn){btn.disabled=false;btn.classList.remove('loading');btn.textContent='Added ✓';setTimeout(function(){btn.textContent=orig;},1400);}})
      .catch(function(){if(btn){btn.disabled=false;btn.classList.remove('loading');btn.textContent='Try again';setTimeout(function(){btn.textContent=orig;},1600);}});
  };
  /* collection / card quick-add (single-variant products) */
  /* carry the item code onto quick-added lines too (data-sku on the card's Add button), so an order
     names its mirrors the same way however the shopper got there */
  document.addEventListener('click',function(e){var q=e.target.closest('[data-qadd]');if(!q)return;e.preventDefault();
    var qs=q.getAttribute('data-sku')||'';
    window.tacCartAdd(q.getAttribute('data-qadd'),1,q,qs?{'Item code':qs}:null);});

  if(!dr)return;                          /* everything below is drawer-only */
  var itemsEl=document.getElementById('cartDrawerItems'),
      emptyEl=document.getElementById('cartDrawerEmpty'),
      subEl=document.getElementById('cartDrawerSubtotal'),
      footEl=dr.querySelector('.cd-foot'),
      moreEl=dr.querySelector('.cd-more'),
      goalEl=document.getElementById('cartDrawerGoal'),
      goalFill=goalEl?goalEl.querySelector('.cd-goal-fill'):null,
      goalMsg=goalEl?goalEl.querySelector('.cd-goal-msg'):null,
      upsellEls=dr.querySelectorAll('.cd-upsell:not(.cd-upsell-dyn) [data-upsell-id]'),
      upsellBlk=dr.querySelector('.cd-upsell:not(.cd-upsell-dyn)'),
      upDyn=document.getElementById('cdUpsell'),
      upRecCache={},upRecAnchor=null,
      goal=parseInt(dr.getAttribute('data-goal')||'0',10),
      giftVid=parseInt(dr.getAttribute('data-gift-id')||'0',10)||0,
      discWrap=document.getElementById('cartDrawerDiscounts'),
      savEl=document.getElementById('cartDrawerSavings'),
      discMsg=document.getElementById('cdDiscMsg'),giftBusy=false,
      reward=dr.getAttribute('data-reward')||'',unlocked=dr.getAttribute('data-unlocked')||'',
      volEl=document.getElementById('cdVolNudge'),
      chkHint=document.getElementById('cdCheckoutHint'),
      lastFocus=null;
  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function volNudge(cart){return (volEl&&window.tacVolNudge)?window.tacVolNudge(volEl,cart,giftVid):{pct:0};}   /* shared impl (top-level), also used by the page cart; returns the reached tier */
  var volType=(volEl?(volEl.getAttribute('data-type')||''):'').toLowerCase().trim();
  /* a line earns the per-line volume badge if it's a counted mirror (not the gift/wrap line, and matches the configured type when set) */
  function volLine(it){var wrapEl=document.querySelector('.gift-opts[data-wrap-id]'),wrapId=wrapEl?parseInt(wrapEl.getAttribute('data-wrap-id'),10)||0:0;
    if(giftVid&&it.variant_id===giftVid)return false;
    if(wrapId&&it.variant_id===wrapId)return false;
    if(volType&&(it.product_type||'').toLowerCase()!==volType)return false;
    return true;}
  function img120(u){if(!u)return '';return u+(u.indexOf('?')>-1?'&':'?')+'width=120';}
  function open(){lastFocus=document.activeElement;dr.classList.add('open');dr.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';var c=dr.querySelector('.cd-close');if(c)c.focus();}
  function close(){dr.classList.remove('open');dr.setAttribute('aria-hidden','true');document.body.style.overflow='';if(lastFocus&&lastFocus.focus)lastFocus.focus();}
  /* P2 — content-aware cart upsell (opt-in via #cdUpsell[data-upsell-dynamic]). Fills the strip from
     Shopify's complementary recommendations for what's in the cart (anchored on the first mirror, else the
     first item; complementary → related fallback), re-filtering against the live cart on every change and
     fetching once per anchor product. No-ops entirely when the dynamic block isn't rendered. */
  function upTile(p,inCartPids){
    if(inCartPids[p.id])return '';
    var v=p.variants&&p.variants[0];if(!v||v.available===false)return '';
    var im=p.featured_image||(p.images&&p.images[0])||'';
    return '<div class="cd-up" data-upsell-id="'+v.id+'"><div class="cd-up-thumb">'+(im?'<img src="'+esc(img120(im))+'" alt="" width="48" height="48" loading="lazy">':'')+'</div>'+
      '<div class="cd-up-info"><span class="cd-up-name">'+esc(p.title)+'</span><span class="cd-up-price">'+money(v.price)+'</span></div>'+
      '<button type="button" class="cd-up-add" data-upsell-add="'+v.id+'" aria-label="Add '+esc(p.title)+' to order">+ Add</button></div>';
  }
  function paintDynUpsell(ps,inCartPids){
    var list=upDyn.querySelector('.cd-upsell-list');if(!list)return;
    var html='',n=0,i;for(i=0;i<ps.length&&n<3;i++){var t=upTile(ps[i],inCartPids);if(t){html+=t;n++;}}
    if(!n){upDyn.hidden=true;return;}list.innerHTML=html;upDyn.hidden=false;
  }
  function renderDynUpsell(cart){
    if(!upDyn)return;
    var items=cart.items||[];if(!items.length){upDyn.hidden=true;return;}
    var anchor=items[0],i;for(i=0;i<items.length;i++){if((items[i].product_type||'').toLowerCase().indexOf('mirror')>-1){anchor=items[i];break;}}
    var pid=anchor.product_id;if(!pid){upDyn.hidden=true;return;}
    var inCartPids={};items.forEach(function(it){inCartPids[it.product_id]=1;});
    if(upRecCache[pid]){paintDynUpsell(upRecCache[pid],inCartPids);return;}
    if(upRecAnchor===pid)return;                 /* fetch already in flight for this anchor */
    upRecAnchor=pid;
    var load=function(intent,cb){fetch('/recommendations/products.json?product_id='+pid+'&limit=8&intent='+intent,{headers:{'Accept':'application/json'}})
      .then(function(r){return r.ok?r.json():{products:[]};}).then(function(d){cb((d&&d.products)||[]);}).catch(function(){cb([]);});};
    load('complementary',function(ps){
      if(ps.length){upRecCache[pid]=ps;paintDynUpsell(ps,inCartPids);}
      else load('related',function(ps2){upRecCache[pid]=ps2||[];paintDynUpsell(upRecCache[pid],inCartPids);});
    });
  }
  function render(cart){
    var has=cart.items&&cart.items.length,giftPrice=0;
    var volRes=volNudge(cart),volPct=volRes&&volRes.pct||0;   /* reached tier — also renders #cdVolNudge; used to badge each qualifying line below */
    if(itemsEl){itemsEl.setAttribute('aria-busy','false');
      itemsEl.innerHTML=!has?'':cart.items.map(function(it,i){
        var line=i+1,isGift=giftVid&&it.variant_id===giftVid;
        if(isGift)giftPrice+=it.final_line_price;
        var vt=(it.variant_title&&it.variant_title.indexOf('Default')<0)?'<div class="cd-vt">'+esc(it.variant_title)+'</div>':'',
            im=it.image?'<img src="'+esc(img120(it.image))+'" alt="" width="60" height="75" loading="lazy">':'';
        /* item code — /cart.js carries the raw SKU, so trim it here the same way snippets/sku-code does server-side */
        var cdSku=tacItemCode(it.sku),sk=cdSku?'<div class="cd-sku">Item #&nbsp;'+esc(cdSku)+'</div>':'';
        /* line-item properties (e.g. "Vanity width" from the PDP expert nudge); skip Shopify's hidden `_`-prefixed keys + blanks */
        var pp='';if(it.properties){for(var pk in it.properties){if(it.properties.hasOwnProperty(pk)){/* 'Item code' rides onto the order but is printed by .cd-sku above, not twice — tacLineProp drops it, along with hidden `_` keys and blanks */var pTx=tacLineProp(pk,it.properties[pk]);if(pTx)pp+='<div class="cd-prop">'+esc(pTx)+'</div>';}}}
        /* the auto-gift line is system-managed: a badge instead of qty/remove so shoppers can't fight syncGift */
        var giftFree=isGift&&it.final_line_price===0;        /* only $0 reads "Free gift"; a partial/misconfigured discount intentionally shows as a paid "Reward pick" so we never imply free when it isn't */
        var ctrl=isGift
          ? '<div class="cd-irow"><span class="cd-gift-tag'+(giftFree?' cd-gift-tag-free':'')+'">'+(giftFree?'Free gift 🎁':'Reward pick')+'</span></div>'
          : '<div class="cd-irow"><div class="cd-qty"><button type="button" class="cd-step" data-step="-1" aria-label="Decrease quantity">&minus;</button>'+
            '<span class="cd-qv">'+it.quantity+'</span><button type="button" class="cd-step" data-step="1" aria-label="Increase quantity">+</button></div>'+
            '<button type="button" class="cd-remove" data-remove aria-label="Remove '+esc(it.product_title)+'">Remove</button></div>';
        var priceHtml=(giftFree&&it.original_line_price>0)
          ? '<s class="cd-was">'+money(it.original_line_price)+'</s><span class="cd-free">'+money(0)+'</span>'
          : money(it.final_line_price);
        var volBadge=(volPct>0&&!isGift&&volLine(it))?'<span class="cd-volsave">· save '+volPct+'%</span>':'';
        return '<div class="cd-item'+(isGift?' cd-item-gift':'')+'" role="listitem" data-line="'+line+'">'+
          '<a class="cd-thumb" href="'+esc(it.url)+'">'+im+'</a>'+
          '<div class="cd-info"><a class="cd-iname" href="'+esc(it.url)+'">'+esc(it.product_title)+'</a>'+vt+sk+pp+ctrl+'</div>'+
          '<div class="cd-iprice">'+priceHtml+volBadge+'</div></div>';
      }).join('');
    }
    if(emptyEl)emptyEl.hidden=!!has;
    if(footEl)footEl.hidden=!has;
    if(moreEl)moreEl.hidden=!has;   /* the optional extras live in the scroll body now; same show/hide as the foot */
    /* when a volume tier is active, show the estimated post-discount subtotal right where shoppers read it (full price struck + ≈ estimate) */
    if(subEl){if(volPct>0&&volRes.est!=null&&volRes.est<cart.total_price){
        subEl.innerHTML='<s class="cd-sub-was">'+money(cart.total_price)+'</s> <span class="cd-sub-est">≈ '+money(volRes.est)+'</span>';}
      else{subEl.textContent=money(cart.total_price);}}
    /* Pay-in-4 on the live cart total — recompute + range-gate on every cart change */
    var finEl=document.getElementById('cartDrawerFin');
    if(finEl){var tp=cart.total_price||0,fmin=parseInt(finEl.getAttribute('data-fin-min'),10)||0,fmax=parseInt(finEl.getAttribute('data-fin-max'),10)||Infinity;
      if(tp>=fmin&&tp<=fmax){finEl.innerHTML=(finEl.getAttribute('data-fin-label')||'or 4 interest-free payments of')+' <strong>'+money(Math.floor(tp/4))+'</strong> <span class="fin-by">with Shop Pay</span>';finEl.hidden=false;}
      else{finEl.hidden=true;}}
    /* repeat the one-away upsell at the checkout button (the strongest moment); hidden once a tier is reached */
    if(chkHint){if(volRes.next&&volRes.next.off>0){
        var h='Add <b>'+volRes.next.need+'</b> more mirror'+(volRes.next.need===1?'':'s')+' → save <b>~'+(window.tacMoneyRound?window.tacMoneyRound(volRes.next.off):money(volRes.next.off))+'</b>';
        if(chkHint.innerHTML!==h)chkHint.innerHTML=h;chkHint.hidden=false;}
      else{chkHint.hidden=true;}}
    /* total savings (code + automatic + gift discounts) — reinforces the reward at the checkout moment */
    if(savEl){var sav=cart.total_discount||0;if(sav>0){savEl.innerHTML='You’re saving <b>'+money(sav)+'</b>';savEl.hidden=false;}else{savEl.hidden=true;}}
    var cc=document.getElementById('cartCount');if(cc&&typeof cart.item_count==='number')cc.textContent=cart.item_count;
    /* qualifying subtotal excludes the gift line so the bar + gift logic measure real merchandise spend */
    var qual=cart.total_price-giftPrice;
    if(goalEl&&goal>0){var pct=Math.max(0,Math.min(100,qual/goal*100));
      if(goalFill)goalFill.style.width=pct+'%';
      if(goalMsg){if(qual>=goal){goalMsg.innerHTML=esc(unlocked);goalEl.classList.add('cd-done');}
        else{goalMsg.innerHTML='Add <b>'+money(goal-qual)+'</b> to get '+esc(reward);goalEl.classList.remove('cd-done');}}
    }
    /* applied discount codes (and entered-but-not-eligible ones) */
    if(discWrap){var rows='';
      (cart.cart_level_discount_applications||[]).forEach(function(d){
        rows+='<div class="cd-disc-row"><span class="cd-disc-tag">✓ '+esc(d.title)+'</span><span class="cd-disc-amt">&minus;'+money(d.total_allocated_amount)+'</span>'+
          '<button type="button" class="cd-disc-rm" data-disc-remove aria-label="Remove discount '+esc(d.title)+'">Remove</button></div>';});
      (cart.discount_codes||[]).forEach(function(c){if(c.applicable===false){
        rows+='<div class="cd-disc-row cd-disc-bad"><span class="cd-disc-tag">'+esc(c.code)+' — not eligible</span>'+
          '<button type="button" class="cd-disc-rm" data-disc-remove aria-label="Remove '+esc(c.code)+'">Remove</button></div>';}});
      discWrap.innerHTML=rows;}
    if(upsellEls&&upsellEls.length){var inCart={};(cart.items||[]).forEach(function(it){inCart[it.variant_id]=1;});
      var anyVis=false;Array.prototype.forEach.call(upsellEls,function(u){var hide=!!inCart[parseInt(u.getAttribute('data-upsell-id'),10)];u.hidden=hide;if(!hide)anyVis=true;});
      if(upsellBlk)upsellBlk.hidden=!anyVis;}
    renderDynUpsell(cart);
    if(window.tacGiftSync)window.tacGiftSync(cart);
    syncGift(cart,qual);
  }
  function fetchRender(){if(itemsEl)itemsEl.setAttribute('aria-busy','true');
    return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(render).catch(function(){});}
  window.tacRefreshCartDrawer=fetchRender;   /* gift module calls this after toggling the wrap SKU so the drawer re-renders in place */
  function change(line,qty){if(itemsEl)itemsEl.setAttribute('aria-busy','true');
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:line,quantity:qty})})
      .then(function(r){return r.json();}).then(render).catch(function(){});}
  window.tacOpenCartDrawer=function(){open();return fetchRender();};
  window.tacCloseCartDrawer=close;

  dr.addEventListener('click',function(e){
    if(e.target.closest('.cd-close')||e.target.closest('.cd-overlay')||e.target.closest('.cd-close-go')){close();return;}
    var step=e.target.closest('.cd-step');
    if(step){var it=step.closest('.cd-item');if(!it)return;var qv=it.querySelector('.cd-qv'),nx=(+qv.textContent)+(+step.getAttribute('data-step'));change(+it.getAttribute('data-line'),Math.max(0,nx));return;}
    var rm=e.target.closest('[data-remove]');
    if(rm){var it2=rm.closest('.cd-item');if(it2)change(+it2.getAttribute('data-line'),0);return;}
    var up=e.target.closest('[data-upsell-add]');
    if(up){e.preventDefault();window.tacCartAdd(up.getAttribute('data-upsell-add'),1,up);return;}
    if(e.target.closest('[data-disc-apply]')){e.preventDefault();applyDiscount();return;}
    if(e.target.closest('[data-disc-remove]')){e.preventDefault();removeDiscount();return;}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&dr.classList.contains('open'))close();});
  document.querySelectorAll('[data-cart-drawer]').forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();window.tacOpenCartDrawer();});});

  /* discount code → /cart/update.js {discount} (apply) / {discount:''} (remove all) — official Ajax API, stays in the drawer */
  var discIn=document.getElementById('cdDiscount');
  function dmsg(t){if(!discMsg)return;discMsg.textContent=t||'';discMsg.hidden=!t;}
  function codeLive(cart,code){code=(code||'').toLowerCase();
    if((cart.cart_level_discount_applications||[]).length)return true;
    return (cart.discount_codes||[]).some(function(c){return (c.code||'').toLowerCase()===code&&c.applicable;});}
  function updateDiscount(code){if(itemsEl)itemsEl.setAttribute('aria-busy','true');
    return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({discount:code})})
      .then(function(r){return r.json();}).then(function(cart){render(cart);return cart;});}
  function applyDiscount(){if(!discIn)return;var code=(discIn.value||'').trim();if(!code){discIn.focus();return;}
    var btn=dr.querySelector('[data-disc-apply]'),orig=btn?btn.textContent:'';if(btn){btn.disabled=true;btn.textContent='Applying…';}dmsg('');
    updateDiscount(code).then(function(cart){
      if(codeLive(cart,code)){discIn.value='';dmsg('');}else{dmsg('“'+code+'” couldn’t be applied to this cart.');}
    }).catch(function(){dmsg('Couldn’t apply that code — try again.');})
      .then(function(){if(btn){btn.disabled=false;btn.textContent=orig||'Apply';}});}
  function removeDiscount(){dmsg('');updateDiscount('').catch(function(){});}
  if(discIn)discIn.addEventListener('keydown',function(e){if(e.key==='Enter'){e.preventDefault();applyDiscount();}});

  /* free-gift auto-add/remove at the reward goal (qualifying subtotal excludes the gift itself) */
  function syncGift(cart,qual){
    if(!giftVid||goal<=0||giftBusy)return;
    var present=false,line=0;(cart.items||[]).forEach(function(it,i){if(it.variant_id===giftVid){present=true;line=i+1;}});
    if(qual>=goal&&!present){giftBusy=true;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:giftVid,quantity:1}]})})
        .then(function(r){return r.json();}).then(function(){return fetchRender();}).catch(function(){}).then(function(){giftBusy=false;});
    } else if(qual<goal&&present){giftBusy=true;
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:line,quantity:0})})
        .then(function(r){return r.json();}).then(render).catch(function(){}).then(function(){giftBusy=false;});
    }
  }

  /* order note → debounced /cart/update.js (no navigation) */
  var noteIn=document.getElementById('cdNote');
  if(noteIn){var noteT;noteIn.addEventListener('input',function(){clearTimeout(noteT);noteT=setTimeout(function(){
    fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({note:noteIn.value})}).catch(function(){});
  },650);});}
  /* delivery phone → the same debounced path, as a cart ATTRIBUTE. The drawer has no form submit, so
     the page-cart's `attributes[Delivery phone]` input has no equivalent here. Blank clears it, so a
     shopper who deletes what they typed doesn't leave a stale number on the order. */
  var phoneIn=document.getElementById('cdPhone'),phoneOk=document.getElementById('cdPhoneOk');
  if(phoneIn){var phoneT;phoneIn.addEventListener('input',function(){clearTimeout(phoneT);if(phoneOk)phoneOk.hidden=true;phoneT=setTimeout(function(){
    tacSaveDeliveryPhone(phoneIn.value).then(function(){if(phoneOk)phoneOk.hidden=!phoneIn.value.trim();});
  },650);});}
});

/* These blocks must run on EVERY page. The cart-drawer handler above early-returns at `if(!dr)return`
   when no #cartDrawer is mounted (cart_type:page) — which was silently killing the PDP buy-box add-on,
   the qty/bulk nudge, and the trade-form personalization (capture / success / cart-quote) that live
   below it. Own DOMContentLoaded ⇒ they always run; they use only window.tacCartAdd / window.tacMoney,
   defined in the handler above, which registers first. */
document.addEventListener('DOMContentLoaded',function(){
  /* Collect ALL enabled line-item properties from the product form (Vanity width, gift options, …)
     so the AJAX add path sends them too. A native form POST submits every properties[…] input; the
     intercept must match, or the property silently never reaches the cart/order. Defined here (the form
     block is always present) rather than in the size-finder block, which early-returns when absent. */
  window.tacItemProps=function(){
    var pform=document.getElementById('product-form'); if(!pform)return null;
    var out={},cnt=0;
    Array.prototype.forEach.call(pform.querySelectorAll('[name^="properties["]'),function(el){
      if(el.disabled)return; var m=el.name.match(/^properties\[(.+)\]$/); if(!m)return;
      var val=(el.value||'').trim(); if(!val)return; out[m[1]]=val; cnt++;
    });
    return cnt?out:null;
  };

  /* intercept the primary PDP add-to-cart so it opens the drawer instead of a full reload */
  var pf=document.getElementById('product-form');
  if(pf){pf.addEventListener('submit',function(e){
    e.preventDefault();
    var idEl=pf.querySelector('[name="id"]'),qEl=pf.querySelector('[name="quantity"]'),sub=pf.querySelector('[name="add"]');
    if(!idEl||!idEl.value)return;
    var qty=qEl?(parseInt(qEl.value,10)||1):1,props=window.tacItemProps&&window.tacItemProps();
    /* optional buy-box add-on (#pdpAddon) rides into the cart with the mirror — add it first (no drawer),
       then the main item via tacCartAdd which opens the drawer/toasts with both lines. A failed add-on
       never blocks the mirror; unchecked or absent → straight to the main add. */
    var ax=document.getElementById('pdpAddon'),axId=0;
    if(ax&&ax.checked&&!ax.disabled){axId=parseInt(ax.getAttribute('data-vid'),10)||0;}  /* missing / non-numeric / 0 → skip the add-on, never block the mirror */
    var go=function(){window.tacCartAdd(idEl.value,qty,sub,props);};
    /* add a valid add-on first (no drawer), then the mirror; .then(go,go) ⇒ even a sold-out/422 add-on still adds the mirror */
    if(axId>0){fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:axId,quantity:1}]})}).then(go,go);}else{go();}
  });}

  /* Live add-on total — show "Mirror + add-on = $X" while #pdpAddon is checked, recomputing on
     variant switch. Guarded: no-op when the add-on row / total element is absent (any non-PDP page). */
  (function(){var ax=document.getElementById('pdpAddon'),tot=document.querySelector('[data-addon-total]');if(!ax||!tot)return;
    var money=window.tacMoney||function(c){return '$'+((c||0)/100).toFixed(2);};
    var addonC=parseInt(ax.getAttribute('data-pricec'),10)||0,vg=document.getElementById('pdpVariants');
    function mirrorC(){var a=vg&&vg.querySelector('.pvar.active');return a?(parseInt(a.getAttribute('data-pricec'),10)||0):(parseInt(tot.getAttribute('data-mirror'),10)||0);}
    function render(){if(ax.checked&&!ax.disabled){tot.textContent='Mirror + add-on = '+money(mirrorC()+addonC);tot.hidden=false;}else{tot.hidden=true;}}
    ax.addEventListener('change',render);
    if(vg)vg.addEventListener('click',function(e){if(e.target.closest('.pvar'))setTimeout(render,0);});
    render();})();

  /* Quantity-aware bulk nudge — emphasise the "Need 10+?" line once the qty stepper reaches the
     threshold, and (when the volume table exists) surface the active tier's per-unit price right there
     so a volume buyer sees the saving without applying. Reads #pdpVolume's .pvol-row data (kept current
     per variant by theme-pdp.js). Guarded on .pdp-bulk + #qty → inert elsewhere. */
  (function(){var bl=document.querySelector('.pdp-bulk'),q=document.getElementById('qty');if(!bl||!q)return;
    var th=parseInt(bl.getAttribute('data-bulk-threshold'),10)||3,
        each=bl.parentNode.querySelector('[data-bulk-each]'),
        vol=document.getElementById('pdpVolume'),
        money=window.tacMoney||function(c){return '$'+((c||0)/100).toFixed(2);};
    function tier(n){if(!vol)return null;var best=null;
      vol.querySelectorAll('.pvol-row').forEach(function(r){var m=parseInt(r.getAttribute('data-min'),10)||1,p=parseInt(r.getAttribute('data-pct'),10)||0;
        if(n>=m&&p>0&&(!best||m>best.m)){best={m:m,unit:parseInt(r.getAttribute('data-unit'),10)||0};}});
      return best;}
    function upd(){var n=parseInt(q.value,10)||1,on=n>=th;bl.classList.toggle('is-emph',on);
      if(each){var t=on?tier(n):null;if(t&&t.unit>0){each.textContent=money(t.unit)+' each at '+t.m+'+';each.hidden=false;}else{each.hidden=true;}}}
    q.addEventListener('input',upd);q.addEventListener('change',upd);
    document.querySelectorAll('[data-qty-step]').forEach(function(b){b.addEventListener('click',function(){setTimeout(upd,0);});});
    var vg=document.getElementById('pdpVariants');if(vg)vg.addEventListener('click',function(e){if(e.target.closest('.pvar'))setTimeout(upd,0);});
    upd();})();

  /* Trade form: carry the originating product + bulk intent from the PDP link into the contact form.
     Liquid can't read query params, so ?product=<handle> → hidden contact[product] (+ a visible "Enquiring
     about …" line), and ?intent=bulk appends 'bulk' to contact[tags]. Guarded on #tradeProduct → only the
     Professionals page runs it. */
  (function(){var f=document.getElementById('tradeProduct');if(!f)return;
    var qs;try{qs=new URLSearchParams(location.search);}catch(e){return;}
    var h=qs.get('product');
    if(h){f.value=h;var note=document.getElementById('tradeFromProduct'),lab=note&&note.querySelector('[data-trade-product]');
      if(lab){lab.textContent=h.replace(/-/g,' ');note.hidden=false;}}
    /* cart-carried basket (?quote=) → prefill the message so a project quote arrives itemised */
    var qv=qs.get('quote');
    if(qv){var bd=(f.form||document).querySelector('[name="contact[body]"]');if(bd&&!bd.value){bd.value='Project quote request:\n'+qv;}}
    var isBulk=qs.get('intent')==='bulk';
    if(isBulk){var form=f.form||document,tg=form.querySelector('[name="contact[tags]"]');
      if(tg&&tg.value.indexOf('bulk')<0){tg.value=tg.value+', bulk';}
      var hd=document.getElementById('proApplyHeading'),bh=hd&&hd.getAttribute('data-bulk-heading');if(hd&&bh){hd.textContent=bh;}}
    /* stash context so the post-submit success page (a fresh load, query string gone) can echo it back */
    try{var stash={};if(h)stash.p=h;if(isBulk)stash.b=1;if(stash.p||stash.b)sessionStorage.setItem('tac_trade',JSON.stringify(stash));}catch(e){}
  })();

  /* Trade success: echo the bulk / project context the lead arrived with (sessionStorage from the PDP link),
     so the confirmation reflects what they sent. Guarded on #proSuccess → only the trade success state runs it. */
  (function(){var s=document.getElementById('proSuccess'),ex=s&&s.querySelector('[data-trade-extra]');if(!ex)return;
    try{var raw=sessionStorage.getItem('tac_trade');if(!raw)return;var d=JSON.parse(raw)||{};
      if(d.b){ex.textContent=' Logged as a bulk / project enquiry'+(d.p?' for '+d.p.replace(/-/g,' '):'')+'.';}
      sessionStorage.removeItem('tac_trade');}catch(e){}})();

  /* Cart → project quote: carry the basket into the trade form. On click, read /cart.js, build a
     "2× Product (variant)" summary, and hand it to the Professionals form via ?quote= (decoded there into
     contact[body]). Guarded on [data-cart-quote]; falls back to the plain link if the cart read fails. */
  (function(){var ql=document.querySelector('[data-cart-quote]');if(!ql)return;
    ql.addEventListener('click',function(e){e.preventDefault();var base=ql.getAttribute('href');
      fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){
        var all=(c.items||[]).map(function(it){var t=it.product_title||it.title||'',v=(it.variant_title&&it.variant_title.indexOf('Default')<0)?(' ('+it.variant_title+')'):'';return it.quantity+'× '+t+v;});
        var lines=all.slice(0,25);if(all.length>25){lines.push('…and '+(all.length-25)+' more');}  /* keep the ?quote= URL within safe length */
        var sep=base.indexOf('?')<0?'?':'&';location.href=base+sep+'quote='+encodeURIComponent(lines.join('\n'));
      }).catch(function(){location.href=base;});});})();
});

/* ---- Gift options (wrap SKU + printed gift note) — guarded; works in the drawer and on the cart page ---- */
document.addEventListener('DOMContentLoaded',function(){
  var blocks=document.querySelectorAll('.gift-opts');if(!blocks.length)return;
  function post(body){return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)});}
  /* re-render the drawer in place after a wrap add/remove; on the page cart there's no drawer, so reload to reflect the new line + totals */
  function refresh(){if(window.tacRefreshCartDrawer){window.tacRefreshCartDrawer();return;}location.reload();}
  /* express "add free wrap" chip — visible only when wrap is genuinely free (subtotal ≥ threshold), it's flagged a gift, and the wrap isn't already in the cart (state from data-free/data-incart, kept fresh by tacGiftSync / server render) */
  function giftChip(g){var chip=g.querySelector('.gift-wrap-chip');if(!chip)return;
    var wid=parseInt(g.getAttribute('data-wrap-id'),10)||0,free=g.getAttribute('data-free')==='true',inCart=g.getAttribute('data-incart')==='true',is=g.querySelector('.gift-is'),isGift=is?is.checked:false;
    chip.hidden=!(wid&&free&&isGift&&!inCart);}
  blocks.forEach(function(g){
    var wid=parseInt(g.getAttribute('data-wrap-id'),10)||0,
        cb=g.querySelector('.gift-wrap-cb'),
        is=g.querySelector('.gift-is'),
        chip=g.querySelector('.gift-wrap-chip'),
        msgWrap=g.querySelector('.gift-msg-wrap'),
        msg=g.querySelector('.gift-msg'),
        cnt=g.querySelector('.gift-msg-count'),
        rcpt=g.querySelector('.gift-rcpt'),
        busy=false,GKEY='tac_gift';
    function setCount(){if(cnt&&msg)cnt.textContent=(msg.value.length||0)+'/200';}
    /* remember the gift intent locally so a re-opened cart restores it instantly, before the server attribute round-trips */
    function gstore(){try{localStorage.setItem(GKEY,JSON.stringify({g:!!(is&&is.checked),r:!!(rcpt&&rcpt.checked)}));}catch(_){}}
    /* gift receipt → cart attribute (so fulfilment prints the slip without prices) */
    if(rcpt){rcpt.addEventListener('change',function(){post({attributes:{'Gift receipt':rcpt.checked?'Yes':''}}).catch(function(){});gstore();});}
    /* gift-wrap SKU add / remove */
    if(cb&&wid){cb.addEventListener('change',function(){
      if(busy){cb.checked=!cb.checked;return;}busy=true;cb.disabled=true;
      var done=function(){busy=false;cb.disabled=false;refresh();};
      if(cb.checked){
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:wid,quantity:1}]})}).then(done,done);
      }else{
        fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){
          var ln=0;(c.items||[]).forEach(function(it,i){if(it.variant_id===wid)ln=i+1;});
          if(!ln){done();return;}
          fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:ln,quantity:0})}).then(done,done);
        },done);
      }
    });}
    /* one-tap express path: add the free wrap (reuses the wrap-checkbox handler) */
    if(chip&&cb){chip.addEventListener('click',function(){if(cb.disabled)return;cb.checked=true;cb.dispatchEvent(new Event('change'));chip.hidden=true;});}
    /* "this is a gift" flag → reveals the message + stores the cart attribute */
    if(is){is.addEventListener('change',function(){
      if(msgWrap)msgWrap.hidden=!is.checked;
      post({attributes:{'Gift':is.checked?'Yes':''}}).catch(function(){});
      giftChip(g);gstore();
      if(is.checked&&msg)msg.focus();
    });}
    /* printed gift message → debounced cart attribute (also flips the gift flag on when the shopper types one) */
    if(msg){var t;msg.addEventListener('input',function(){setCount();clearTimeout(t);t=setTimeout(function(){
      var v=msg.value;post({attributes:{'Gift message':v,'Gift':v?'Yes':(is&&is.checked?'Yes':'')}}).catch(function(){});
      if(v&&is&&!is.checked){is.checked=true;if(msgWrap)msgWrap.hidden=false;gstore();}
    },650);});setCount();}
    /* one-tap message starters → fill the textarea and save (reuses the input handler above) */
    if(msg)g.querySelectorAll('.gift-preset').forEach(function(p){p.addEventListener('click',function(){msg.value=p.textContent.trim();msg.dispatchEvent(new Event('input'));msg.focus();});});
    /* restore the remembered gift intent (and re-persist to the cart so it stays truthful at checkout) — runs before any server sync, so no flicker */
    (function(){var st=null;try{st=JSON.parse(localStorage.getItem(GKEY)||'null');}catch(_){}
      if(!st)return;
      if(is&&st.g&&!is.checked){is.checked=true;if(msgWrap)msgWrap.hidden=false;post({attributes:{'Gift':'Yes'}}).catch(function(){});}
      if(rcpt&&st.r&&!rcpt.checked){rcpt.checked=true;post({attributes:{'Gift receipt':'Yes'}}).catch(function(){});}
      giftChip(g);
    })();
  });
  /* the drawer pushes fresh cart state here after any change so the wrap toggle + free/paid label stay truthful */
  window.tacGiftSync=function(cart){
    document.querySelectorAll('.gift-opts').forEach(function(g){
      var wid=parseInt(g.getAttribute('data-wrap-id'),10)||0;if(!wid)return;
      var cb=g.querySelector('.gift-wrap-cb'),pr=g.querySelector('.gift-wrap-price'),
          thr=parseInt(g.getAttribute('data-threshold'),10)||0,
          wprice=parseInt(g.getAttribute('data-wrap-price'),10)||0,
          inCart=false,merch=0;
      (cart.items||[]).forEach(function(it){if(it.variant_id===wid)inCart=true;else merch+=it.final_line_price;});
      if(cb&&!cb.disabled)cb.checked=inCart;
      var free=thr>0&&merch>=thr;
      if(pr){var m=window.tacMoney?window.tacMoney(wprice):'';
        pr.classList.toggle('gift-wrap-free',free);
        pr.innerHTML=free?('<s>'+m+'</s> Free'):m;}
      g.setAttribute('data-free',free?'true':'false');g.setAttribute('data-incart',inCart?'true':'false');
      giftChip(g);
    });
  };
});

/* ---- Mirror Finder quiz (list-builder #6) — guarded ---- */
document.addEventListener('DOMContentLoaded',function(){
  var q=document.getElementById('mirrorQuiz');if(!q)return;
  var steps=Array.prototype.slice.call(q.querySelectorAll('.quiz-step')),
      prog=q.querySelector('.quiz-prog-fill'),
      KEY='tac_quiz',
      qCount=q.querySelectorAll('.quiz-opts').length,   /* number of question steps */
      resultIdx=steps.length-1,
      ans={};
  try{ans=JSON.parse(localStorage.getItem(KEY))||{};}catch(e){ans={};}
  function save(){try{localStorage.setItem(KEY,JSON.stringify(ans));}catch(_){}}
  /* shareable result: answers <-> ?m=place-use-shape-style so an emailed/copied link deep-links the match (no localStorage needed).
     QKEYS is the POSITIONAL contract for ?m= AND the match: customer tag — it's derived from the rendered .quiz-opts order so
     reordering/adding questions keeps encode↔decode in sync automatically (no hidden constant to forget). Caveat inherent to any
     positional scheme: a link generated by an OLDER deploy can still decode wrong after a reorder — bump a version prefix if that matters. */
  var SIZE={powder:'20–24" compact',single:'24–32"',double:'40"+ or a pair'};
  var QKEYS=Array.prototype.map.call(q.querySelectorAll('.quiz-opts'),function(b){return b.getAttribute('data-key');});
  function encodeAns(){return QKEYS.map(function(k){return ans[k]||'';}).join('-');}
  function parseM(m){var p=String(m).split('-'),o={};
    QKEYS.forEach(function(k,i){if(p[i])o[k]=p[i];});if(o.place)o._size=SIZE[o.place]||'';return o;}
  function setM(val){try{var u=new URL(location.href);if(val)u.searchParams.set('m',val);else u.searchParams.delete('m');history.replaceState(null,'',u.toString());}catch(_){}}
  function go(i){
    steps.forEach(function(s){s.hidden=true;});
    var s=steps[i];if(!s)return;s.hidden=false;
    if(prog)prog.style.width=Math.min(100,Math.round(i/qCount*100))+'%';
    if(i>0){var f=s.querySelector('.quiz-opt,input,button');if(f&&f.focus)try{f.focus({preventScroll:true});}catch(_){}}
  }
  function useText(u){return {makeup:'makeup & grooming',shaving:'shaving',ambiance:'everyday light & ambiance'}[u]||'your routine';}
  /* Hand the quiz's bathroom-type answer to the shared vanity-width store: powder→22, single-sink→28,
     double→48. Published (not just written), so it also fires tac:vanity and moves any mounted width
     slider — every quiz-taker instantly gets "Best fit" badges on collections, a size finder already on
     their number, and a pre-filled buy-box fit check. The quiz asks for a ROOM, not a width, on purpose:
     it's a 4-tap funnel, and the two tools that want an exact number both offer the slider. */
  function writeQuizWidth(){var W={powder:22,single:28,double:48},pw=ans.place&&W[ans.place];if(pw&&window.tacPublishVanityW)window.tacPublishVanityW(pw,'quiz');}
  function qesc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function renderResult(){
    var shape=ans.shape||'',names={rectangle:'Rectangle',round:'Round',oval:'Oval',cabinet:'Medicine cabinet'};
    var nm=(names[shape]||'Your LED mirror')+(ans._size?' · '+ans._size:'');
    var url=(shape&&q.getAttribute('data-url-'+shape))||'';if(!url)url=q.getAttribute('data-fallback')||'/collections/all';
    var why='Based on your answers, this is the cleanest fit'+(ans.use?' for '+useText(ans.use):'')+'. Free US shipping, 1-year warranty and 30-day returns on every order.';
    var nEl=document.getElementById('quizResultName'),wEl=document.getElementById('quizResultWhy'),cEl=document.getElementById('quizResultCta');
    if(nEl)nEl.textContent=nm;if(wEl)wEl.textContent=why;if(cEl)cEl.setAttribute('href',url);
    /* recommended product card (if the merchant set one for this shape) → one-tap add */
    var prods=null,pEl=document.getElementById('quizProducts');try{prods=pEl?JSON.parse(pEl.textContent):null;}catch(_){}
    var pr=prods&&prods[shape],cardEl=document.getElementById('quizResultCard');
    if(pr&&cardEl){
      var ph=pr.image?'<img src="'+qesc(pr.image)+'" alt="'+qesc(pr.title)+'" loading="lazy" width="480" height="600" onerror="cardFail(this)">':'';
      var add=pr.available?'<button type="button" class="add qadd" data-qadd="'+qesc(pr.vid)+'" aria-label="Add '+qesc(pr.title)+' to cart">Add to cart</button>':'<a class="add" href="'+qesc(pr.url)+'">View</a>';
      cardEl.innerHTML='<article class="card quiz-pcard"><a class="card-link" href="'+qesc(pr.url)+'" aria-label="'+qesc(pr.title)+'"></a>'+
        '<div class="ph">'+ph+'<div class="fb"><div class="ring"></div></div></div>'+
        '<div class="body">'+(pr.type?'<span class="shape">'+qesc(pr.type)+'</span>':'')+'<h3>'+qesc(pr.title)+'</h3>'+
        '<div class="foot"><span class="price">'+qesc(pr.price)+'</span>'+add+'</div></div></article>';
      cardEl.hidden=false;
      if(cEl){cEl.setAttribute('href',url);cEl.innerHTML='Browse '+(names[shape]||'all').toLowerCase()+' mirrors <span class="arr">&rarr;</span>';cEl.classList.remove('btn-dark');cEl.classList.add('btn-ghost');}
    } else if(cardEl){cardEl.hidden=true;cardEl.innerHTML='';}
    writeQuizWidth();   /* deep-link / posted-result path: the click handler didn't run, so write here too */
  }
  /* option pick → record + auto-advance */
  q.addEventListener('click',function(e){
    var opt=e.target.closest('.quiz-opt');
    if(opt){var box=opt.closest('.quiz-opts'),key=box.getAttribute('data-key');
      box.querySelectorAll('.quiz-opt').forEach(function(b){b.classList.remove('sel');b.setAttribute('aria-pressed','false');});
      opt.classList.add('sel');opt.setAttribute('aria-pressed','true');
      ans[key]=opt.getAttribute('data-val');
      if(opt.getAttribute('data-size'))ans._size=opt.getAttribute('data-size');
      if(key==='place')writeQuizWidth();   /* activate fit badges as soon as they pick a bathroom type — even if they never reach the email gate */
      save();
      var idx=steps.indexOf(opt.closest('.quiz-step')),nx=idx+1;
      setTimeout(function(){if(nx===resultIdx){renderResult();setM(encodeAns());}go(nx);},170);return;}   /* last answer → the match, no email gate */
    var back=e.target.closest('[data-back]');
    if(back){var bi=steps.indexOf(back.closest('.quiz-step'));if(bi>0)go(bi-1);return;}
    if(e.target.closest('[data-quiz-restart]')){ans={};save();setM('');go(0);return;}
  });
  /* email gate → stamp answers as tags, then let the customer form POST */
  var form=q.querySelector('.quiz-form');
  if(form){form.addEventListener('submit',function(){
    var tags=['newsletter','quiz'];
    QKEYS.forEach(function(k){if(ans[k])tags.push(k+':'+ans[k]);});
    /* full match as one tag so a welcome email/flow can rebuild the deep link: site/?m={value-after-the-colon} */
    if(QKEYS.some(function(k){return ans[k];}))tags.push('match:'+encodeAns());
    var t=document.getElementById('quizTags');if(t)t.value=tags.join(', ');
    save();
  });}
  /* load: a shared ?m= link shows the match directly; else after the form posts (marker) show the result + stamp a shareable URL */
  var mParam=null;try{mParam=new URLSearchParams(location.search).get('m');}catch(_){}
  var posted=!!q.querySelector('[data-quiz-posted]')||/[?&]customer_posted=true/.test(location.search);
  if(mParam){ans=parseM(mParam);renderResult();go(resultIdx);}
  else if(posted){renderResult();go(resultIdx);setM(encodeAns());}
  else{go(0);}
});

/* ---- Collection mobile filter disclosure — toggle the "Filter & refine" panel (guarded; the button is CSS-shown only on ≤640px). Remembers the open state for the session so it doesn't re-collapse on every collection nav. ---- */
document.addEventListener('DOMContentLoaded',function(){
  var btn=document.querySelector('.col-refine-toggle'),panel=document.getElementById('colRefine');
  if(!btn||!panel)return;
  var KEY='tacFiltersOpen';
  try{if(sessionStorage.getItem(KEY)==='1'){panel.classList.add('open');btn.setAttribute('aria-expanded','true');}}catch(_){}
  btn.addEventListener('click',function(){
    var open=panel.classList.toggle('open');
    btn.setAttribute('aria-expanded',open?'true':'false');
    try{sessionStorage.setItem(KEY,open?'1':'0');}catch(_){}
  });
});

/* ---- PDP buy-box fit line — passive "Best for vanities X″ and wider" from the selected variant width; works whether or not the nudge is enabled ---- */
document.addEventListener('DOMContentLoaded',function(){
  var line=document.querySelector('.pdp-fitline'),listEl=document.querySelector('.pdp-sizefit');
  if(!line&&!listEl)return;
  var vg=document.getElementById('pdpVariants');
  function lbl(b){var s=b&&b.querySelector('.pvar-name');return s?(s.textContent||''):'';}
  function curSrc(){
    if(vg){var b=vg.querySelector('.pvar.active')||vg.querySelector('.pvar[aria-pressed="true"]');if(b)return lbl(b);}
    var h=document.querySelector('.pdp-info h1');return h?(h.textContent||''):'';
  }
  function storedW(){return tacReadVanityW();}
  /* P1+P2 — the passive fit line; personalizes to the remembered vanity width when one exists */
  function render(){
    if(!line)return;
    var w=tacParseInches(curSrc());if(!w){line.hidden=true;return;}
    var sw=storedW(),yrs=tacVanityPhrase();   /* same rule as the fit card + card badges */
    if(sw){
      if(sw>=w){var side=Math.round((sw-w)/2*10)/10;line.textContent=side>0?'✓ Fits '+yrs+sw+'″ vanity — about '+side+'″ each side':'✓ Fits '+yrs+sw+'″ vanity';}
      else line.textContent='⚠ Tight for '+yrs+sw+'″ vanity — this size suits '+(Math.round(w)+4)+'″+';
    }else line.textContent='Best for vanities '+(Math.round(w)+4)+'″ and wider';
    line.classList.toggle('personal',!!sw);line.hidden=false;
  }
  /* P1 — one row per variant with its fit range, current size highlighted (hidden for single-size products) */
  function renderList(){
    if(!listEl||!vg)return;
    var btns=vg.querySelectorAll('.pvar'),rows=[];
    for(var i=0;i<btns.length;i++){var w=tacParseInches(lbl(btns[i]));if(w)rows.push({w:w,on:btns[i].classList.contains('active')});}
    if(rows.length<2){listEl.hidden=true;return;}
    listEl.innerHTML='';
    rows.forEach(function(r){var li=document.createElement('li');li.className='pdp-sizefit-row'+(r.on?' on':'');
      li.innerHTML='<span class="pdp-sizefit-w">'+r.w+'″</span><span class="pdp-sizefit-r">fits '+(Math.round(r.w)+4)+'″+ vanities</span>';listEl.appendChild(li);});
    listEl.hidden=false;
  }
  function refresh(){render();renderList();}
  if(vg)vg.addEventListener('click',function(e){if(e.target.closest('.pvar'))refresh();});
  window.tacFitlineRefresh=render;        /* let the nudge width field repaint the line live as the shopper types */
  refresh();
});

/* ---- PDP spec sheet — keep the Size row in sync with the selected variant (the one spec that varies by variant) ---- */
document.addEventListener('DOMContentLoaded',function(){
  var sizeEl=document.getElementById('pdpSpecSize'),vg=document.getElementById('pdpVariants');
  if(!sizeEl||!vg)return;
  vg.addEventListener('click',function(e){var b=e.target.closest('.pvar');if(!b)return;var nm=b.querySelector('.pvar-name');if(nm)sizeEl.textContent=(nm.textContent||'').trim();});
});

/* ---- PDP dimensioned drawing — a to-scale W×H sketch of the SELECTED size (#pdpDim, shape from data-shape).
        Parses the W/T labels from the variant title (`20''W x 28''T`), NEVER digit order. Only numbers reach
        innerHTML. Redraws from the clicked tile's own label so it can't race the .active class swap. ---- */
document.addEventListener('DOMContentLoaded',function(){
  var fig=document.getElementById('pdpDim'),svg=document.getElementById('pdpDimSvg'),cap=document.getElementById('pdpDimCap');
  if(!fig||!svg)return;
  var vg=document.getElementById('pdpVariants'),shape=fig.getAttribute('data-shape')||'rectangle';
  function activeLabel(){
    if(vg){var b=vg.querySelector('.pvar.active')||vg.querySelector('.pvar[aria-pressed="true"]');var s=b&&b.querySelector('.pvar-name');if(s)return s.textContent||'';}
    var el=document.getElementById('pdpSpecSize');return el?(el.textContent||''):'';
  }
  function dims(src){
    src=src||'';var w=0,h=0,m=src.match(/(\d+(?:\.\d+)?)\s*(?:''|″|"|”)?\s*W/i);if(m)w=parseFloat(m[1]);
    m=src.match(/(\d+(?:\.\d+)?)\s*(?:''|″|"|”)?\s*[TH]/i);if(m)h=parseFloat(m[1]);
    if(!w||!h){m=src.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i);if(m){w=w||parseFloat(m[1]);h=h||parseFloat(m[2]);}}
    if(w&&!h&&shape==='round')h=w;   /* round sizes are often a single diameter */
    return {w:w,h:h};
  }
  /* ONE px-per-inch shared by every size on this product, so a 24″ mirror actually draws smaller than
     a 32″ one. Fitting each drawing to the box independently made every variant render identically
     (24×24 and 32×32 both landed at r=84) and only the caption moved — which reads as "the picture is
     decorative". Derived from the widest AND the tallest variant (they can be different tiles, e.g.
     20×28 next to 40×24), so the largest size still fits the 210×168 box. Computed once; falls back to
     the old per-drawing fit when no tile parses, so a single-variant PDP is unchanged. */
  var sharedS=0;
  function scaleFor(d){
    if(sharedS)return sharedS;
    var mw=0,mh=0;
    if(vg)[].forEach.call(vg.querySelectorAll('.pvar .pvar-name'),function(n){
      var v=dims(n.textContent||'');if(v.w>mw)mw=v.w;if(v.h>mh)mh=v.h;});
    if(mw>0&&mh>0)sharedS=Math.min(210/mw,168/mh);
    return sharedS||Math.min(210/d.w,168/d.h);
  }
  function draw(label){
    var d=dims(label);
    if(!(d.w>0&&d.h>0)){fig.hidden=true;return;}
    var maxW=210,maxH=168,s=scaleFor(d),mw=d.w*s,mh=d.h*s;
    var x=30+(maxW-mw)/2,y=14+(maxH-mh)/2,bY=y+mh+20,rX=x+mw+20,el;
    if((shape==='round'||shape==='oval')&&Math.abs(mw-mh)<0.5)el='<circle class="dim-shape" cx="'+(x+mw/2)+'" cy="'+(y+mh/2)+'" r="'+(mw/2)+'"/>';
    else if(shape==='round'||shape==='oval')el='<ellipse class="dim-shape" cx="'+(x+mw/2)+'" cy="'+(y+mh/2)+'" rx="'+(mw/2)+'" ry="'+(mh/2)+'"/>';
    else el='<rect class="dim-shape" x="'+x+'" y="'+y+'" width="'+mw+'" height="'+mh+'" rx="'+Math.min(10,mw*0.06)+'"/>';
    svg.innerHTML=el
      +'<line class="dim-line" x1="'+x+'" y1="'+bY+'" x2="'+(x+mw)+'" y2="'+bY+'"/>'
      +'<line class="dim-line" x1="'+x+'" y1="'+(bY-5)+'" x2="'+x+'" y2="'+(bY+5)+'"/>'
      +'<line class="dim-line" x1="'+(x+mw)+'" y1="'+(bY-5)+'" x2="'+(x+mw)+'" y2="'+(bY+5)+'"/>'
      +'<text class="dim-txt" x="'+(x+mw/2)+'" y="'+(bY+17)+'" text-anchor="middle">'+d.w+'″</text>'
      +'<line class="dim-line" x1="'+rX+'" y1="'+y+'" x2="'+rX+'" y2="'+(y+mh)+'"/>'
      +'<line class="dim-line" x1="'+(rX-5)+'" y1="'+y+'" x2="'+(rX+5)+'" y2="'+y+'"/>'
      +'<line class="dim-line" x1="'+(rX-5)+'" y1="'+(y+mh)+'" x2="'+(rX+5)+'" y2="'+(y+mh)+'"/>'
      +'<text class="dim-txt" x="'+(rX+9)+'" y="'+(y+mh/2+4)+'">'+d.h+'″</text>';
    if(cap)cap.textContent='Drawn to scale — '+d.w+'″ wide × '+d.h+'″ tall';
    fig.hidden=false;
  }
  if(vg)vg.addEventListener('click',function(e){var b=e.target.closest('.pvar');if(!b)return;var s=b.querySelector('.pvar-name');draw(s?(s.textContent||''):activeLabel());});
  draw(activeLabel());
});

/* ---- PDP "Ask an expert" proactive nudge — guarded; slides in after a delay, dismiss persists for the session ---- */
document.addEventListener('DOMContentLoaded',function(){
  var n=document.getElementById('pdpExpert');if(!n)return;
  var seen=false;try{seen=sessionStorage.getItem('tacExpertSeen')==='1';}catch(_){}
  var delay=parseInt(n.getAttribute('data-delay'),10);if(!(delay>=5))delay=45;
  var done=false,t=null;
  function remember(){try{sessionStorage.setItem('tacExpertSeen','1');}catch(_){}}
  function stopTimer(){if(t){clearTimeout(t);t=null;}}
  /* One bottom-left card per SESSION: whichever of this and the welcome slide-in opens first claims
     sessionStorage tacOverlay, and the other stays closed for the rest of the visit (the welcome IIFE checks
     the same key). Only the automatic reveals are gated — the "?" launcher is the shopper asking. */
  function slot(){try{return sessionStorage.getItem('tacOverlay')||'';}catch(_){return '';}}
  function reveal(){done=true;stopTimer();n.classList.remove('mini');n.classList.add('show');n.setAttribute('aria-hidden','false');}
  function show(){if(done)return;var o=slot(),wp=document.getElementById('welcomePop');
    if((o&&o!=='expert')||(wp&&wp.classList.contains('is-open'))){done=true;stopTimer();return;}
    try{sessionStorage.setItem('tacOverlay','expert');}catch(_){}reveal();}
  /* P2 — collapse to a re-openable "?" bubble instead of vanishing: stays reachable, just stops nagging */
  function minimize(){stopTimer();n.classList.add('show','mini');n.setAttribute('aria-hidden','false');remember();}
  var x=n.querySelector('[data-expert-close]'),opener=n.querySelector('.pdp-expert-open');
  if(x)x.addEventListener('click',minimize);
  if(opener)opener.addEventListener('click',reveal);
  /* stand aside while the in-page Add to cart (.atc-in) or the gallery thumbnails (.thumbs-in) are on screen —
     theme.css decides where each applies (thumbs only on ≤900px, where the gallery isn't sticky). A rect check on
     scroll, not an IntersectionObserver: IO lags a frame or more, long enough to flash the card over the button
     (and pdp_overlay_qa.mjs caught it stale). Scroll events are frame-aligned, so this is one read per frame. */
  var aside=[['.pdp-atc','atc-in'],['.pdp-thumbs','thumbs-in']].map(function(k){return [document.querySelector(k[0]),k[1]];}).filter(function(g){return g[0];});
  function standAside(){for(var i=0;i<aside.length;i++){var r=aside[i][0].getBoundingClientRect();n.classList.toggle(aside[i][1],r.width>0&&r.bottom>0&&r.top<innerHeight);}}
  if(aside.length){addEventListener('scroll',standAside,{passive:true});addEventListener('resize',standAside);standAside();}
  /* tapping a link CTA counts as engaged this session */
  Array.prototype.forEach.call(n.querySelectorAll('a[href]'),function(a){a.addEventListener('click',remember);});

  /* P1 — variant- & vanity-width-aware email: rewrite the mailto with the selected size/finish + entered width (mailto mode only) */
  var ask=n.querySelector('.pdp-expert-ask'),vg=document.getElementById('pdpVariants'),wIn=n.querySelector('.pdp-expert-win');
  var rm=matchMedia('(prefers-reduced-motion:reduce)').matches,panel=n.querySelector('.pdp-expert-answer'),chips=n.querySelectorAll('.pdp-expert-chip');
  function pvarLabel(b){var s=b&&b.querySelector('.pvar-name');return s?(s.textContent||'').trim():'';}
  function activeLabel(){if(!vg)return '';return pvarLabel(vg.querySelector('.pvar.active')||vg.querySelector('.pvar[aria-pressed="true"]'));}
  function syncAsk(label){
    if(!ask||!ask.getAttribute('data-ask-email'))return;        /* contact-URL/no-mailto mode: leave href as rendered */
    var subj=ask.getAttribute('data-ask-subject')||'',body=ask.getAttribute('data-ask-body')||'';
    var v=label!=null?label:activeLabel();
    if(v){subj+=' — '+v;body+='\n\nThe option I’m looking at: '+v;}
    var w=wIn&&wIn.value?wIn.value.trim():'';
    if(w)body+='\nMy vanity width: '+w+' in';
    ask.href='mailto:'+ask.getAttribute('data-ask-email')+'?subject='+encodeURIComponent(subj)+'&body='+encodeURIComponent(body);
  }
  if(vg)vg.addEventListener('click',function(e){var b=e.target.closest('.pvar');if(b){syncAsk(pvarLabel(b));fitVerdict();}});

  /* P2 — carry the entered vanity width onto the order as a line-item property. Synced to the hidden
     form input (#pdpVanityProp): enabled+valued when a width is set, disabled otherwise. The generic
     window.tacItemProps (defined in the product-form block) reads this input on the AJAX add path. */
  var vProp=document.getElementById('pdpVanityProp');
  function widthVal(){var w=wIn&&wIn.value?wIn.value.trim():'';return w?w+' in':'';}
  /* Route through tacFit.applyVanityProp so this field labels the width the same way the fit check does
     ("54 in (measured)"), instead of overwriting it with a bare number. A typed width is a stated one, so
     it's published as 'pdp' first — that also carries it to the sliders and the card badges. */
  function syncVanityProp(stated){
    var raw=wIn&&wIn.value?parseInt(wIn.value,10):0;
    /* stated=true only when the shopper TYPED here. The field is also pre-filled from the store on
       load, and publishing that back re-tagged the provenance as 'pdp' — promoting a quiz guess to a
       measurement on every PDP load and undoing the "a typical N″ vanity" wording site-wide. */
    if(stated&&raw>0&&window.tacPublishVanityW)window.tacPublishVanityW(raw,'pdp');
    if(window.tacFit&&window.tacFit.applyVanityProp){window.tacFit.applyVanityProp(raw>0?raw:0);return;}
    var v=widthVal();if(vProp){if(v){vProp.value=v;vProp.disabled=false;}else{vProp.value='';vProp.disabled=true;}}
  }

  /* P1 — instant fit verdict; when too wide, offer a one-tap switch to the largest variant that fits (recommend-and-switch) */
  function mirrorWidth(){return tacParseInches(activeLabel()||(document.querySelector('.pdp-info h1')&&document.querySelector('.pdp-info h1').textContent)||'');}
  function bestFit(v){
    if(!vg)return null;var best=null,bestW=0,btns=vg.querySelectorAll('.pvar');
    for(var i=0;i<btns.length;i++){if(btns[i].classList.contains('soldout'))continue;
      var w=tacParseInches(pvarLabel(btns[i]));if(w&&w<=v&&w>bestW){bestW=w;best=btns[i];}}
    return (best&&!best.classList.contains('active'))?best:null;
  }
  function clearVerdict(){if(panel&&panel.dataset.kind==='verdict'){panel.hidden=true;panel.removeAttribute('data-kind');}}
  function fitVerdict(){
    if(!panel)return;
    var v=parseFloat(wIn&&wIn.value);
    if(!(v>0)){clearVerdict();return;}
    var mw=mirrorWidth();if(!mw){clearVerdict();return;}
    panel.innerHTML='';panel.dataset.kind='verdict';panel.hidden=false;
    var msg=document.createElement('div');
    if(v>=mw){var side=Math.round((v-mw)/2*10)/10;msg.textContent=side>0?'✓ Fits — about '+side+'″ clearance each side':'✓ Fits edge-to-edge';panel.appendChild(msg);}
    else{
      msg.textContent='⚠ Wider than your vanity by '+(Math.round((mw-v)*10)/10)+'″ — consider sizing down';panel.appendChild(msg);
      var alt=bestFit(v);
      if(alt){var sb=document.createElement('button');sb.type='button';sb.className='pdp-expert-switch';sb.textContent='Switch to '+tacParseInches(pvarLabel(alt))+'″ →';
        sb.addEventListener('click',function(){alt.click();});panel.appendChild(sb);}   /* the .pvar click re-runs syncAsk + fitVerdict via the variant listener */
    }
    Array.prototype.forEach.call(chips,function(o){o.classList.remove('on');});
  }
  /* P3 — remember the shopper's width across products this session */
  if(wIn){var svw=tacReadVanityW();if(svw)wIn.value=svw;}
  /* typing here IS a statement — syncVanityProp(true) publishes it (write + sliders + broadcast). The bare
     tacWriteVanityW that used to run here passed no source, which wiped the provenance tag. */
  if(wIn)wIn.addEventListener('input',function(){syncAsk();syncVanityProp(true);fitVerdict();if(window.tacFitlineRefresh)window.tacFitlineRefresh();});
  syncAsk();syncVanityProp();fitVerdict();                       /* seed only — must NOT re-stamp provenance */

  /* P3 — "how to measure" toggletip beside the width field */
  var tipBtn=n.querySelector('.pdp-expert-tip'),tipTxt=n.querySelector('.pdp-expert-tiptext');
  if(tipBtn&&tipTxt)tipBtn.addEventListener('click',function(){var willShow=tipTxt.hidden;tipTxt.hidden=!willShow;tipBtn.setAttribute('aria-expanded',String(willShow));});

  /* quick-answer chips: render the matching FAQ answer inline (no scroll-away); fall back to scrolling the specs/FAQ heading */
  function findFaq(kw){
    var kws=kw.toLowerCase().split('|'),btns=document.querySelectorAll('.pdpfaq .faq button');
    for(var i=0;i<btns.length;i++){var txt=(btns[i].textContent||'').toLowerCase();
      for(var j=0;j<kws.length;j++){if(kws[j]&&txt.indexOf(kws[j])>-1)return btns[i];}}
    return null;
  }
  var chips=n.querySelectorAll('.pdp-expert-chip');
  Array.prototype.forEach.call(chips,function(c){c.addEventListener('click',function(){
    remember();
    if(c.classList.contains('on')){c.classList.remove('on');if(panel){panel.hidden=true;panel.removeAttribute('data-kind');}return;}   /* re-tap toggles the answer closed */
    var btn=findFaq(c.getAttribute('data-faq')||'');
    if(btn&&panel){
      var item=btn.closest('.faq'),ans=item&&item.querySelector('.ans'),q=btn.querySelector('span');
      panel.innerHTML='';
      var h=document.createElement('strong');h.textContent=(q?q.textContent:c.textContent).trim();panel.appendChild(h);
      if(ans){var d=document.createElement('div');d.innerHTML=ans.innerHTML;panel.appendChild(d);}  /* answer copied from the already-rendered on-page FAQ */
      panel.hidden=false;panel.dataset.kind='faq';
      Array.prototype.forEach.call(chips,function(o){o.classList.remove('on');});c.classList.add('on');
      return;
    }
    var tgt=document.querySelector('.pdpspec-h')||document.querySelector('.pdpfaq-h');   /* no on-page FAQ match → send them to the spec/FAQ */
    if(tgt)tgt.scrollIntoView({behavior:rm?'auto':'smooth',block:'start'});
  });});

  /* P2 — triggers: once dismissed this session, start minimized (but reachable); otherwise arm the timer + scroll-depth reveal */
  if(seen){minimize();return;}
  t=setTimeout(show,delay*1000);
  if('IntersectionObserver' in window){
    var marks=document.querySelectorAll('.pdpspec,.pdpfaq');
    if(marks.length){var io=new IntersectionObserver(function(es){for(var i=0;i<es.length;i++){if(es[i].isIntersecting){show();io.disconnect();return;}}},{rootMargin:'0px 0px -25% 0px'});
      Array.prototype.forEach.call(marks,function(m){io.observe(m);});}
  }
});

/* ---- PDP recently viewed — records this product in localStorage and renders the prior ones (excludes the current product); hidden until there's history ---- */
document.addEventListener('DOMContentLoaded',function(){
  var sec=document.querySelector('.pdp-recent');if(!sec)return;
  var grid=sec.querySelector('.pdp-recent-grid');if(!grid)return;
  var KEY='tacRV',MAX=8,cur=window.TAC_PV||null;
  function get(){try{return JSON.parse(localStorage.getItem(KEY))||[];}catch(_){return [];}}
  function set(a){try{localStorage.setItem(KEY,JSON.stringify(a));}catch(_){}}
  var list=get();
  if(cur&&cur.h){list=list.filter(function(it){return it&&it.h!==cur.h;});list.unshift(cur);if(list.length>MAX)list=list.slice(0,MAX);set(list);}
  var others=list.filter(function(it){return it&&it.h&&(!cur||it.h!==cur.h);}).slice(0,4);
  if(!others.length)return;
  others.forEach(function(it){grid.appendChild(tacBuildCard(it));});
  sec.hidden=false;
  if(window.tacApplyCardFit)tacApplyCardFit();   /* badge the freshly-built rail cards if a width is known */
});

/* ---- Save-for-later UI — delegated [data-save] toggle + heart repaint across PDP + every product card; all driven by the shared tacSaved store ---- */
document.addEventListener('DOMContentLoaded',function(){
  function objFromEl(el){var d=el.dataset,o={h:d.h,u:d.u,t:d.t,img:d.img,p:d.p,vid:d.vid,one:d.one==='true',ty:d.ty};if(d.img2)o.i2=d.img2;if(d.c)o.c=d.c;if(d.pc)o.pc=d.pc;if(d.sku)o.sku=d.sku;if(d.dim)o.dim=d.dim;if(d.cct)o.cct=d.cct;if(d.lum)o.lum=d.lum;if(d.mount)o.mount=d.mount;if(d.feat)o.feat=d.feat;return o;}
  function paintEl(el){var on=tacSavedHas(el.dataset.h);el.classList.toggle('on',on);el.setAttribute('aria-pressed',String(on));
    var ic=el.querySelector('[data-save-ic]');if(ic)ic.textContent=on?'♥':'♡';var t=el.querySelector('[data-save-t]');if(t)t.textContent=on?'Saved':'Save';}
  function paintAll(){Array.prototype.forEach.call(document.querySelectorAll('[data-save]'),paintEl);}
  document.addEventListener('click',function(e){var b=e.target.closest('[data-save]');if(!b)return;e.preventDefault();tacSavedToggle(objFromEl(b));});
  document.addEventListener('tac:saved',paintAll);
  paintAll();
});

/* ---- PDP saved count + inline saved-mirrors panel — reads the shared store, re-renders on 'tac:saved' ---- */
document.addEventListener('DOMContentLoaded',function(){
  var cnt=document.querySelector('.pdp-save-count'),panel=document.getElementById('pdpSavedPanel');
  if(!cnt&&!panel)return;
  function obj(x){return (typeof x==='string')?{h:x,u:'/products/'+x,t:x}:x;}
  /* wishlist-to-email capture (#pdpSavedEmail, Liquid-rendered) — surfaces at the save-confirmation
     moment (this product's heart is on, or the saved panel is open) so the shortlist survives the
     browser; submit stamps saved:<handle> tags like the Saved page's form (theme.js [data-saved-page]) */
  var em=document.getElementById('pdpSavedEmail');
  function paintEmail(a){if(!em)return;
    var heart=document.querySelector('.pdp-save[data-save]');
    var mine=heart?tacSavedHas(heart.dataset.h):false;
    em.hidden=!(a.length&&(mine||(panel&&!panel.hidden)));}
  var ef=document.getElementById('pdpSavedForm'),et=document.getElementById('pdpSavedTags');
  if(ef&&et)ef.addEventListener('submit',function(){
    var hs=tacSavedGet().map(function(x){return obj(x).h;}).filter(Boolean);
    et.value=(['newsletter','wishlist'].concat(hs.map(function(h){return 'saved:'+h;}))).join(', ');
    /* cross-device list link in the customer note — base path from the form's own return_to (the Saved page) */
    var en=document.getElementById('pdpSavedNote'),rt=ef.querySelector('[name="return_to"]');
    if(en)en.value=hs.length?('Saved mirrors: '+location.origin+((rt&&rt.value)||'/pages/saved')+'?ids='+hs.join(',')):'';});
  function renderPanel(){
    if(!panel)return;var a=tacSavedGet();panel.innerHTML='';
    if(!a.length){panel.hidden=true;if(cnt)cnt.setAttribute('aria-expanded','false');return;}
    var grid=document.createElement('div');grid.className='lineup pdp-saved-grid';
    a.forEach(function(it){var o=obj(it);
      var cell=document.createElement('div');cell.className='pdp-saved-cell';cell.setAttribute('data-h',o.h||'');cell.appendChild(tacBuildCard(o));
      var rm=document.createElement('button');rm.type='button';rm.className='pdp-saved-x';rm.setAttribute('aria-label','Remove '+(o.t||'')+' from saved');rm.textContent='×';
      rm.addEventListener('click',function(){tacSavedToggle(o);});cell.appendChild(rm);grid.appendChild(cell);
    });
    panel.appendChild(grid);
    tacSavedFlag(panel);   /* badge from the warm cache; the open handler below fetches the cold rest */
  }
  function paint(){var a=tacSavedGet();
    if(cnt){if(a.length){cnt.textContent=a.length+' saved';cnt.hidden=false;}else{cnt.hidden=true;if(panel)panel.hidden=true;}}
    if(panel&&!panel.hidden)renderPanel();
    paintEmail(a);
  }
  if(cnt&&panel)cnt.addEventListener('click',function(){var willOpen=panel.hidden;if(willOpen)renderPanel();panel.hidden=!willOpen;cnt.setAttribute('aria-expanded',String(willOpen));paintEmail(tacSavedGet());
    /* since-you-saved flags on open only — a PDP load never pays fetches for a panel nobody opens */
    if(willOpen){var repan=function(){if(!panel.hidden)tacSavedFlag(panel);};tacSavedRefresh(tacSavedGet().map(obj),repan,repan);}});
  document.addEventListener('tac:saved',paint);
  paint();
});

/* ---- Recovery-surface rails ([data-shortlist] on cart / empty search / 404) — "Pick up where you left off" from recently-viewed, falling back to saved; hidden with no history ---- */
document.addEventListener('DOMContentLoaded',function(){
  var secs=document.querySelectorAll('[data-shortlist]');if(!secs.length)return;
  function rv(){try{return JSON.parse(localStorage.getItem('tacRV'))||[];}catch(_){return [];}}
  function sv(){return window.tacSavedGet?tacSavedGet():[];}
  Array.prototype.forEach.call(secs,function(sec){
    var grid=sec.querySelector('.tac-shortlist-grid');if(!grid)return;
    var savedFirst=sec.getAttribute('data-shortlist')==='saved';   /* empty cart leads with the saved shortlist */
    var primary=savedFirst?sv():rv(),fallback=savedFirst?rv():sv();
    var items=primary.length?primary:fallback;
    var inCart=(sec.getAttribute('data-incart')||'').split(',').filter(Boolean);   /* don't suggest what's already in the cart */
    items=items.filter(function(it){return it&&typeof it==='object'&&it.h&&inCart.indexOf(it.h)<0;}).slice(0,4);
    if(!items.length)return;
    items.forEach(function(it){grid.appendChild(tacBuildCard(it));});
    sec.hidden=false;
  });
});

/* ---- Page cart: quantity steppers that update themselves + a phone-only sticky checkout bar ----
   The cart form posts natively (Shopify reloads /cart with new totals), so a stepper or a typed quantity
   just submits the form's Update after a short pause — no Update click needed. The sticky bar shows on
   phones while the order summary (subtotal + Checkout) is scrolled out of view. */
document.addEventListener('DOMContentLoaded',function(){
  var form=document.getElementById('cartPageForm');if(!form)return;
  var upd=form.querySelector('.cart-update'),t=null;
  function submitSoon(){clearTimeout(t);t=setTimeout(function(){form.classList.add('is-updating');
    if(form.requestSubmit&&upd)form.requestSubmit(upd);else{var h=document.createElement('input');h.type='hidden';h.name='update';h.value='1';form.appendChild(h);form.submit();}},450);}
  form.addEventListener('click',function(e){var b=e.target.closest('[data-cqstep]');if(!b)return;
    var inp=b.parentNode.querySelector('input[name="updates[]"]');if(!inp)return;
    inp.value=Math.max(0,(parseInt(inp.value,10)||0)+parseInt(b.getAttribute('data-cqstep'),10));submitSoon();});
  form.addEventListener('change',function(e){if(e.target.matches('input[name="updates[]"]'))submitSoon();});
  var bar=form.querySelector('[data-cart-stickybar]'),sum=document.getElementById('cartSummary');
  if(bar&&sum&&window.IntersectionObserver&&window.matchMedia){
    var mq=window.matchMedia('(max-width:899px)');
    new IntersectionObserver(function(es){es.forEach(function(en){bar.hidden=!mq.matches||en.isIntersecting;});},{threshold:0}).observe(sum);
  }
});

/* ---- Search size-gap note ([data-size-gap]) — query asks for a width no result comes in ---- */
document.addEventListener('DOMContentLoaded',function(){
  var el=document.querySelector('[data-size-gap]');if(!el)return;
  var q=(el.getAttribute('data-q')||'').toLowerCase();
  var m=q.match(/(\d{2})(?:\.\d)?\s*(?:-|\s)?(?:inch(?:es)?|in\b|"|″|”|'')/)||q.match(/^\s*(\d{2})\s*$/)||q.match(/\b(\d{2})\b(?=.*\b(?:round|oval|rectangle|mirror|cabinet)\b)/);
  if(!m)return;
  var want=parseInt(m[1],10);if(!(want>=12&&want<=96))return;
  var shape=(q.match(/\b(round|oval|rectangle|rectangular|cabinet|full.?length)\b/)||[])[1]||'';
  if(shape==='rectangular')shape='rectangle';
  /* Shape in the query → only that shape's results count, else a 40″ rectangle hides a 36″-round gap.
     Titles reliably name round/oval/cabinet/full-length; many rectangles don't say "rectangle", so those use every result. */
  var shapeRe={round:/\bround\b/i,oval:/\boval\b/i,cabinet:/cabinet/i}[shape]||(/^full/.test(shape)?/full.?length|dressing/i:null);
  var max=0;document.querySelectorAll('.shop-grid .card[data-sizes]').forEach(function(c){
    if(shapeRe){var h=c.querySelector('h3');if(!h||!shapeRe.test(h.textContent))return;}
    (c.getAttribute('data-sizes')||'').split('|').forEach(function(x){var n=parseFloat(x);if(n>max)max=n;});});
  if(!max||want<=max)return;
  el.textContent='We don’t make a '+want+'″'+(shape?' '+shape:'')+' mirror — '+max+'″ is the largest'+(shape?' '+shape:'')+' we carry. Here are the closest sizes.';
  el.hidden=false;
});

/* ---- Saved mirrors page ([data-saved-page]) — own wishlist (with Share) OR a shared list hydrated from ?ids= via /products/{handle}.js ---- */
document.addEventListener('DOMContentLoaded',function(){
  var root=document.querySelector('[data-saved-page]');if(!root)return;
  var grid=root.querySelector('.saved-page-grid'),empty=root.querySelector('.saved-page-empty'),
      actions=document.querySelector('[data-saved-actions]'),shareBtn=document.querySelector('[data-saved-share]'),
      sharedBox=document.querySelector('[data-saved-shared]'),saveAllBtn=document.querySelector('[data-saved-saveall]');
  function obj(x){return (typeof x==='string')?{h:x,u:'/products/'+x,t:x}:x;}
  function sharedIds(){try{return (new URLSearchParams(location.search).get('ids')||'').split(',').map(function(s){return s.trim();}).filter(Boolean);}catch(_){return [];}}
  function fmt(c){return window.tacMoney?tacMoney(c):'$'+(c/100).toFixed(2);}
  function toCard(p){var img=p.featured_image||'';if(img.indexOf('//')===0)img='https:'+img;
    var on=p.compare_at_price&&p.compare_at_price>p.price,o={h:p.handle,u:p.url||('/products/'+p.handle),t:p.title,img:img,p:fmt(p.price),pc:p.price,vid:(p.variants&&p.variants[0]&&p.variants[0].id),one:(p.variants&&p.variants.length===1),ty:p.type};if(on)o.c=fmt(p.compare_at_price);return o;}
  function paint(list,withRemove){
    if(!grid)return;grid.innerHTML='';
    if(!list.length){grid.hidden=true;if(empty)empty.hidden=false;return;}
    if(empty)empty.hidden=true;grid.hidden=false;
    list.forEach(function(it){var o=obj(it);var cell=document.createElement('div');cell.className='pdp-saved-cell';cell.setAttribute('data-h',o.h||'');cell.appendChild(tacBuildCard(o));
      if(withRemove){var rm=document.createElement('button');rm.type='button';rm.className='pdp-saved-x';rm.setAttribute('aria-label','Remove '+(o.t||'')+' from saved');rm.textContent='×';rm.addEventListener('click',function(){tacSavedToggle(o);});cell.appendChild(rm);}
      grid.appendChild(cell);});
  }
  /* since-you-saved flags now live at top level (tacSavedFlag/tacSavedRefresh, beside tacBuildCard)
     so the PDP saved panel shares them; this block just wires them to the page grid. */
  var shared=sharedIds();
  if(shared.length){
    if(actions)actions.hidden=true;
    Promise.all(shared.map(function(h){return fetch('/products/'+h+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.ok?r.json():null;}).catch(function(){return null;});}))
      .then(function(ps){var cards=ps.filter(Boolean).map(toCard);
        if(!cards.length){if(grid)grid.hidden=true;if(empty)empty.hidden=false;return;}
        paint(cards,false);if(sharedBox)sharedBox.hidden=false;
        /* the full product JSON is already in hand — badge sold-out items so a shared list (a
           purchase-committee artifact) never presents a dead option as buyable. No vid in a shared
           link (it carries handles only), so the flag is product-level; no price-drop either (a
           shared list has no saved-time price to compare). */
        ps.filter(Boolean).forEach(function(p){if(!p.available)tacSavedLiveCache[p.handle]={out:true,vid:null,drop:0,now:0};});
        tacSavedFlag(grid);
        if(saveAllBtn)saveAllBtn.addEventListener('click',function(){cards.forEach(function(o){if(!tacSavedHas(o.h))tacSavedToggle(o);});location.assign(location.pathname);});
      });
    return;
  }
  var emailBox=document.querySelector('[data-saved-email]'),savedForm=document.getElementById('savedForm'),savedTags=document.getElementById('savedTags'),savedNote=document.getElementById('savedNote');
  if(savedForm&&savedTags)savedForm.addEventListener('submit',function(){var hs=(window.tacSavedGet?tacSavedGet():[]).map(function(x){return obj(x).h;}).filter(Boolean);savedTags.value=(['newsletter','wishlist'].concat(hs.map(function(h){return 'saved:'+h;}))).join(', ');
    /* cross-device list link in the customer note — the Share button's ?ids= format, paste-ready for follow-up emails */
    if(savedNote)savedNote.value=hs.length?('Saved mirrors: '+location.origin+location.pathname+'?ids='+hs.join(',')):'';});
  /* "what changed" one-liner above the grid — counts the CURRENT flags (exactly what the badges
     show) and says "since you saved", because that's what the flags measure; the last-visit
     bookkeeping belongs to the header dot. role=status so it's announced when it lands. */
  function summary(){
    var a=window.tacSavedGet?tacSavedGet():[],drops=0,outs=0;
    a.forEach(function(x){var i=tacSavedLiveCache[tacSavedKeyOf(x)];if(!i)return;if(i.out)outs++;else if(i.drop>0)drops++;});
    var el=document.getElementById('savedNews');
    if(!drops&&!outs){if(el)el.hidden=true;return;}
    if(!el){el=document.createElement('p');el.id='savedNews';el.className='saved-news';el.setAttribute('role','status');
      if(grid&&grid.parentNode)grid.parentNode.insertBefore(el,grid);else return;}
    var parts=[];
    if(drops)parts.push(drops===1?'1 price drop':drops+' price drops');
    if(outs)parts.push(outs+' sold out');
    el.textContent=parts.join(' · ')+' since you saved';
    el.hidden=false;
  }
  function render(){var a=window.tacSavedGet?tacSavedGet():[];paint(a,true);
    tacSavedFlag(grid);summary();var regrid=function(){tacSavedFlag(grid);summary();};tacSavedRefresh(a.map(obj),regrid,regrid);
    if(actions)actions.hidden=a.length<1;if(emailBox&&savedTags)emailBox.hidden=a.length<1;}
  if(shareBtn)shareBtn.addEventListener('click',function(){
    var hs=(window.tacSavedGet?tacSavedGet():[]).map(function(x){return obj(x).h;}).filter(Boolean);if(!hs.length)return;
    var url=location.origin+location.pathname+'?ids='+hs.join(',');
    if(navigator.clipboard&&navigator.clipboard.writeText)navigator.clipboard.writeText(url).then(function(){if(window.toast)toast('Link copied');},function(){window.prompt('Copy your list link:',url);});
    else window.prompt('Copy your list link:',url);
  });
  document.addEventListener('tac:saved',render);
  render();
});

/* ---- Header saved-count badge ([data-saved-link]/[data-saved-count]) — live count from the shared store; hidden at zero ---- */
document.addEventListener('DOMContentLoaded',function(){
  var link=document.querySelector('[data-saved-link]'),cnt=document.querySelector('[data-saved-count]');
  if(!link&&!cnt)return;
  function paint(){var n=(window.tacSavedGet?tacSavedGet():[]).length;if(cnt)cnt.textContent=n;if(link)link.hidden=n<1;}
  document.addEventListener('tac:saved',paint);
  paint();
  /* something-changed dot — a saved mirror newly sold out or dropped in price since the last
     Saved-page visit puts a dot on the heart (the honest return trigger for the 28-day cycle).
     Live states come from tacSavedRefresh (once per SESSION, result cached in sessionStorage —
     other pages don't refetch); "seen" states persist in localStorage and are re-recorded on a
     Saved-page visit (own list only, not a shared ?ids= view), which clears the dot. */
  if(!link)return;
  function lState(h){var i=tacSavedLiveCache[h];return i?(i.out?'o':(i.drop>0?'d':'')):'';}
  function lSnap(items){var m={};items.forEach(function(x){var h=tacSavedKeyOf(x);if(h)m[h]=lState(h);});return m;}
  function dot(on){link.classList.toggle('has-news',!!on);
    link.setAttribute('aria-label',on?'Saved mirrors — your list changed':'Saved mirrors');}
  var items=window.tacSavedGet?tacSavedGet():[];
  var onOwnSaved=false;
  try{onOwnSaved=!!document.querySelector('[data-saved-page]')&&!/[?&]ids=/.test(location.search);}catch(_){}
  if(onOwnSaved){
    /* the Saved page is the read receipt — once its fetches settle, record states as seen + clear */
    tacSavedRefresh(items,null,function(){
      try{localStorage.setItem('tacSavedSeen',JSON.stringify(lSnap(items)));sessionStorage.setItem('tacSavedDot','0');}catch(_){}
      dot(false);
    });
    return;
  }
  var known=null;try{known=sessionStorage.getItem('tacSavedDot');}catch(_){}
  if(known!==null){dot(known==='1');return;}
  if(!items.length){try{sessionStorage.setItem('tacSavedDot','0');}catch(_){}return;}
  tacSavedRefresh(items,null,function(){
    var seen={};try{seen=JSON.parse(localStorage.getItem('tacSavedSeen'))||{};}catch(_){}
    var news=false;
    items.forEach(function(x){var h=tacSavedKeyOf(x),st=lState(h);if(st&&seen[h]!==st)news=true;});
    try{sessionStorage.setItem('tacSavedDot',news?'1':'0');}catch(_){}
    dot(news);
  });
});

/* ---- Inspiration gallery lightbox — tap/Enter any gallery photo → full-screen; ←/→ (keys + arrows) browse with wrap; carries the caption + "Shop this mirror" link; x/overlay/Escape closes; reduced-motion safe. Uses the 1200px data-pin-media on each img. ---- */
(function(){
  var imgs=Array.prototype.slice.call(document.querySelectorAll('.gallery .frame img'));
  if(!imgs.length)return;
  var multi=imgs.length>1;
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion:reduce)').matches;
  var ov,imgEl,closeBtn,prevBtn,nextBtn,capEl,countEl,lastFocus,cur=0,tx=0,ty=0;
  function meta(i){
    var img=imgs[i],g=img.closest('.g'),shop=g?g.querySelector('a.cap-shop'):null;
    return {src:img.getAttribute('data-pin-media')||img.currentSrc||img.src,alt:img.alt||'',shop:shop?shop.getAttribute('href'):''};
  }
  function build(){
    ov=document.createElement('div');ov.className='ig-lightbox';ov.setAttribute('role','dialog');ov.setAttribute('aria-modal','true');ov.setAttribute('aria-label','Inspiration photo');
    imgEl=document.createElement('img');imgEl.className='ig-lightbox-img';imgEl.alt='';
    closeBtn=document.createElement('button');closeBtn.type='button';closeBtn.className='ig-lightbox-close';closeBtn.setAttribute('aria-label','Close');closeBtn.innerHTML='&times;';
    prevBtn=document.createElement('button');prevBtn.type='button';prevBtn.className='ig-lightbox-nav prev';prevBtn.setAttribute('aria-label','Previous photo');prevBtn.innerHTML='&#8249;';
    nextBtn=document.createElement('button');nextBtn.type='button';nextBtn.className='ig-lightbox-nav next';nextBtn.setAttribute('aria-label','Next photo');nextBtn.innerHTML='&#8250;';
    capEl=document.createElement('div');capEl.className='ig-lightbox-cap';
    countEl=document.createElement('div');countEl.className='ig-lightbox-count';countEl.setAttribute('aria-hidden','true');
    ov.appendChild(imgEl);ov.appendChild(prevBtn);ov.appendChild(nextBtn);ov.appendChild(capEl);ov.appendChild(countEl);ov.appendChild(closeBtn);
    if(!multi){prevBtn.hidden=true;nextBtn.hidden=true;countEl.hidden=true;}
    ov.addEventListener('click',function(e){if(e.target===ov||e.target===closeBtn)close();});
    prevBtn.addEventListener('click',function(e){e.stopPropagation();nav(-1);});
    nextBtn.addEventListener('click',function(e){e.stopPropagation();nav(1);});
    /* swipe left/right on touch → prev/next (horizontal-dominant gestures only, so vertical scroll is untouched) */
    ov.addEventListener('touchstart',function(e){tx=e.changedTouches[0].clientX;ty=e.changedTouches[0].clientY;},{passive:true});
    ov.addEventListener('touchend',function(e){
      var dx=e.changedTouches[0].clientX-tx,dy=e.changedTouches[0].clientY-ty;
      if(multi&&Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy))nav(dx<0?1:-1);
    },{passive:true});
    ov.addEventListener('keydown',function(e){
      if(e.key!=='Tab')return;
      var f=ov.querySelectorAll('button:not([hidden]),a[href]');if(!f.length)return;
      var first=f[0],last=f[f.length-1];
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
    });
    document.body.appendChild(ov);
  }
  function show(i){
    cur=(i+imgs.length)%imgs.length;
    var m=meta(cur);
    imgEl.src=m.src;imgEl.alt=m.alt;
    capEl.innerHTML='';
    if(m.alt){var s=document.createElement('span');s.className='ig-lightbox-cap-txt';s.textContent=m.alt;capEl.appendChild(s);}
    if(m.shop){var a=document.createElement('a');a.className='ig-lightbox-shop';a.href=m.shop;a.textContent='Shop this mirror →';capEl.appendChild(a);}
    capEl.hidden=!(m.alt||m.shop);
    if(multi){countEl.textContent=(cur+1)+' / '+imgs.length;}
    if(!reduce){imgEl.style.opacity='0';requestAnimationFrame(function(){imgEl.style.opacity='1';});}else{imgEl.style.opacity='1';}
    if(multi){new Image().src=meta((cur+1)%imgs.length).src;new Image().src=meta((cur-1+imgs.length)%imgs.length).src;}
  }
  function nav(d){if(multi)show(cur+d);}
  function open(i){
    if(!ov)build();
    show(i);
    lastFocus=document.activeElement;document.body.style.overflow='hidden';
    ov.classList.add('open');closeBtn.focus();
  }
  function close(){
    if(!ov||!ov.classList.contains('open'))return;
    ov.classList.remove('open');document.body.style.overflow='';
    if(lastFocus&&lastFocus.focus)lastFocus.focus();
  }
  imgs.forEach(function(img,i){
    img.setAttribute('tabindex','0');img.setAttribute('role','button');
    if(!img.getAttribute('aria-label'))img.setAttribute('aria-label','Enlarge photo'+(img.alt?': '+img.alt:''));
    img.style.cursor='zoom-in';
    img.addEventListener('click',function(){open(i);});
    img.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();open(i);}});
  });
  document.addEventListener('keydown',function(e){
    if(!ov||!ov.classList.contains('open'))return;
    if(e.key==='Escape')close();
    else if(e.key==='ArrowLeft'){e.preventDefault();nav(-1);}
    else if(e.key==='ArrowRight'){e.preventDefault();nav(1);}
  });
})();

/* ============================ ENGAGEMENT ANALYTICS ============================ */
/* Feeds the EXISTING GA4 (314662431) through the Google tag already on the storefront
   (Google & YouTube channel). Sends ONLY interactions no store-level/channel pixel can
   see: the signature interactive widgets + intent clicks. We deliberately DON'T emit
   add_to_cart / view_item / search here — the Shopify web pixels (Meta, TikTok, Pinterest)
   and the Google channel already own those, so re-emitting would double-count.
   Fully guarded: a no-op when gtag is absent (e.g. local `theme dev` without the channel),
   falling back to dataLayer if a GTM container is ever deployed. */
(function(){
  function ev(name,params){try{
    if(typeof window.gtag==='function'){window.gtag('event',name,params||{});}
    else if(window.dataLayer&&typeof window.dataLayer.push==='function'){window.dataLayer.push(Object.assign({event:name},params||{}));}
    /* also tag the Clarity session by intent, so replays can be filtered to "used size finder / LED simulator" etc. */
    if(params&&params.engagement&&typeof window.clarity==='function'){window.clarity('set','engagement',params.engagement);}
    /* and as a Clarity custom event, so each one can be a funnel step / segment filter in the dashboard */
    if(typeof window.clarity==='function'){window.clarity('event',name);}
  }catch(e){}}
  /* Clarity-only event — for signals GA4 already owns through the channel pixels (add_to_cart), where a
     second GA4 event would double-count. The queue stub in theme.liquid buffers these until the tag loads. */
  function cev(name){try{if(typeof window.clarity==='function'){window.clarity('event',name);}}catch(e){}}
  function once(fn){var d=false;return function(){if(d)return;d=true;try{fn();}catch(e){}};}

  /* LED light simulator (hero light pod) — once, on first temperature/brightness/preset touch */
  var kel=document.getElementById('kelvin'),bri=document.getElementById('bright');
  if(kel||bri){
    var ledOnce=once(function(){ev('led_simulator_engaged',{engagement:'led_simulator',kelvin:kel?+kel.value:undefined,brightness:bri?+bri.value:undefined});});
    if(kel)kel.addEventListener('input',ledOnce);
    if(bri)bri.addEventListener('input',ledOnce);
    Array.prototype.forEach.call(document.querySelectorAll('.lp-preset'),function(p){p.addEventListener('click',ledOnce);});
  }

  /* Before/after reveal — once, when the handle is dragged */
  var baR=document.getElementById('baRange');
  if(baR){var baOnce=once(function(){ev('before_after_used',{engagement:'before_after'});});baR.addEventListener('input',baOnce);}

  /* Anti-fog wipe demo — once, on first wipe */
  var fog=document.getElementById('fogDemo');
  if(fog){var fogOnce=once(function(){ev('fog_wipe_used',{engagement:'fog_wipe'});});fog.addEventListener('pointerdown',fogOnce);fog.addEventListener('pointermove',fogOnce);}

  /* Size finder — once on first use, plus the settled recommendation ('change' fires on release) */
  var van=document.getElementById('vanity'),sgN=document.getElementById('sgName');
  if(van){
    var sizeOnce=once(function(){ev('size_finder_used',{engagement:'size_finder'});});
    van.addEventListener('input',sizeOnce);
    van.addEventListener('change',function(){ev('size_finder_result',{engagement:'size_finder',vanity_width:+van.value,recommended:sgN?(sgN.textContent||'').trim():undefined});});
  }

  /* Buy-box fit check width slider (#pdpFit) — is the quick-pick row earning its space above the Add to
     Cart button, or is everyone dragging? Two distinct events, each once per page load. Delegated because
     theme-pdp.js re-renders that control; scoped to #pdpFit so the below-fold calculator's identical
     slider stays out of it (a size-guide page has no #pdpFit and emits nothing). */
  (function(){
    if(!document.getElementById('pdpFit'))return;
    function inBuyBox(t){return t&&t.closest&&t.closest('#pdpFit');}
    /* drag: once — 'input' fires on every pixel of a drag. pick: every tap — they're rare, and WHICH
       width gets tapped is the whole point (a pile-up on one value says the range could tighten). */
    var dragOnce=once(function(){ev('fit_check_slider',{engagement:'fit_check'});});
    document.addEventListener('input',function(e){
      if(e.target.classList&&e.target.classList.contains('vw-range')&&inBuyBox(e.target))dragOnce();});
    document.addEventListener('click',function(e){
      var p=e.target.closest&&e.target.closest('[data-vw-preset]');
      if(p&&inBuyBox(p))ev('fit_check_preset',{engagement:'fit_check',vanity_width:+p.getAttribute('data-vw-preset')});});
  })();

  /* PDP funnel signals for the Clarity audit's before/after checks (2026-10-20): WHICH Add-to-cart got the
     tap (sticky bar vs buy box), whether the gallery was used, and how often the corner overlays get shut.
     Own listener, because the delegated one below returns on its first match. */
  if(document.getElementById('product-form')){
    var galOnce=once(function(){ev('pdp_gallery_used',{engagement:'gallery'});});
    document.addEventListener('click',function(e){
      var t=e.target;if(!t||!t.closest)return;
      if(t.closest('#mctaAdd')){cev('sticky_atc_click');return;}
      if(t.closest('.pdp-atc')){cev('buybox_atc_click');return;}
      if(t.closest('#pdpScaleTile')){cev('gallery_scale_open');galOnce();return;}
      if(t.closest('[data-scale-go]')){cev('gallery_scale_to_atc');return;}
      if(t.closest('.pdp-gallery')){galOnce();return;}
      if(t.closest('[data-expert-close]')){cev('expert_nudge_close');return;}
    });
  }
  /* welcome slide-in: shown + closed, on every page (watch the class rather than reach into its IIFE) */
  (function(){
    var wp=document.getElementById('welcomePop');if(!wp)return;
    var shownOnce=once(function(){cev('welcome_popup_shown');});
    if(wp.classList.contains('is-open'))shownOnce();
    if('MutationObserver' in window)new MutationObserver(function(){if(wp.classList.contains('is-open'))shownOnce();}).observe(wp,{attributes:true,attributeFilter:['class']});
    wp.addEventListener('click',function(e){if(e.target.closest&&e.target.closest('[data-welcome-close]'))cev('welcome_popup_close');});
  })();

  /* Delegated clicks: FAQ opens, recently-viewed rail, shape selection, "Find My Size" CTAs.
     This listener bubbles to document, so each section's own handler (FAQ toggle, etc.) has
     already run — we read post-toggle state. Navigations survive via gtag's sendBeacon. */
  document.addEventListener('click',function(e){
    var t=e.target;if(!t||!t.closest)return;
    /* FAQ accordion — fire only when a row is OPENED (the section toggled `.open` first) */
    var fbtn=t.closest('.faq button');
    if(fbtn){
      var fq=fbtn.closest('.faq');
      if(fq&&fq.classList.contains('open')){
        var qs=fbtn.querySelector('span:not(.pm)')||fbtn.querySelector('span');
        ev('faq_open',{engagement:'faq',question:qs?(qs.textContent||'').trim().slice(0,100):undefined});
      }
      return;
    }
    /* Recently-viewed rail — click-through to a prior product */
    var rv=t.closest('.pdp-recent');
    if(rv){
      var rc=t.closest('.card');
      if(rc){
        var rl=rc.querySelector('a.card-link, a[href*="/products/"]'),rt=rc.querySelector('h3');
        ev('recently_viewed_click',{engagement:'recently_viewed',product:rt?(rt.textContent||'').trim():undefined,handle:rl?((rl.getAttribute('href')||'').split('/products/')[1]||'').split(/[?#]/)[0]:undefined});
      }
      return;
    }
    /* Shape selection (home shop-by-shape + collection filter) */
    var cat=t.closest('.cat');
    if(cat){
      var nm=cat.querySelector('.cat-name');
      ev('shape_select',{engagement:'shape',shape:(nm?nm.textContent:cat.textContent||'').trim(),source:cat.closest('.shapes-select')?'collection_filter':'shop_by_shape'});
      return;
    }
    /* Predictive-search Guides group — measures whether research-phase shoppers use it (mouse
       clicks only: keyboard Enter navigates via location.href in the suggest block, not a click) */
    var nsg=t.closest('.nss-guides a');
    if(nsg){
      ev('select_content',{engagement:'search_suggest_guide',content_type:'search_suggest_guide',item_id:(nsg.getAttribute('href')||'').split(/[?#]/)[0]});
      return;
    }
    /* Outbound to Amazon — quantify how much traffic we hand off to the marketplace */
    var aout=t.closest('a');
    if(aout&&/amazon\./i.test(aout.hostname||aout.getAttribute('href')||'')){
      ev('click_outbound',{engagement:'outbound',destination:'amazon',link_url:aout.href||aout.getAttribute('href')});
      return;
    }
    /* "Find My Size" CTAs */
    var a=t.closest('a,button');
    if(a&&(a.textContent||'').trim().toLowerCase()==='find my size'){
      ev('find_my_size_click',{engagement:'find_my_size',page_path:location.pathname});
    }
  });

  /* Save-for-later — fire `save_product` only for NEWLY added items by diffing the shared
     `tacSaved` store on each `tac:saved` event. Order-independent (works no matter which save
     UI fired it) and never fires on un-save. */
  if(window.tacSavedGet){
    var savedPrev={};
    (window.tacSavedGet()||[]).forEach(function(x){var h=(typeof x==='string')?x:(x&&x.h);if(h)savedPrev[h]=1;});
    document.addEventListener('tac:saved',function(){
      var cur=window.tacSavedGet()||[],seen={};
      cur.forEach(function(x){
        var h=(typeof x==='string')?x:(x&&x.h);if(!h)return;seen[h]=1;
        if(!savedPrev[h])ev('save_product',{engagement:'save',handle:h,product:(x&&x.t)||undefined});
      });
      savedPrev=seen;
    });
  }

  /* Mirror-finder quiz funnel — start (first option), per-step progression, and completion
     (email gate passed → [data-quiz-posted] renders on the post-submit redirect). quiz_complete is
     a DISTINCT event, not sign_up, so it never collides with the footer newsletter sign_up that the
     same customer-form success also triggers (Shopify marks every customer form posted_successfully). */
  var quizEl=document.getElementById('mirrorQuiz');
  if(quizEl){
    var quizStarted=false;
    quizEl.addEventListener('click',function(e){
      var opt=e.target.closest&&e.target.closest('.quiz-opt');if(!opt)return;
      if(!quizStarted){quizStarted=true;ev('quiz_start',{engagement:'quiz'});}
      var stepEl=opt.closest('[data-step]'),grp=opt.closest('.quiz-opts');
      ev('quiz_step',{engagement:'quiz',step:stepEl?+stepEl.getAttribute('data-step'):undefined,quiz_key:grp?grp.getAttribute('data-key'):undefined});
    });
    if(document.querySelector('[data-quiz-posted]'))ev('quiz_complete',{engagement:'quiz'});
  }
})();

/* ---- Welcome-offer slide-in — first-order email capture (WELCOME10). Shows once after a
   delay, stays dismissed 30 days (localStorage), opens immediately on the post-signup reload
   to reveal the code. Guarded: no-ops when the section isn't rendered. ---- */
(function(){
  var pop=document.getElementById('welcomePop');if(!pop)return;
  var KEY='tacWelcomeDismiss',CKEY='tacWelcomeClaimed',now=Date.now(),TTL=30*24*60*60*1000;
  function dismissed(){try{var v=parseInt(localStorage.getItem(KEY)||'0',10);return v&&(now-v)<TTL;}catch(e){return false;}}
  function setDismiss(){try{localStorage.setItem(KEY,String(now));}catch(e){}}
  function claimed(){try{return localStorage.getItem(CKEY)==='1';}catch(e){return false;}}
  function open(){pop.classList.add('is-open');pop.setAttribute('aria-hidden','false');}
  function close(){pop.classList.remove('is-open');pop.setAttribute('aria-hidden','true');setDismiss();}
  var x=pop.querySelector('[data-welcome-close]');if(x)x.addEventListener('click',close);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&pop.classList.contains('is-open'))close();});
  /* Mark the offer claimed only when THIS form is submitted — distinguishes a real welcome
     signup from any other {% form 'customer' %} (footer newsletter), which Shopify also flags
     posted_successfully on every customer form. The write is synchronous so it survives reload. */
  var wform=pop.querySelector('.welcome-form');
  if(wform)wform.addEventListener('submit',function(){try{localStorage.setItem(CKEY,'1');}catch(e){}});
  /* Post-signup reload shows the success/code markup on EVERY customer form. Only auto-open it
     when this visitor actually claimed via the welcome form — a footer signup no longer hijacks it. */
  if(pop.querySelector('[data-welcome-success]')){if(claimed())open();return;}
  if(claimed()||dismissed())return;
  var delay=(parseInt(pop.getAttribute('data-delay'),10)||20)*1000,shown=false;
  /* Product pages get no timer: at 8s the slide-in landed on top of the sticky Add-to-cart (#mctaAdd) on
     mobile (Clarity 2026-10-20 — 0 of 80 taps on Add to cart on the top PDP, 24% were overlay closes).
     Exit-intent below still offers it on desktop. Never stack over the open PDP expert nudge either. */
  var onPdp=!!document.getElementById('mctaAdd');
  /* one bottom-left card per session — shares sessionStorage tacOverlay with the PDP expert nudge (see there) */
  function trigger(){if(shown)return;var o='';try{o=sessionStorage.getItem('tacOverlay')||'';}catch(e){}
    var ex=document.getElementById('pdpExpert');if((o&&o!=='welcome')||(ex&&ex.classList.contains('show')&&!ex.classList.contains('mini')))return;
    shown=true;try{sessionStorage.setItem('tacOverlay','welcome');}catch(e){}open();}
  /* Time AND engagement: after the delay, wait until a third of the page has been scrolled (or the page is
     too short to scroll) — the 2026-10-21 audit caught it covering a third of the phone screen ~4 s into
     the homepage, before the shopper had seen a product. */
  function engaged(){var d=document.documentElement,max=d.scrollHeight-window.innerHeight;return max<200||(window.scrollY||d.scrollTop)>=max*0.33;}
  function onScroll(){if(engaged()){window.removeEventListener('scroll',onScroll);trigger();}}
  var t=onPdp?null:setTimeout(function(){if(engaged())trigger();else window.addEventListener('scroll',onScroll,{passive:true});},delay);
  /* also trigger on exit-intent (desktop) so a leaving visitor still sees it */
  document.addEventListener('mouseout',function(e){if(!e.relatedTarget&&e.clientY<=0){clearTimeout(t);trigger();}});
})();

/* ---- Compare mirrors — a localStorage-backed tray + side-by-side modal. Cards expose
   data-compare-add with {h,u,t,img,p,pc,ty}; reuses the same payload idea as save-for-later.
   Guarded: builds its tray/modal lazily, no-ops if no compare buttons exist on the page. ---- */
(function(){
  if(!document.body)return;
  var KEY='tacCompare',MAX=4;
  function load(){try{return JSON.parse(localStorage.getItem(KEY)||'[]');}catch(e){return [];}}
  function save(a){try{localStorage.setItem(KEY,JSON.stringify(a.slice(0,MAX)));}catch(e){}}
  var items=load();
  function has(h){return items.some(function(i){return i.h===h;});}
  function payload(b){var d=b.dataset;return {h:d.h,u:d.u,t:d.t,img:d.img,p:d.p,pc:d.pc,ty:d.ty,vid:d.vid,one:d.one,avail:d.avail,dim:d.dim,cct:d.cct,lum:d.lum,mount:d.mount,feat:d.feat};}
  /* feature icons for the compare table — paths MIRROR snippets/feature-icon.liquid (keep in sync). */
  var CMP_FEAT_ICONS={cct:'<path d="M9 18h6M10 21h4"/><path d="M12 3a6 6 0 0 0-4 10.5c.7.7 1 1.3 1 2.5h6c0-1.2.3-1.8 1-2.5A6 6 0 0 0 12 3Z"/>',dimmable:'<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4 12H2M22 12h-2M5 5l1.5 1.5M17.5 17.5L19 19M19 5l-1.5 1.5M6.5 17.5L5 19"/>','anti-fog':'<path d="M3 8h13M19 8h2M5 12h14M3 16h11M17 16h4"/>',touch:'<path d="M9 11V6a2 2 0 0 1 4 0v5"/><path d="M13 11V9a2 2 0 0 1 4 0v6a5 5 0 0 1-5 5h-1.5a4 4 0 0 1-3-1.4L4 15a1.6 1.6 0 0 1 2.4-2L9 15"/>',bluetooth:'<path d="M7 7l10 10-5 4V3l5 4L7 17"/>',clock:'<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',magnify:'<circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/>',hardwired:'<path d="M9 2v6M15 2v6"/><path d="M6 8h12v3a6 6 0 0 1-12 0V8Z"/><path d="M12 17v5"/>','ip-rated':'<path d="M12 3s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11Z"/>',smart:'<rect x="7" y="3" width="10" height="18" rx="2"/><path d="M11 18h2"/>'};
  var CMP_FEAT_LABELS={cct:'3-color','anti-fog':'Anti-fog',dimmable:'Dimmable',touch:'Touch',bluetooth:'Bluetooth',clock:'Time display',magnify:'Magnifier',hardwired:'Hard-wired','ip-rated':'Damp-rated',smart:'Smart'};
  function featCell(it){if(!it.feat)return '—';var ks=(''+it.feat).split(',').filter(Boolean),out='';for(var i=0;i<ks.length;i++){var p=CMP_FEAT_ICONS[ks[i]];if(!p)continue;out+='<span class="cmp-feat" title="'+esc(CMP_FEAT_LABELS[ks[i]]||ks[i])+'"><svg viewBox="0 0 24 24" aria-hidden="true">'+p+'</svg></span>';}return out||'—';}

  /* tray (created once, lives at body end) */
  var tray=document.createElement('div');tray.className='cmp-tray';tray.setAttribute('role','region');tray.setAttribute('aria-label','Compare mirrors');
  tray.innerHTML='<div class="cmp-tray-items"></div><span class="cmp-tray-meta"></span><button type="button" class="cmp-tray-go">Compare</button><button type="button" class="cmp-tray-clear">Clear</button>';
  document.body.appendChild(tray);
  var trayItems=tray.querySelector('.cmp-tray-items'),trayMeta=tray.querySelector('.cmp-tray-meta'),trayGo=tray.querySelector('.cmp-tray-go'),trayClear=tray.querySelector('.cmp-tray-clear');

  /* re-query each call so dynamically-built cards (saved panel / recently-viewed) reflect state */
  function syncButtons(){var all=document.querySelectorAll('[data-compare-add]');for(var i=0;i<all.length;i++){all[i].setAttribute('aria-pressed',has(all[i].dataset.h)?'true':'false');}}
  window.tacCompareSync=syncButtons;
  function renderTray(){
    trayItems.innerHTML='';
    items.forEach(function(it){
      var chip=document.createElement('div');chip.className='cmp-chip';
      chip.innerHTML='<img src="'+(it.img||'')+'" alt="'+(it.t||'').replace(/"/g,'&quot;')+'"><button type="button" class="cmp-chip-x" aria-label="Remove">&times;</button>';
      chip.querySelector('.cmp-chip-x').addEventListener('click',function(){remove(it.h);});
      trayItems.appendChild(chip);
    });
    trayMeta.textContent=items.length+' selected';
    trayGo.textContent=items.length?('Compare ('+items.length+')'):'Compare';
    trayGo.disabled=items.length<2;
    if(items.length)tray.classList.add('is-open');else tray.classList.remove('is-open');
    /* reserve bottom space so the fixed tray never covers footer links/CTAs on short pages */
    document.body.classList.toggle('has-cmp-tray',items.length>0);
    syncButtons();
  }
  function add(it){if(has(it.h))return;if(items.length>=MAX){if(window.toast)window.toast('Compare up to '+MAX+' mirrors');return;}items.push(it);save(items);renderTray();}
  function remove(h){items=items.filter(function(i){return i.h!==h;});save(items);renderTray();if(modal&&modal.classList.contains('is-open'))buildModal();}
  function clear(){items=[];save(items);renderTray();closeModal();}

  /* delegated so compare buttons added later (saved/recently-viewed) work without rebinding */
  document.addEventListener('click',function(e){var b=e.target.closest&&e.target.closest('[data-compare-add]');if(!b)return;e.preventDefault();var h=b.dataset.h;if(has(h))remove(h);else add(payload(b));});
  trayClear.addEventListener('click',clear);

  /* modal */
  var modal=null;
  function ensureModal(){
    if(modal)return;
    modal=document.createElement('div');modal.className='cmp-modal';modal.setAttribute('role','dialog');modal.setAttribute('aria-modal','true');modal.setAttribute('aria-label','Compare mirrors');
    modal.innerHTML='<div class="cmp-modal-inner"><div class="cmp-modal-head"><h2>Compare mirrors</h2><button type="button" class="cmp-modal-x" aria-label="Close">&times;</button></div><div class="cmp-modal-body"></div></div>';
    document.body.appendChild(modal);
    modal.addEventListener('click',function(e){if(e.target===modal)closeModal();});
    modal.querySelector('.cmp-modal-x').addEventListener('click',closeModal);
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&modal.classList.contains('is-open'))closeModal();});
  }
  function esc(s){return (s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}
  function buildModal(){
    ensureModal();
    /* removing items inside the modal can drop below 2 — show a prompt instead of a one-column/empty table */
    if(items.length<2){modal.querySelector('.cmp-modal-body').innerHTML='<p class="cmp-empty">Add another mirror to compare — pick at least two from any collection, your saved list, or recently viewed.</p>';return;}
    var headerRow={render:function(it){return '<div class="cmp-prod"><img src="'+(it.img||'')+'" alt="'+esc(it.t)+'"><a href="'+(it.u||'#')+'">'+esc(it.t)+'</a></div>';}};
    var ctaRow={render:function(it){
      /* single-variant + available → quick-add in place (existing [data-qadd] delegate handles it); else link to the PDP for option selection */
      var single=(it.one==='true'||it.one===true),avail=(it.avail==null||it.avail==='true'||it.avail===true);
      if(single&&it.vid&&avail)return '<button type="button" class="cmp-go qadd" data-qadd="'+esc(it.vid)+'" aria-label="Add '+esc(it.t)+' to cart">Add to cart</button>';
      return '<a class="cmp-go" href="'+(it.u||'#')+'">View mirror</a>';
    }};
    /* opt:true rows hide entirely when EVERY compared mirror lacks the value (all "—") — keeps the
       table credible while spec metafields are still being backfilled. Price stays always-on. */
    var specRows=[
      {label:'Shape',opt:true,render:function(it){return esc(it.ty)||'—';}},
      {label:'Features',opt:true,render:featCell},
      {label:'Price',render:function(it){return esc(it.p)||'—';}},
      {label:'Pay in 4',opt:true,render:function(it){var c=parseInt(it.pc||'0',10);return c?('4 × '+ (window.tacMoney?window.tacMoney(Math.floor(c/4)):('$'+(c/400).toFixed(2)))):'—';}},
      {label:'Size',opt:true,render:function(it){return esc(it.dim)||'—';}},
      {label:'Light (CCT)',opt:true,render:function(it){return esc(it.cct)||'—';}},
      {label:'Brightness',opt:true,render:function(it){return esc(it.lum)||'—';}},
      {label:'Mount',opt:true,render:function(it){return esc(it.mount)||'—';}}
    ].filter(function(r){return !r.opt||!items.every(function(it){return r.render(it)==='—';});});
    var html='<table class="cmp-table"><thead><tr><th class="cmp-row-label"></th>';
    items.forEach(function(it){html+='<th>'+headerRow.render(it)+'</th>';});
    html+='</tr></thead><tbody>';
    specRows.concat([ctaRow]).forEach(function(r){
      html+='<tr><td class="cmp-row-label">'+(r.label||'')+'</td>';
      items.forEach(function(it){html+='<td>'+r.render(it)+'</td>';});
      html+='</tr>';
    });
    html+='</tbody></table>';
    modal.querySelector('.cmp-modal-body').innerHTML=html;
  }
  function openModal(){if(items.length<2)return;buildModal();modal.classList.add('is-open');}
  function closeModal(){if(modal)modal.classList.remove('is-open');}
  trayGo.addEventListener('click',openModal);
  /* quick-add from the modal: let the global [data-qadd] delegate do the add, then step the modal aside so the cart drawer/toast is visible */
  document.addEventListener('click',function(e){if(e.target.closest&&e.target.closest('.cmp-modal .qadd'))closeModal();});

  renderTray();
})();

/* ---- Quick view (#tacQuickview) — collection-card peek. Click [data-quickview] → fetch /products/{handle}.js,
   open a modal (image, price, variant <select>, add-to-cart). Reuses window.tacCartAdd (cart sync + toast/drawer)
   and window.tacMoney. Delegated, so it's inert until a trigger is clicked — safe on every page. ---- */
(function(){
  var modal=null,lastTrigger=null,cache={},current=null;
  function esc(s){return (s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}
  function money(c){return window.tacMoney?window.tacMoney(c):('$'+((c||0)/100).toFixed(2));}
  function variantById(id){return current?current.variants.filter(function(v){return String(v.id)===String(id);})[0]:null;}
  function priceHTML(v){return (v.compare_at_price&&v.compare_at_price>v.price?'<s>'+money(v.compare_at_price)+'</s> ':'')+money(v.price);}
  function ensure(){
    if(modal)return;
    modal=document.createElement('div');modal.className='qv-modal';modal.setAttribute('role','dialog');modal.setAttribute('aria-modal','true');modal.setAttribute('aria-label','Quick view');
    modal.innerHTML='<div class="qv-inner"><button type="button" class="qv-x" aria-label="Close">&times;</button><div class="qv-body"></div></div>';
    document.body.appendChild(modal);
    modal.addEventListener('click',function(e){if(e.target===modal)close();});
    modal.querySelector('.qv-x').addEventListener('click',close);
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&modal.classList.contains('is-open'))close();});
    modal.addEventListener('change',function(e){var sel=e.target.closest&&e.target.closest('[data-qv-variant]');if(sel)selectVariant(sel.value);});
    modal.addEventListener('click',function(e){
      var b=e.target.closest&&e.target.closest('[data-qv-add]');if(!b||b.disabled)return;e.preventDefault();
      var p=window.tacCartAdd(b.getAttribute('data-qv-add'),1,b);
      if(p&&p.then){p.then(function(){close();});}else{close();}
    });
  }
  function selectVariant(id){
    var v=variantById(id);if(!v)return;
    var price=modal.querySelector('[data-qv-price]'),add=modal.querySelector('[data-qv-add]'),img=modal.querySelector('[data-qv-img]');
    if(price)price.innerHTML=priceHTML(v);
    if(add){add.setAttribute('data-qv-add',v.id);add.disabled=!v.available;add.textContent=v.available?'Add to cart':'Sold out';}
    if(img&&v.featured_image&&v.featured_image.src)img.src=v.featured_image.src;
  }
  /* spec chips mirror the card's .pc-specs — sourced from the trigger's data-* because /products.js omits metafields. Each renders only when set, so a spec-less mirror shows none. */
  function specChips(s){
    if(!s)return '';
    var chips=[];if(s.cct)chips.push(s.cct);if(s.lum)chips.push(s.lum);if(s.ip)chips.push(s.ip);
    if(!chips.length)return '';
    return '<div class="qv-specs" aria-label="Key specs">'+chips.map(function(c){return '<span class="pdp-specchip">'+esc(c)+'</span>';}).join('')+'</div>';
  }
  /* review stars mirror the card's .card-stars — real data only (rc>0), no fabricated rating (§11). rv/rc also from the trigger's data-* (reviews.* metafields aren't in /products.js). */
  function starsHTML(rv,rc){
    rc=parseInt(rc||'0',10);if(!rc)return '';
    var pct=Math.round((parseFloat(rv)||0)*20),disp=String(rc).replace(/\B(?=(\d{3})+(?!\d))/g,',');
    return '<span class="card-stars qv-stars" aria-label="Rated '+esc(rv)+' out of 5 from '+disp+' review'+(rc===1?'':'s')+'"><span class="stars" style="--rate:'+pct+'%" aria-hidden="true">★★★★★</span><span class="card-rc">('+disp+')</span></span>';
  }
  function render(p,specs){
    current=p;
    var avail=p.variants.filter(function(x){return x.available;});
    var v=avail[0]||p.variants[0];
    var imgSrc=(v.featured_image&&v.featured_image.src)||p.featured_image||(p.images&&p.images[0])||'';
    var html='<div class="qv-media"><img data-qv-img src="'+esc(imgSrc)+'" alt="'+esc(p.title)+'" onerror="if(window.cardFail)cardFail(this)"></div>'+
      '<div class="qv-info">'+
      (p.type?'<span class="qv-type">'+esc(p.type)+'</span>':'')+
      '<h2 class="qv-title">'+esc(p.title)+'</h2>'+
      (specs?starsHTML(specs.rv,specs.rc):'')+
      '<p class="qv-price" data-qv-price>'+priceHTML(v)+'</p>'+
      specChips(specs);
    if(p.variants.length>1){
      html+='<label class="qv-vlabel">'+esc((p.options&&p.options[0])||'Option')+'<select class="qv-select" data-qv-variant>';
      p.variants.forEach(function(x){html+='<option value="'+x.id+'"'+(x.id===v.id?' selected':'')+'>'+esc(x.title)+(x.available?'':' — Sold out')+'</option>';});
      html+='</select></label>';
    }
    html+='<button type="button" class="qv-add" data-qv-add="'+v.id+'"'+(v.available?'':' disabled')+'>'+(v.available?'Add to cart':'Sold out')+'</button>'+
      '<a class="qv-full" href="'+esc(p.url)+'">View full details &rarr;</a>'+
      '</div>';
    modal.querySelector('.qv-body').innerHTML=html;
  }
  function open(p,specs){ensure();render(p,specs);modal.classList.add('is-open');var x=modal.querySelector('.qv-x');if(x)x.focus();}
  function close(){if(modal)modal.classList.remove('is-open');if(lastTrigger){lastTrigger.focus();lastTrigger=null;}}
  document.addEventListener('click',function(e){
    var t=e.target.closest&&e.target.closest('[data-quickview]');if(!t)return;e.preventDefault();
    var h=t.getAttribute('data-quickview');if(!h)return;
    lastTrigger=t;ensure();
    var specs={cct:t.getAttribute('data-cct'),lum:t.getAttribute('data-lum'),ip:t.getAttribute('data-ip'),rv:t.getAttribute('data-rv'),rc:t.getAttribute('data-rc')};
    if(cache[h]){open(cache[h],specs);return;}
    t.classList.add('loading');
    fetch('/products/'+encodeURIComponent(h)+'.js',{headers:{'Accept':'application/json'}})
      .then(function(r){if(!r.ok)throw 0;return r.json();})
      .then(function(p){cache[h]=p;open(p,specs);})
      .catch(function(){if(window.toast)window.toast('Could not load preview');else window.location.href='/products/'+h;})
      .then(function(){t.classList.remove('loading');});
  });
})();

/* Collection: flag the pinned filter-summary bar (.shop-count) as .is-stuck only once it pins under
   the header, so its divider/shadow shows only while it's acting as a toolbar. Self-contained guarded
   block (template + element + IO gated) — never touches other pages. */
(function(){
  if(!document.body.classList.contains('template-collection'))return;
  var sc=document.querySelector('.shop-count');
  if(!sc||!('IntersectionObserver' in window))return;
  var sentinel=document.createElement('div');
  sentinel.setAttribute('aria-hidden','true');
  sentinel.style.cssText='height:1px;margin-bottom:-1px;pointer-events:none';
  sc.parentNode.insertBefore(sentinel,sc);
  new IntersectionObserver(function(es){
    var e=es[0];
    sc.classList.toggle('is-stuck',!e.isIntersecting&&e.boundingClientRect.top<62);
  },{threshold:[0],rootMargin:'-62px 0px 0px 0px'}).observe(sentinel);
  /* rootMargin top -62px = the sticky pin line (top:62px). Without it the observer fires only when the
     sentinel clears the VIEWPORT top (y=0), 62px later than the bar actually pins — leaving a scroll
     band where the bar is pinned but bare (no divider), so it reads as a strip floating over the grid. */
})();

/* ===== "TOP RATED" SORT — client-side grid reorder (collection + search) =====
   Shopify has no native rating sort and Liquid can't read a custom ?sort_by=top-rated,
   so we reorder the rendered product cards here by their data-rv (real reviews.rating,
   blank→0). Correct when the whole result set is on one page — main-collection per_page
   is 24 (covers the largest collection, 22); broad searches sort the first page only.
   Own DOMContentLoaded handler so the early return can't trap any other block. */
document.addEventListener('DOMContentLoaded',function(){
  var params;
  try{params=new URLSearchParams(window.location.search);}catch(e){return;}
  if(params.get('sort_by')!=='top-rated')return;
  var chip=document.querySelector('[data-sort-toprated]');
  if(chip){chip.classList.add('active');chip.setAttribute('aria-current','true');}
  /* Name the active sort in the results count line, like the native sorts do server-side. */
  var sc=document.querySelector('.shop-count');
  if(sc&&!/top rated/i.test(sc.textContent)){
    var lbl=document.createElement('span');
    lbl.textContent=' · Top rated';
    var clear=sc.querySelector('a');
    if(clear){sc.insertBefore(lbl,clear);}else{sc.appendChild(lbl);}
  }
  var grids=document.querySelectorAll('.shop-grid');
  Array.prototype.forEach.call(grids,function(grid){
    var cards=Array.prototype.filter.call(grid.children,function(el){return el.classList&&el.classList.contains('card');});
    if(cards.length<2)return;
    cards.sort(function(a,b){
      var ra=parseFloat(a.getAttribute('data-rv'))||0,rb=parseFloat(b.getAttribute('data-rv'))||0;
      return rb-ra;
    });
    cards.forEach(function(c){grid.appendChild(c);});
  });
});

/* ===== CLIENT-SIDE FILTERS — width + price band + finish (collection + search) =====
   Width/price/finish have no native filter (price has no tag, finish is a variant OPTION, search
   has no facets at all), and the result set fits one page (per_page/paginate 24), so we filter the
   rendered cards by data-sizes / data-price / data-finishes — same approach as the "Top rated" sort.
   All three persist in the URL (?size=/?price=/?finish=) and are stamped onto the server-rendered
   width/shape/feature/sort links, so a tag/sort reload restores them (Wayfair-style sticky facets).
   Active facets surface as removable pills (#shopPills). Own guarded handler — bails when no row. */
document.addEventListener('DOMContentLoaded',function(){
  var sizeRow=document.getElementById('colSize'),priceRow=document.getElementById('colPrice'),finishRow=document.getElementById('colFinish');
  if(!sizeRow&&!priceRow&&!finishRow)return;
  var grids=document.querySelectorAll('.shop-grid');if(!grids.length)return;
  var countEl=document.querySelector('.shop-count [data-shop-n]');
  var total=countEl?(parseInt(countEl.getAttribute('data-shop-total'),10)||0):0;
  var noun=(countEl&&countEl.getAttribute('data-shop-noun'))||'mirror';
  var pillsEl=document.getElementById('shopPills');
  var noMatchEl=document.getElementById('shopNoMatch');
  /* mobile "Filter & refine" badge — seeded from the server tag count (current_tags.size) and kept in
     sync with client-side size/price/finish picks so it reflects ALL active facets, not just server tags. */
  var toggleBtn=document.querySelector('.col-refine-toggle');
  var serverCount=0;
  if(toggleBtn){var sc0=toggleBtn.querySelector('.col-refine-count');serverCount=sc0?(parseInt(sc0.textContent,10)||0):0;}
  var state={size:null,price:null,finish:null};   /* size='32' | 'fit'; price={min,max,band}; finish='black' */
  /* "Fits your 48″ vanity" width chip (2026-10-21) — uses the ONE remembered vanity width (CLAUDE.md §6a) and the
     same rule as the PDP size list ("fits W+4″ vanities"): a card qualifies if any of its widths is ≤ vanity − 4″.
     Only added when a width is known; relabels/re-filters live on tac:vanity. */
  function vanW(){return window.tacReadVanityW?tacReadVanityW():0;}
  function fitLabel(){var w=vanW(),ph=window.tacVanityPhrase?tacVanityPhrase():'your ';return 'Fits '+ph+w+'″ vanity';}
  function sizeText(k){return k==='fit'?fitLabel():k+'″';}
  var fitChip=null;
  if(sizeRow&&vanW()>0){
    var allC=sizeRow.querySelector('[data-size-key="all"]');
    fitChip=document.createElement('a');fitChip.className='chip-btn chip-fit';fitChip.href=window.location.pathname;fitChip.setAttribute('data-size-key','fit');fitChip.textContent=fitLabel();
    if(allC&&allC.nextSibling)sizeRow.insertBefore(fitChip,allC.nextSibling);else sizeRow.appendChild(fitChip);
  }
  var didRestore=false,restoreNoteEl=null;
  function updateRefineBadge(){
    if(!toggleBtn)return;
    var n=serverCount+(state.size?1:0)+(state.price?1:0)+(state.finish?1:0);
    var badge=toggleBtn.querySelector('.col-refine-count');
    if(n>0){
      if(!badge){badge=document.createElement('span');badge.className='col-refine-count';toggleBtn.insertBefore(badge,toggleBtn.querySelector('.col-refine-caret'));}
      badge.textContent=n;badge.setAttribute('aria-label',n+' filter'+(n===1?'':'s')+' active');
    }else if(badge){badge.parentNode.removeChild(badge);}
  }
  function eachCard(cb){Array.prototype.forEach.call(grids,function(g){Array.prototype.forEach.call(g.children,function(c){if(c.classList&&c.classList.contains('card'))cb(c);});});}
  function any(){return state.size||state.price||state.finish;}
  function apply(){
    var shown=0;
    eachCard(function(c){
      var ok=true;
      if(state.size)ok=matchSize(c,state.size);
      if(ok&&state.price){var p=parseInt(c.getAttribute('data-price'),10);ok=!isNaN(p)&&(state.price.min===null||p>=state.price.min)&&(state.price.max===null||p<state.price.max);}
      if(ok&&state.finish){var f=c.getAttribute('data-finishes')||'';ok=f.indexOf('|'+state.finish+'|')!==-1;}
      c.classList.toggle('pc-hide',!ok);if(ok)shown++;
    });
    if(countEl){countEl.textContent=!any()?(total+' '+(total===1?noun:noun+'s')):(shown+' of '+total+' '+noun+'s');}
    if(noMatchEl)noMatchEl.hidden=!(any()&&shown===0);
    syncUrl();decorateLinks();renderPills();updateRefineBadge();updateChipCounts();saveState();
  }
  /* session persistence — remember the last price/finish/width for THIS collection (scoped by its base
     path, read off an "all" chip's href) and re-apply on return, unless the URL already carries facets.
     Each restore is guarded by chip existence so a stale value never filters a collection to zero. */
  var STORE='tacRefine',STORE_TTL=1800000;   /* 30 min — a short-lived cross-tab memory, not a permanent pin */
  function basePath(){
    var a=(priceRow&&priceRow.querySelector('[data-price-band="all"]'))||(finishRow&&finishRow.querySelector('[data-finish-key="all"]'))||(sizeRow&&sizeRow.querySelector('[data-size-key="all"]'));
    if(!a)return window.location.pathname;
    try{return new URL(a.getAttribute('href'),window.location.origin).pathname;}catch(e){return window.location.pathname;}
  }
  function saveState(){
    try{
      if(!any()){localStorage.removeItem(STORE);return;}
      localStorage.setItem(STORE,JSON.stringify({p:basePath(),size:state.size,price:state.price?state.price.band:null,finish:state.finish,t:Date.now()}));
    }catch(_){}
  }
  function clearAll(){
    state.size=null;state.price=null;state.finish=null;
    if(sizeRow)markActive(sizeRow,sizeRow.querySelector('[data-size-key="all"]'));
    if(priceRow)markActive(priceRow,priceRow.querySelector('[data-price-band="all"]'));
    if(finishRow)markActive(finishRow,finishRow.querySelector('[data-finish-key="all"]'));
    removeRestoreNote();apply();
  }
  /* shared single-facet matchers — reused by per-chip counts (apply() keeps its own inline copy). */
  function matchSize(c,sz){if(!sz)return true;var ss=c.getAttribute('data-sizes')||'';
    if(sz==='fit'){var w=vanW();if(!w)return true;return ss.split('|').some(function(x){var n=parseFloat(x);return n>0&&n+4<=w;});}
    return ss.indexOf('|'+sz+'|')!==-1;}
  function matchPrice(c,pr){if(!pr)return true;var p=parseInt(c.getAttribute('data-price'),10);return !isNaN(p)&&(pr.min===null||p>=pr.min)&&(pr.max===null||p<pr.max);}
  function matchFinish(c,fn){if(!fn)return true;return (c.getAttribute('data-finishes')||'').indexOf('|'+fn+'|')!==-1;}
  function priceObj(chip){var b=chip.getAttribute('data-price-band');if(!b||b==='all')return null;var mn=chip.getAttribute('data-price-min'),mx=chip.getAttribute('data-price-max');return{min:mn?parseInt(mn,10):null,max:mx?parseInt(mx,10):null,band:b};}
  function countCards(fn){var n=0;eachCard(function(c){if(fn(c))n++;});return n;}
  function chipLabel(chip){var t='';Array.prototype.forEach.call(chip.childNodes,function(n){if(n.nodeType===3)t+=n.nodeValue;});return t.trim();}
  function setChipCount(chip,n){
    var s=chip.querySelector('.chip-n'),sr=chip.querySelector('.chip-sr');
    if(n===null){if(s)s.parentNode.removeChild(s);if(sr)sr.parentNode.removeChild(sr);chip.classList.remove('chip-0');chip.removeAttribute('aria-disabled');return;}
    if(!s){s=document.createElement('span');s.className='chip-n';chip.appendChild(s);}
    s.textContent=' ('+n+')';chip.classList.toggle('chip-0',n===0);
    /* a zero-yield combo can't be selected — block the click (mouse via CSS pointer-events, keyboard via
       the guard in bindRow); the active chip never disables itself. A visually-hidden suffix tells SR
       users WHY it's inert (the "(0)" count is visual-only). */
    if(n===0&&!chip.classList.contains('active')){
      chip.setAttribute('aria-disabled','true');
      if(!sr){sr=document.createElement('span');sr.className='visually-hidden chip-sr';chip.appendChild(sr);}
      sr.textContent=' — no matches';
    }else{chip.removeAttribute('aria-disabled');if(sr)sr.parentNode.removeChild(sr);}
  }
  /* live per-chip counts — each chip shows how many cards it would yield combined with the OTHER active
     facets (not its own row's pick), so shoppers see dead-end combos before clicking. Mirrors the
     server-side feature-chip counts on the unfiltered view. */
  function updateChipCounts(){
    if(sizeRow)Array.prototype.forEach.call(sizeRow.querySelectorAll('[data-size-key]'),function(chip){
      var k=chip.getAttribute('data-size-key');if(k==='all'){setChipCount(chip,null);return;}
      setChipCount(chip,countCards(function(c){return matchSize(c,k)&&matchPrice(c,state.price)&&matchFinish(c,state.finish);}));
    });
    if(priceRow)Array.prototype.forEach.call(priceRow.querySelectorAll('[data-price-band]'),function(chip){
      if(chip.getAttribute('data-price-band')==='all'){setChipCount(chip,null);return;}
      var pr=priceObj(chip);
      setChipCount(chip,countCards(function(c){return matchSize(c,state.size)&&matchPrice(c,pr)&&matchFinish(c,state.finish);}));
    });
    if(finishRow)Array.prototype.forEach.call(finishRow.querySelectorAll('[data-finish-key]'),function(chip){
      var k=chip.getAttribute('data-finish-key');if(k==='all'){setChipCount(chip,null);return;}
      setChipCount(chip,countCards(function(c){return matchSize(c,state.size)&&matchPrice(c,state.price)&&matchFinish(c,k);}));
    });
  }
  function removeRestoreNote(){if(restoreNoteEl&&restoreNoteEl.parentNode){restoreNoteEl.parentNode.removeChild(restoreNoteEl);}restoreNoteEl=null;}
  function showRestoreNote(){
    if(!didRestore||!pillsEl||restoreNoteEl)return;
    var parts=[];
    if(state.size)parts.push(sizeText(state.size));
    if(state.price){var rpp=priceRow&&priceRow.querySelector('[data-price-band="'+state.price.band+'"]');parts.push(rpp?chipLabel(rpp):'price');}
    if(state.finish){var rfp=finishRow&&finishRow.querySelector('[data-finish-key="'+state.finish+'"]');parts.push(rfp?chipLabel(rfp):state.finish);}
    var note=document.createElement('div');note.className='shop-restored';
    note.appendChild(document.createTextNode('Showing your saved filters'+(parts.length?': '+parts.join(', '):'')+'. '));
    var b=document.createElement('button');b.type='button';b.className='shop-restored-x';b.textContent='Clear';
    b.addEventListener('click',clearAll);
    note.appendChild(b);
    pillsEl.parentNode.insertBefore(note,pillsEl);
    restoreNoteEl=note;
  }
  function syncUrl(){
    if(!window.history||!history.replaceState)return;
    var p;try{p=new URLSearchParams(window.location.search);}catch(e){return;}
    if(state.size)p.set('size',state.size);else p.delete('size');
    if(state.price&&state.price.band&&state.price.band!=='all')p.set('price',state.price.band);else p.delete('price');
    if(state.finish)p.set('finish',state.finish);else p.delete('finish');
    var qs=p.toString();
    try{history.replaceState(null,'',window.location.pathname+(qs?'?'+qs:'')+window.location.hash);}catch(e){}
  }
  function stamp(u){
    if(state.size)u.searchParams.set('size',state.size);else u.searchParams.delete('size');
    if(state.price&&state.price.band&&state.price.band!=='all')u.searchParams.set('price',state.price.band);else u.searchParams.delete('price');
    if(state.finish)u.searchParams.set('finish',state.finish);else u.searchParams.delete('finish');
    return u;
  }
  function decorateLinks(){
    /* carry the active facets onto server-rendered tag-filter + sort links so a reload keeps them.
       Skip the client-side filter chips, the "Clear all" link, and cross-collection related links. */
    var links=document.querySelectorAll('.shop .chip-btn[href], .template-search .shop-filters .chip-btn[href]');
    Array.prototype.forEach.call(links,function(a){
      if(a.hasAttribute('data-size-key')||a.hasAttribute('data-price-band')||a.hasAttribute('data-finish-key'))return;
      if(a.closest&&(a.closest('.shop-count')||a.closest('.related-attrs')))return;
      var u;try{u=new URL(a.getAttribute('href'),window.location.origin);}catch(e){return;}
      stamp(u);a.setAttribute('href',u.pathname+u.search+u.hash);
    });
  }
  function clearFacet(which){
    if(which==='size'){state.size=null;if(sizeRow)markActive(sizeRow,sizeRow.querySelector('[data-size-key="all"]'));}
    else if(which==='price'){state.price=null;if(priceRow)markActive(priceRow,priceRow.querySelector('[data-price-band="all"]'));}
    else if(which==='finish'){state.finish=null;if(finishRow)markActive(finishRow,finishRow.querySelector('[data-finish-key="all"]'));}
    apply();
  }
  function pill(label,onRemove,href){
    var el=document.createElement('span');el.className='shop-pill';
    el.appendChild(document.createTextNode(label+' '));
    var x=document.createElement('button');x.type='button';x.className='shop-pill-x';x.setAttribute('aria-label','Remove '+label);x.textContent='✕';
    x.addEventListener('click',function(){if(href){window.location.href=href;}else{onRemove();}});
    el.appendChild(x);return el;
  }
  function renderPills(){
    if(!pillsEl)return;
    pillsEl.innerHTML='';
    /* active server tag (collection width/shape/feature) — removal reloads to the bare collection (kept facets re-applied) */
    var tagLabel=pillsEl.getAttribute('data-tag-label'),tagClear=pillsEl.getAttribute('data-tag-clear');
    if(tagLabel&&tagClear){
      /* the tag-clear URL must DROP the size param too (the tag IS the width on collections) */
      var u;try{u=new URL(tagClear,window.location.origin);}catch(e){u=null;}
      var href=u?(function(){if(state.price&&state.price.band&&state.price.band!=='all')u.searchParams.set('price',state.price.band);if(state.finish)u.searchParams.set('finish',state.finish);return u.pathname+u.search+u.hash;})():tagClear;
      pillsEl.appendChild(pill(tagLabel,null,href));
    }
    if(state.size)pillsEl.appendChild(pill(sizeText(state.size),function(){clearFacet('size');}));
    if(state.price){var pc=priceRow&&priceRow.querySelector('[data-price-band="'+state.price.band+'"]');pillsEl.appendChild(pill(pc?chipLabel(pc):'Price',function(){clearFacet('price');}));}
    if(state.finish){var fc=finishRow&&finishRow.querySelector('[data-finish-key="'+state.finish+'"]');pillsEl.appendChild(pill(fc?chipLabel(fc):state.finish,function(){clearFacet('finish');}));}
    /* ≥2 client facets stacked → offer a one-tap in-place reset (server tag/sort still clear via their own
       reload-based "Clear all" in the summary bar). */
    var clientN=(state.size?1:0)+(state.price?1:0)+(state.finish?1:0);
    if(clientN>1){
      var ca=document.createElement('button');ca.type='button';ca.className='shop-pill shop-pill-clear';ca.textContent='Clear all';
      ca.addEventListener('click',clearAll);
      pillsEl.appendChild(ca);
    }
  }
  function bindRow(row,onPick){
    if(!row)return;
    var chips=row.querySelectorAll('a[href]');
    Array.prototype.forEach.call(chips,function(chip){
      chip.addEventListener('click',function(e){
        e.preventDefault();
        if(chip.getAttribute('aria-disabled')==='true')return;
        removeRestoreNote();
        /* checkbox behaviour: clicking an already-checked client facet unchecks it (selects the row's "all") */
        if(chip.classList.contains('active')){
          var w=chip.hasAttribute('data-size-key')?'size':chip.hasAttribute('data-price-band')?'price':chip.hasAttribute('data-finish-key')?'finish':null;
          var key=chip.getAttribute('data-size-key')||chip.getAttribute('data-price-band')||chip.getAttribute('data-finish-key');
          if(w&&key&&key!=='all'){clearFacet(w);return;}
        }
        markActive(row,chip);
        onPick(chip);apply();
      });
    });
  }
  function markActive(row,sel){
    var chips=row.querySelectorAll('a[href]');
    Array.prototype.forEach.call(chips,function(c){c.classList.remove('active');c.removeAttribute('aria-current');});
    if(sel){sel.classList.add('active');sel.setAttribute('aria-current','true');}
  }
  bindRow(sizeRow,function(chip){var k=chip.getAttribute('data-size-key');state.size=(k&&k!=='all')?k:null;});
  document.addEventListener('tac:vanity',function(){if(!fitChip)return;var lab=fitLabel();fitChip.firstChild&&fitChip.firstChild.nodeType===3?fitChip.firstChild.nodeValue=lab:fitChip.insertBefore(document.createTextNode(lab),fitChip.firstChild);if(state.size==='fit')apply();else updateChipCounts();});
  bindRow(priceRow,function(chip){
    if(chip.getAttribute('data-price-band')==='all'){state.price=null;return;}
    var mn=chip.getAttribute('data-price-min'),mx=chip.getAttribute('data-price-max');
    state.price={min:mn?parseInt(mn,10):null,max:mx?parseInt(mx,10):null,band:chip.getAttribute('data-price-band')};
  });
  bindRow(finishRow,function(chip){var k=chip.getAttribute('data-finish-key');state.finish=(k&&k!=='all')?k:null;});
  if(noMatchEl){var clearBtn=noMatchEl.querySelector('[data-clear-filters]');if(clearBtn)clearBtn.addEventListener('click',clearAll);}
  /* hydrate from URL so a width/shape/feature/sort reload restores the active facets */
  var params;try{params=new URLSearchParams(window.location.search);}catch(e){params=null;}
  if(params){
    var sz=params.get('size');
    if(sz&&sizeRow){var sc=sizeRow.querySelector('[data-size-key="'+sz+'"]');if(sc){markActive(sizeRow,sc);state.size=sz;}}
    var pb=params.get('price');
    if(pb&&priceRow){var pc2=priceRow.querySelector('[data-price-band="'+pb+'"]');if(pc2){markActive(priceRow,pc2);var mn=pc2.getAttribute('data-price-min'),mx=pc2.getAttribute('data-price-max');state.price={min:mn?parseInt(mn,10):null,max:mx?parseInt(mx,10):null,band:pb};}}
    var fk=params.get('finish');
    if(fk&&finishRow){var fc=finishRow.querySelector('[data-finish-key="'+fk+'"]');if(fc){markActive(finishRow,fc);state.finish=fk;}}
  }
  /* no facets in the URL → restore the session's last refine for this collection (guarded by chip presence) */
  if(!any()&&params&&!params.get('size')&&!params.get('price')&&!params.get('finish')){
    var saved;try{saved=JSON.parse(localStorage.getItem(STORE)||'null');}catch(e){saved=null;}
    if(saved&&saved.t&&(Date.now()-saved.t>STORE_TTL)){try{localStorage.removeItem(STORE);}catch(_){}saved=null;}
    if(saved&&saved.p===basePath()){
      if(saved.size&&sizeRow){var rsc=sizeRow.querySelector('[data-size-key="'+saved.size+'"]');if(rsc){markActive(sizeRow,rsc);state.size=saved.size;}}
      if(saved.price&&priceRow){var rpc=priceRow.querySelector('[data-price-band="'+saved.price+'"]');if(rpc){markActive(priceRow,rpc);var rmn=rpc.getAttribute('data-price-min'),rmx=rpc.getAttribute('data-price-max');state.price={min:rmn?parseInt(rmn,10):null,max:rmx?parseInt(rmx,10):null,band:saved.price};}}
      if(saved.finish&&finishRow){var rfc=finishRow.querySelector('[data-finish-key="'+saved.finish+'"]');if(rfc){markActive(finishRow,rfc);state.finish=saved.finish;}}
      if(any())didRestore=true;
    }
  }
  if(any()){apply();showRestoreNote();}else{decorateLinks();renderPills();updateRefineBadge();updateChipCounts();}
});

/* ===== POLICY PAGE — auto table of contents + scroll-spy =====
   Builds the "On this page" list from the H2–H4 headings in #policyBody (the rich-text
   legal body, whose structure the merchant controls in admin), so the TOC is correct no
   matter how the page is written. Own handler + early returns so it never traps other JS;
   leaves the nav hidden when there's nothing worth linking. */
document.addEventListener('DOMContentLoaded',function(){
  var toc=document.getElementById('policyToc');if(!toc)return;
  var body=document.getElementById('policyBody');if(!body)return;
  var ul=toc.querySelector('ul');if(!ul)return;

  /* Skip the company/address sign-off heading (e.g. "Tacovici Manufacturing Inc") — it's a
     footer, not a section. Matches the company-name setting, ignoring trailing punctuation. */
  function tocnorm(s){return (s||'').replace(/\s+/g,' ').trim().replace(/[.\s]+$/,'').toLowerCase();}
  var excl=tocnorm(toc.getAttribute('data-toc-exclude'));
  var nodes=body.querySelectorAll('h2,h3,h4'),heads=[];
  Array.prototype.forEach.call(nodes,function(h){
    var t=(h.textContent||'').replace(/\s+/g,' ').trim();
    if(!t)return;
    if(excl&&tocnorm(t)===excl)return;
    heads.push(h);
  });
  if(heads.length<2)return; /* a one-item TOC is just noise */

  /* Normalise depth: the shallowest heading present becomes the top level, so an h4-only
     page (Shipping/Warranty) isn't rendered as all-indented sub-items. */
  var minLvl=9;
  heads.forEach(function(h){var l=parseInt(h.tagName.charAt(1),10);if(l<minLvl)minLvl=l;});

  var used={};
  function slug(t){
    var s=t.toLowerCase().replace(/[^\w]+/g,'-').replace(/^-+|-+$/g,'')||'section';
    var base=s,n=2;while(used[s]){s=base+'-'+n;n++;}used[s]=1;return s;
  }

  var frag=document.createDocumentFragment(),links=[];
  heads.forEach(function(h){
    var text=h.textContent.replace(/\s+/g,' ').trim();
    var id=h.id||slug(text);if(!h.id)h.id=id;
    var li=document.createElement('li');
    var a=document.createElement('a');
    a.href='#'+id;
    a.textContent=text;
    a.className=(parseInt(h.tagName.charAt(1),10)===minLvl)?'lvl-2':'lvl-3';
    li.appendChild(a);frag.appendChild(li);
    links.push({a:a,h:h});
  });
  ul.appendChild(frag);
  toc.hidden=false;

  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  toc.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('a');if(!a)return;
    var t=document.getElementById(decodeURIComponent((a.getAttribute('href')||'').slice(1)));
    if(!t)return;
    e.preventDefault();
    t.scrollIntoView({behavior:reduce?'auto':'smooth',block:'start'});
    if(history.replaceState)history.replaceState(null,'','#'+t.id);else window.location.hash=t.id;
  });

  /* Scroll-spy: highlight the link for the heading nearest the top of the viewport. */
  if('IntersectionObserver' in window){
    function setActive(id){
      links.forEach(function(l){l.a.classList.toggle('is-active',l.h.id===id);});
    }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){if(en.isIntersecting)setActive(en.target.id);});
    },{rootMargin:'-82px 0px -68% 0px',threshold:0});
    links.forEach(function(l){io.observe(l.h);});
  }
});

/* ---- Browse-time fit badge (uses the remembered vanity width) ----
   When the shopper has told us their vanity width on a PDP (the buy-box fit check, the vanity calculator,
   or the ask-an-expert field all write sessionStorage.tacVanityW), flag on each product card whether it
   offers a well-proportioned size for that wall. Reads the pipe-wrapped widths already on .card[data-sizes]
   (parsed from each product's size:<N>-inch tags). The badge is non-interactive so it sits safely under
   .card-link. Runs on load AND on the 'tac:vanity' event (dispatched by tacFit.setVanityProp) so in-DOM
   cards — e.g. the PDP related-products grid — re-stamp the moment a width is entered, no reload needed. */
function tacApplyCardFit(){
  var v=tacReadVanityW();
  var cards=document.querySelectorAll('.card[data-sizes]');if(!cards.length)return;
  function widths(ds){var a=(ds||'').split('|'),o=[],i,k;for(i=0;i<a.length;i++){k=parseFloat(a[i]);if(k>=8&&k<=160)o.push(k);}return o;}
  for(var i=0;i<cards.length;i++){
    var card=cards[i],body=card.querySelector('.body');if(!body)continue;
    var old=card.querySelector('.card-fit');if(old)old.parentNode.removeChild(old);   /* refresh so a changed width re-stamps */
    if(!(v>0))continue;
    var ws=widths(card.getAttribute('data-sizes'));if(!ws.length)continue;
    var fits=false,minW=Infinity,j,w,side;
    for(j=0;j<ws.length;j++){w=ws[j];if(w<minW)minW=w;side=(v-w)/2;if(side>=1.5&&side<=10)fits=true;}
    var cls,ic,txt,yours=tacVanityPhrase();   /* a quiz guess / stale width isn't "yours" */
    if(fits){cls='card-fit--yes';ic='✓';txt='Fits '+yours+v+'″ vanity';}
    else if(minW>v-1){cls='card-fit--warn';ic='↓';txt='Runs large for '+v+'″';}
    else{cls='card-fit--warn';ic='↑';txt='Wider suits '+yours+v+'″ vanity';}
    var el=document.createElement('span');el.className='card-fit '+cls;
    el.innerHTML='<span class="card-fit-ic" aria-hidden="true">'+ic+'</span>'+txt;
    body.insertBefore(el,body.firstChild);
  }
}
document.addEventListener('DOMContentLoaded',tacApplyCardFit);
document.addEventListener('tac:vanity',tacApplyCardFit);

/* ---- Item-code hand-off — a PDP "Ask about this item" / "Arrives protected" link carries ?item=<code>
   (the SKU minus its JT prefix, snippets/sku-code). Fill it into whichever support form the shopper
   landed on so they never retype it and every message names an exact variant. Guarded three ways: no
   contact/claim form, no ?item=, or a posted-successfully form (no fields) → no work. The value is
   sanitised to the code charset before it touches the DOM. ---- */
document.addEventListener('DOMContentLoaded',function(){
  var host=document.getElementById('contactForm')||document.getElementById('claimForm');if(!host)return;
  var raw='';try{raw=new URLSearchParams(location.search).get('item')||'';}catch(_){}
  var code=raw.trim().replace(/[^A-Za-z0-9._\/-]/g,'').slice(0,32);if(!code)return;
  var f=host.querySelector('form');if(!f)return;
  /* a dedicated field (claim form) keeps the code as its own line in the email; otherwise open the
     message with it so it still reaches us on the general contact form */
  var fld=f.querySelector('input[name="contact[Item code]"]');
  if(fld){if(!fld.value)fld.value=code;fld.disabled=false;}
  /* Say it on screen too. The seeded message text is the shopper's to overwrite — and they usually do —
     so the visible line + the hidden field are what actually guarantee the code reaches us. */
  var ctx=document.getElementById('contactItemCtx'),ctxV=document.getElementById('contactItemCode');
  if(ctx&&ctxV){ctxV.textContent=code;ctx.hidden=false;}
  /* Last-resort seeding only: with a dedicated field OR the visible line present, the code already reaches
     us, and pre-filling the claim form's "describe the damage" box would just be noise to delete. */
  var body=f.querySelector('textarea[name="contact[body]"]');
  if(body&&!body.value&&!fld&&!ctx)body.value='About item # '+code+'\n\n';
  /* a question that arrives from a product page is a product question — preselect that topic when the
     form offers one (matched on the option TEXT so re-labelling the options can't silently break it) */
  var topic=f.querySelector('select[name="contact[topic]"]');
  if(topic)for(var i=0;i<topic.options.length;i++){if(/product/i.test(topic.options[i].text)){topic.selectedIndex=i;break;}}
  /* &u=<handle> → a clickable product URL alongside the code, so support never has to look the listing
     up. Handle-shaped values only; the field stays disabled (submits nothing) unless we fill it. */
  var uh='';try{uh=new URLSearchParams(location.search).get('u')||'';}catch(_){}
  uh=uh.trim().toLowerCase();
  var pf=f.querySelector('input[name="contact[Product]"]');
  /* 255, not 80: this catalogue's SEO handles are long — the 20x32 mirror's is 83 chars
     ("front-lighted-black-framed-led-bathroom-vanity-mirror-defogger-rounded-wall-mounted"), so an
     80-char cap silently dropped the product link on real products. Shopify handles max out at 255. */
  if(pf&&/^[a-z0-9][a-z0-9-]{0,254}$/.test(uh)){pf.value=location.origin+'/products/'+uh;pf.disabled=false;}
});
